[
 {
  "id": "Build",
  "name": "Build",
  "title": "Строить",
  "photo": "/hp/catalog/tree/3028e7ec5c56.webp",
  "children": [
   {
    "id": "Build/Windows and Doors",
    "name": "Windows and Doors",
    "title": "Окна и двери",
    "photo": "/hp/catalog/tree/cbc7ed089ab0.webp",
    "children": [
     {
      "id": "Build/Windows and Doors/Doors",
      "name": "Doors",
      "title": "Двери",
      "photo": "/hp/catalog/tree/cbc7ed089ab0.webp",
      "anyTags": [
       "Door",
       "WallDoor",
       "ArchDoor"
      ],
      "allTags": [],
      "filters": [
       {
        "id": "Single Doors",
        "title": "Одиночные двери",
        "anyTags": [],
        "allTags": [
         "Single"
        ]
       },
       {
        "id": "Double Doors",
        "title": "Двойные двери",
        "anyTags": [],
        "allTags": [
         "Double"
        ]
       },
       {
        "id": "Arch Doors",
        "title": "Арочные двери",
        "anyTags": [],
        "allTags": [
         "ArchDoor"
        ]
       },
       {
        "id": "Entry Doors",
        "title": "Входные двери",
        "anyTags": [],
        "allTags": [
         "Entry"
        ]
       },
       {
        "id": "Entrance set",
        "title": "Входной набор",
        "anyTags": [],
        "allTags": [
         "Entrance"
        ]
       },
       {
        "id": "Sliding Doors",
        "title": "Раздвижные двери",
        "anyTags": [],
        "allTags": [
         "Sliding"
        ]
       },
       {
        "id": "Folding Doors",
        "title": "Складные двери",
        "anyTags": [],
        "allTags": [
         "Folding"
        ]
       },
       {
        "id": "Balcony Doors",
        "title": "Балконные двери",
        "anyTags": [],
        "allTags": [
         "BalconyDoor"
        ]
       },
       {
        "id": "Special Doors",
        "title": "Специальные двери",
        "anyTags": [],
        "allTags": [
         "SpecialDoor"
        ]
       }
      ]
     },
     {
      "id": "Build/Windows and Doors/Windows",
      "name": "Windows",
      "title": "Окна",
      "photo": "/hp/catalog/tree/9c2bf90d424b.webp",
      "anyTags": [],
      "allTags": [
       "Window"
      ]
     },
     {
      "id": "Build/Windows and Doors/Arches",
      "name": "Arches",
      "title": "Арки",
      "photo": "/hp/catalog/tree/7345c4317e3b.webp",
      "anyTags": [],
      "allTags": [
       "Arch"
      ]
     },
     {
      "id": "Build/Windows and Doors/CeilingCurtains",
      "name": "CeilingCurtains",
      "title": "Потолочные шторы",
      "photo": "/hp/catalog/tree/127483acf83e.webp",
      "anyTags": [],
      "allTags": [
       "CurtainsCeiling"
      ]
     },
     {
      "id": "Build/Windows and Doors/Curtains",
      "name": "Curtains",
      "title": "Шторы",
      "photo": "/hp/catalog/tree/071a573a2d16.webp",
      "anyTags": [
       "Curtains",
       "CurtainsWall"
      ],
      "allTags": []
     },
     {
      "id": "Build/Windows and Doors/Openings",
      "name": "Openings",
      "title": "Проёмы",
      "photo": "/hp/catalog/tree/0072eebf6271.webp",
      "anyTags": [],
      "allTags": [
       "Gap"
      ]
     },
     {
      "id": "Build/Windows and Doors/Garage Doors",
      "name": "Garage Doors",
      "title": "Гаражные ворота",
      "photo": "/hp/catalog/tree/a15893fd08eb.webp",
      "anyTags": [],
      "allTags": [
       "GarageDoor"
      ]
     },
     {
      "id": "Build/Windows and Doors/Skylight",
      "name": "Skylight",
      "title": "Мансардное окно",
      "photo": "/hp/catalog/tree/853d656b63c8.webp",
      "anyTags": [
       "Skylight",
       "SkylightRoof"
      ],
      "allTags": []
     },
     {
      "id": "Build/Windows and Doors/Shutters",
      "name": "Shutters",
      "title": "Ставни",
      "photo": "/hp/catalog/tree/75e20575b369.webp",
      "anyTags": [],
      "allTags": [
       "Shutter"
      ]
     },
     {
      "id": "Build/Windows and Doors/Window sills",
      "name": "Window sills",
      "title": "Подоконники",
      "photo": "/hp/catalog/tree/1101c7e00a7a.webp",
      "anyTags": [],
      "allTags": [
       "WindowSill"
      ]
     },
     {
      "id": "Build/Windows and Doors/Elevator",
      "name": "Elevator",
      "title": "Лифт",
      "photo": "/hp/catalog/tree/2f93c48fa35a.webp",
      "anyTags": [],
      "allTags": [
       "Elevator"
      ]
     }
    ]
   },
   {
    "id": "Build/Constructions",
    "name": "Constructions",
    "title": "Конструкции",
    "photo": "/hp/catalog/tree/496b69ac30e3.webp",
    "children": [
     {
      "id": "Build/Constructions/Primitives",
      "name": "Primitives",
      "title": "Примитивы",
      "photo": "/hp/catalog/tree/496b69ac30e3.webp",
      "anyTags": [],
      "allTags": [
       "Primitives"
      ]
     },
     {
      "id": "Build/Constructions/Interior Wall",
      "name": "Interior Wall",
      "title": "Стена",
      "photo": "/hp/catalog/tree/86df4b45932b.webp",
      "anyTags": [
       "InteriorWall",
       "RoomObjects",
       "Universal"
      ],
      "allTags": []
     },
     {
      "id": "Build/Constructions/CeilingDecor",
      "name": "CeilingDecor",
      "title": "Потолочные конструкции",
      "photo": "/hp/catalog/tree/0a4ceaf44974.webp",
      "anyTags": [
       "CeilingConstructions",
       "CeilingBeams"
      ],
      "allTags": []
     },
     {
      "id": "Build/Constructions/Wall constructions",
      "name": "Wall constructions",
      "title": "Стеновые конструкции",
      "photo": "/hp/catalog/tree/969ae91d336a.webp",
      "anyTags": [],
      "allTags": [
       "WallPanel"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Build/Constructions/Moldings",
      "name": "Moldings",
      "title": "Молдинги",
      "photo": "/hp/catalog/tree/ae2ca04c00aa.webp",
      "anyTags": [
       "Molding",
       "Moldings"
      ],
      "allTags": []
     },
     {
      "id": "Build/Constructions/Columns",
      "name": "Columns",
      "title": "Колонны",
      "photo": "/hp/catalog/tree/43cf89b9b516.webp",
      "anyTags": [],
      "allTags": [
       "Column"
      ]
     },
     {
      "id": "Build/Constructions/Stucco",
      "name": "Stucco",
      "title": "Лепнина",
      "photo": "/hp/catalog/tree/8472c7dafe29.webp",
      "anyTags": [
       "Stucco",
       "Stucco3D"
      ],
      "allTags": [],
      "sort": "PriceHigh"
     },
     {
      "id": "Build/Constructions/Pipes",
      "name": "Pipes",
      "title": "Трубы",
      "photo": "/hp/catalog/tree/6143f51b3925.webp",
      "anyTags": [
       "WallPipe",
       "Pipe"
      ],
      "allTags": []
     }
    ]
   },
   {
    "id": "Build/Materials",
    "name": "Materials",
    "title": "Материалы",
    "photo": "/hp/catalog/tree/906bc58185c9.webp",
    "children": [
     {
      "id": "Build/Materials/Other",
      "name": "Other",
      "title": "Другой",
      "photo": "/hp/catalog/tree/906bc58185c9.webp",
      "anyTags": [],
      "allTags": [
       "MaterialOther"
      ]
     },
     {
      "id": "Build/Materials/Wood",
      "name": "Wood",
      "title": "Дерево",
      "photo": "/hp/catalog/tree/41e845031787.webp",
      "anyTags": [],
      "allTags": [
       "MaterialWood"
      ]
     },
     {
      "id": "Build/Materials/Marble",
      "name": "Marble",
      "title": "Мрамор",
      "photo": "/hp/catalog/tree/39dfcf655bc0.webp",
      "anyTags": [],
      "allTags": [
       "MaterialMarble"
      ]
     },
     {
      "id": "Build/Materials/Tile",
      "name": "Tile",
      "title": "Плитка",
      "photo": "/hp/catalog/tree/e1897b268100.webp",
      "anyTags": [],
      "allTags": [
       "MaterialTile"
      ]
     },
     {
      "id": "Build/Materials/Slats",
      "name": "Slats",
      "title": "Ламели",
      "photo": "/hp/catalog/tree/d352584b5c5b.webp",
      "anyTags": [],
      "allTags": [
       "MaterialSlats"
      ]
     },
     {
      "id": "Build/Materials/Fabric",
      "name": "Fabric",
      "title": "Ткань",
      "photo": "/hp/catalog/tree/58df101a71cf.webp",
      "anyTags": [],
      "allTags": [
       "MaterialFabric"
      ]
     },
     {
      "id": "Build/Materials/Wallpapers",
      "name": "Wallpapers",
      "title": "Обои",
      "photo": "/hp/catalog/tree/dcaac6bf0405.webp",
      "anyTags": [],
      "allTags": [
       "MaterialWallpaper"
      ]
     },
     {
      "id": "Build/Materials/Finishes",
      "name": "Finishes",
      "title": "Отделка",
      "photo": "/hp/catalog/tree/604e8f8bc89b.webp",
      "anyTags": [],
      "allTags": [
       "MaterialFinishes"
      ]
     },
     {
      "id": "Build/Materials/Paneling",
      "name": "Paneling",
      "title": "Панели",
      "photo": "/hp/catalog/tree/3030edb035db.webp",
      "anyTags": [],
      "allTags": [
       "MaterialMoldings"
      ]
     },
     {
      "id": "Build/Materials/Parquet or Laminate",
      "name": "Parquet or Laminate",
      "title": "Паркет, ламинат",
      "photo": "/hp/catalog/tree/dc19cad4d593.webp",
      "anyTags": [],
      "allTags": [
       "MaterialParquetOrLaminate"
      ]
     },
     {
      "id": "Build/Materials/Glass",
      "name": "Glass",
      "title": "Стекло",
      "photo": "/hp/catalog/tree/7e8b217cd804.webp",
      "anyTags": [],
      "allTags": [
       "MaterialGlass"
      ]
     },
     {
      "id": "Build/Materials/Stone",
      "name": "Stone",
      "title": "Камень",
      "photo": "/hp/catalog/tree/ce8971d7501e.webp",
      "anyTags": [],
      "allTags": [
       "MaterialStone"
      ]
     },
     {
      "id": "Build/Materials/Bricks",
      "name": "Bricks",
      "title": "Кирпичи",
      "photo": "/hp/catalog/tree/cfbb39e9bae2.webp",
      "anyTags": [],
      "allTags": [
       "MaterialBricks"
      ]
     },
     {
      "id": "Build/Materials/Carpet",
      "name": "Carpet",
      "title": "Ковролин",
      "photo": "/hp/catalog/tree/ad2f48a1f3d2.webp",
      "anyTags": [],
      "allTags": [
       "MaterialCarpet"
      ]
     },
     {
      "id": "Build/Materials/MaterialPlants",
      "name": "MaterialPlants",
      "title": "Растения",
      "photo": "/hp/catalog/tree/4517416a1b1e.webp",
      "anyTags": [],
      "allTags": [
       "MaterialLawn"
      ]
     },
     {
      "id": "Build/Materials/Metal",
      "name": "Metal",
      "title": "Металл",
      "photo": "/hp/catalog/tree/d71e88b81a79.webp",
      "anyTags": [],
      "allTags": [
       "MaterialMetal"
      ]
     },
     {
      "id": "Build/Materials/Photo Wallpaper",
      "name": "Photo Wallpaper",
      "title": "Фотообои",
      "photo": "/hp/catalog/tree/d1766a0c12c3.webp",
      "anyTags": [],
      "allTags": [
       "MaterialPhotoWallpaper"
      ]
     },
     {
      "id": "Build/Materials/Ground",
      "name": "Ground",
      "title": "Земля",
      "photo": "/hp/catalog/tree/813ee8c6aa7b.webp",
      "anyTags": [],
      "allTags": [
       "MaterialGround"
      ]
     },
     {
      "id": "Build/Materials/Granite",
      "name": "Granite",
      "title": "Гранит",
      "photo": "/hp/catalog/tree/ec3d46c92e6a.webp",
      "anyTags": [],
      "allTags": [
       "MaterialGranite"
      ]
     },
     {
      "id": "Build/Materials/Neon",
      "name": "Neon",
      "title": "Неон",
      "photo": "/hp/catalog/tree/958899333da9.webp",
      "anyTags": [],
      "allTags": [
       "MaterialNeon"
      ]
     },
     {
      "id": "Build/Materials/Water",
      "name": "Water",
      "title": "Вода",
      "photo": "/hp/catalog/tree/7fbcbbe744f2.webp",
      "anyTags": [],
      "allTags": [
       "MaterialWater"
      ]
     },
     {
      "id": "Build/Materials/Sky",
      "name": "Sky",
      "title": "Небо",
      "photo": "/hp/catalog/tree/5c1e52e8cdd2.webp",
      "anyTags": [],
      "allTags": [
       "MaterialSky"
      ]
     },
     {
      "id": "Build/Materials/Rattan",
      "name": "Rattan",
      "title": "Ротанг",
      "photo": "/hp/catalog/tree/0dcca90da1ee.webp",
      "anyTags": [],
      "allTags": [
       "MaterialRattan"
      ]
     },
     {
      "id": "Build/Materials/Leather",
      "name": "Leather",
      "title": "Кожа",
      "photo": "/hp/catalog/tree/8909d00d6111.webp",
      "anyTags": [],
      "allTags": [
       "MaterialLeather"
      ]
     },
     {
      "id": "Build/Materials/Roof",
      "name": "Roof",
      "title": "Крыша",
      "photo": "/hp/catalog/tree/0e1100b68874.webp",
      "anyTags": [],
      "allTags": [
       "MaterialRoof"
      ]
     },
     {
      "id": "Build/Materials/Colors",
      "name": "Colors",
      "title": "Цвета",
      "photo": "/hp/catalog/tree/63af85b52ae9.webp",
      "anyTags": [],
      "allTags": [
       "MaterialRalPaint"
      ]
     }
    ]
   },
   {
    "id": "Build/Stairs",
    "name": "Stairs",
    "title": "Лестница",
    "photo": "/hp/catalog/tree/07365846a537.webp",
    "anyTags": [
     "Stairs",
     "StairsOpening",
     "StairsOpeningRound",
     "WallRail"
    ],
    "allTags": [],
    "filters": [
     {
      "id": "Steps",
      "title": "Ступени",
      "anyTags": [],
      "allTags": [
       "Steps"
      ]
     },
     {
      "id": "Straight Stairs",
      "title": "Прямая лестница",
      "anyTags": [],
      "allTags": [
       "StraightStairs"
      ]
     },
     {
      "id": "L-shape Stairs",
      "title": "Г-образная лестница",
      "anyTags": [],
      "allTags": [
       "CornerStairs"
      ]
     },
     {
      "id": "U-shape Stairs",
      "title": "П-образная лестница",
      "anyTags": [],
      "allTags": [
       "UshapeStairs"
      ]
     },
     {
      "id": "Spiral Stairs",
      "title": "Винтовая лестница",
      "anyTags": [],
      "allTags": [
       "RoundStairs"
      ]
     },
     {
      "id": "Curved Stairs",
      "title": "Изогнутая лестница",
      "anyTags": [],
      "allTags": [
       "CurvedStairs"
      ]
     },
     {
      "id": "Winder Stairs",
      "title": "Забежная лестница",
      "anyTags": [],
      "allTags": [
       "WinderStairs"
      ]
     },
     {
      "id": "Grand Staircase",
      "title": "Парадная лестница",
      "anyTags": [],
      "allTags": [
       "GrandStaircase"
      ]
     },
     {
      "id": "Ladder",
      "title": "Ladder",
      "anyTags": [],
      "allTags": [
       "Ladder"
      ]
     },
     {
      "id": "Task Stairs",
      "title": "Специальная лестница",
      "anyTags": [],
      "allTags": [
       "TaskStairs"
      ]
     },
     {
      "id": "Railing",
      "title": "Перила",
      "anyTags": [],
      "allTags": [
       "WallRail"
      ]
     }
    ]
   },
   {
    "id": "Build/Climate electronics",
    "name": "Climate electronics",
    "title": "Климатическая электроника",
    "photo": "/hp/catalog/tree/8cbd84da7b49.webp",
    "children": [
     {
      "id": "Build/Climate electronics/Conditioner",
      "name": "Conditioner",
      "title": "Кондиционер",
      "photo": "/hp/catalog/tree/8cbd84da7b49.webp",
      "anyTags": [],
      "allTags": [
       "Conditioner"
      ]
     },
     {
      "id": "Build/Climate electronics/Ceiling fan",
      "name": "Ceiling fan",
      "title": "Потолочный вентилятор",
      "photo": "/hp/catalog/tree/d47213ab3176.webp",
      "anyTags": [],
      "allTags": [
       "CeilingFan"
      ]
     },
     {
      "id": "Build/Climate electronics/Heating",
      "name": "Heating",
      "title": "Отопление",
      "photo": "/hp/catalog/tree/a3ffca9715f3.webp",
      "anyTags": [],
      "allTags": [
       "Heating"
      ]
     },
     {
      "id": "Build/Climate electronics/Ventilation",
      "name": "Ventilation",
      "title": "Вентиляция",
      "photo": "/hp/catalog/tree/0cf9af13b38e.webp",
      "anyTags": [],
      "allTags": [
       "AirVent"
      ]
     },
     {
      "id": "Build/Climate electronics/Fan",
      "name": "Fan",
      "title": "Вентилятор",
      "photo": "/hp/catalog/tree/536dc03ad328.webp",
      "anyTags": [],
      "allTags": [
       "Fan"
      ]
     },
     {
      "id": "Build/Climate electronics/Air purifier",
      "name": "Air purifier",
      "title": "Очиститель воздуха",
      "photo": "/hp/catalog/tree/42b025ea0290.webp",
      "anyTags": [],
      "allTags": [
       "Purifier"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Build/Climate electronics/Water heater",
      "name": "Water heater",
      "title": "Бойлер",
      "photo": "/hp/catalog/tree/60828117711f.webp",
      "anyTags": [],
      "allTags": [
       "WaterHeater"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Build/Climate electronics/Thermometer",
      "name": "Thermometer",
      "title": "Термометр",
      "photo": "/hp/catalog/tree/abb8d6dcd07e.webp",
      "anyTags": [],
      "allTags": [
       "Thermometer"
      ],
      "sort": "PriceHigh"
     }
    ]
   },
   {
    "id": "Build/Electricity",
    "name": "Electricity",
    "title": "Электричество",
    "photo": "/hp/catalog/tree/14726b082fca.webp",
    "children": [
     {
      "id": "Build/Electricity/LightingOutletsSwitches",
      "name": "LightingOutletsSwitches",
      "title": "Розетки, выключатели",
      "photo": "/hp/catalog/tree/14726b082fca.webp",
      "anyTags": [],
      "allTags": [
       "WiringDevices"
      ]
     },
     {
      "id": "Build/Electricity/Electricity supplies",
      "name": "Electricity supplies",
      "title": "Электроприборы",
      "photo": "/hp/catalog/tree/38775ad0ae50.webp",
      "anyTags": [],
      "allTags": [
       "Electric"
      ]
     }
    ]
   },
   {
    "id": "Build/Fireplaces",
    "name": "Fireplaces",
    "title": "Камин",
    "photo": "/hp/catalog/tree/dba42e206ba4.webp",
    "anyTags": [],
    "allTags": [
     "Fireplace"
    ],
    "filters": [
     {
      "id": "Traditional Fireplace",
      "title": "Traditional Fireplace",
      "anyTags": [],
      "allTags": [
       "ClassicFireplace"
      ]
     },
     {
      "id": "Modern Fireplace",
      "title": "Modern Fireplace",
      "anyTags": [],
      "allTags": [
       "ModernFireplace"
      ]
     },
     {
      "id": "Stove Fireplace",
      "title": "Stove Fireplace",
      "anyTags": [],
      "allTags": [
       "MetalFireplace"
      ]
     },
     {
      "id": "Freestanding Fireplace",
      "title": "Отдельностоящий камин",
      "anyTags": [],
      "allTags": [
       "FreestandingFireplace"
      ]
     },
     {
      "id": "Suspended Fireplace",
      "title": "Подвесной камин",
      "anyTags": [],
      "allTags": [
       "SuspendedFireplace"
      ]
     },
     {
      "id": "Fireplace Accessories",
      "title": "Каминные аксессуары",
      "anyTags": [],
      "allTags": [
       "FireplaceDecor"
      ]
     }
    ]
   },
   {
    "id": "Build/Roofs",
    "name": "Roofs",
    "title": "Крыши",
    "photo": "/hp/catalog/tree/adda2a7e65a4.webp",
    "children": [
     {
      "id": "Build/Roofs/Roof types",
      "name": "Roof types",
      "title": "Типы крыш",
      "photo": "/hp/catalog/tree/2882c2bd3668.webp",
      "anyTags": [],
      "allTags": [
       "Roofs"
      ]
     },
     {
      "id": "Build/Roofs/Dormer window",
      "name": "Dormer window",
      "title": "Чердачное окно",
      "photo": "/hp/catalog/tree/76708ac93c42.webp",
      "anyTags": [],
      "allTags": [
       "DormerWindow"
      ]
     },
     {
      "id": "Build/Roofs/Chimney",
      "name": "Chimney",
      "title": "Дымоход",
      "photo": "/hp/catalog/tree/5a31de2c6f26.webp",
      "anyTags": [],
      "allTags": [
       "Chimney"
      ]
     },
     {
      "id": "Build/Roofs/Gutter",
      "name": "Gutter",
      "title": "Ливневка",
      "photo": "/hp/catalog/tree/c36d8f543e3f.webp",
      "anyTags": [],
      "allTags": [
       "Gutter"
      ]
     }
    ]
   },
   {
    "id": "Build/Knobs,handles",
    "name": "Knobs,handles",
    "title": "Ручки",
    "photo": "/hp/catalog/tree/2c48c3265c0a.webp",
    "anyTags": [],
    "allTags": [
     "Knob"
    ]
   }
  ]
 },
 {
  "id": "Other Rooms",
  "name": "Other Rooms",
  "title": "По типу комнаты",
  "photo": "/hp/catalog/tree/e71e83110f75.webp",
  "children": [
   {
    "id": "Other Rooms/kids",
    "name": "kids",
    "title": "Детская",
    "photo": "/hp/catalog/tree/938f61a3fddc.webp",
    "children": [
     {
      "id": "Other Rooms/kids/KidBed",
      "name": "KidBed",
      "title": "Детская кровать",
      "photo": "/hp/catalog/tree/938f61a3fddc.webp",
      "anyTags": [],
      "allTags": [
       "JuniorBed"
      ]
     },
     {
      "id": "Other Rooms/kids/Kids Storage",
      "name": "Kids Storage",
      "title": "Детские шкафы",
      "photo": "/hp/catalog/tree/8ec7f0ddf28c.webp",
      "anyTags": [],
      "allTags": [
       "KidsStorage"
      ]
     },
     {
      "id": "Other Rooms/kids/Baby Gear",
      "name": "Baby Gear",
      "title": "Вещи для малышей",
      "photo": "/hp/catalog/tree/c0de1e12676c.webp",
      "children": [
       {
        "id": "Other Rooms/kids/Baby Gear/Kids Decor",
        "name": "Kids Decor",
        "title": "Детский декор",
        "photo": "/hp/catalog/tree/f1b889102b5a.webp",
        "children": [
         {
          "id": "Other Rooms/kids/Baby Gear/Kids Decor/Toys",
          "name": "Toys",
          "title": "Игрушки",
          "photo": "/hp/catalog/tree/f1b889102b5a.webp",
          "anyTags": [],
          "allTags": [
           "Toys"
          ]
         },
         {
          "id": "Other Rooms/kids/Baby Gear/Kids Decor/KidsDecor",
          "name": "KidsDecor",
          "title": "Детский декор",
          "photo": "/hp/catalog/tree/5656699ca4d9.webp",
          "anyTags": [],
          "allTags": [
           "KidsDecor"
          ]
         },
         {
          "id": "Other Rooms/kids/Baby Gear/Kids Decor/Kids Art",
          "name": "Kids Art",
          "title": "Детские картины",
          "photo": "/hp/catalog/tree/ae5f6fcef706.webp",
          "anyTags": [],
          "allTags": [
           "KidsArt"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Other Rooms/kids/Baby Gear/Kids Decor/Kids Rugs",
          "name": "Kids Rugs",
          "title": "Детские коврики",
          "photo": "/hp/catalog/tree/9ffd7938c423.webp",
          "anyTags": [],
          "allTags": [
           "KidsRug"
          ]
         },
         {
          "id": "Other Rooms/kids/Baby Gear/Kids Decor/Play Tents",
          "name": "Play Tents",
          "title": "Игровые палатки",
          "photo": "/hp/catalog/tree/70b00b724575.webp",
          "anyTags": [],
          "allTags": [
           "PlayTents"
          ]
         }
        ]
       },
       {
        "id": "Other Rooms/kids/Baby Gear/Crib",
        "name": "Crib",
        "title": "Кроватка",
        "photo": "/hp/catalog/tree/9c8e04247383.webp",
        "anyTags": [],
        "allTags": [
         "Crib"
        ]
       },
       {
        "id": "Other Rooms/kids/Baby Gear/Kid Lamp",
        "name": "Kid Lamp",
        "title": "Детский светильник",
        "photo": "/hp/catalog/tree/253838e7ae39.webp",
        "anyTags": [],
        "allTags": [
         "KidLamp"
        ]
       },
       {
        "id": "Other Rooms/kids/Baby Gear/Bed Canopy",
        "name": "Bed Canopy",
        "title": "Балдахин",
        "photo": "/hp/catalog/tree/2062146d202b.webp",
        "anyTags": [],
        "allTags": [
         "BedCanopy"
        ]
       },
       {
        "id": "Other Rooms/kids/Baby Gear/High Chair",
        "name": "High Chair",
        "title": "Высокий стул",
        "photo": "/hp/catalog/tree/9e6ff76ab316.webp",
        "anyTags": [],
        "allTags": [
         "HighChair"
        ]
       },
       {
        "id": "Other Rooms/kids/Baby Gear/Play Tents",
        "name": "Play Tents",
        "title": "Игровые палатки",
        "photo": "/hp/catalog/tree/70b00b724575.webp",
        "anyTags": [],
        "allTags": [
         "PlayTents"
        ]
       },
       {
        "id": "Other Rooms/kids/Baby Gear/Changing Table",
        "name": "Changing Table",
        "title": "Пеленальный стол",
        "photo": "/hp/catalog/tree/50f7af035cda.webp",
        "anyTags": [],
        "allTags": [
         "Changer"
        ]
       }
      ]
     },
     {
      "id": "Other Rooms/kids/Kid Lamp",
      "name": "Kid Lamp",
      "title": "Детский светильник",
      "photo": "/hp/catalog/tree/253838e7ae39.webp",
      "anyTags": [],
      "allTags": [
       "KidLamp"
      ]
     },
     {
      "id": "Other Rooms/kids/Kids tables and chairs",
      "name": "Kids tables and chairs",
      "title": "Детские столы и стулья",
      "photo": "/hp/catalog/tree/5aa372ff175e.webp",
      "anyTags": [
       "KidChair",
       "KidTable",
       "KidsSet"
      ],
      "allTags": []
     }
    ]
   },
   {
    "id": "Other Rooms/Laundry and cleaning",
    "name": "Laundry and cleaning",
    "title": "Стирка и уборка",
    "photo": "/hp/catalog/tree/7713c65c38b2.webp",
    "children": [
     {
      "id": "Other Rooms/Laundry and cleaning/Washers / Dryers",
      "name": "Washers / Dryers",
      "title": "Стир.машины",
      "photo": "/hp/catalog/tree/f09bf7d93532.webp",
      "anyTags": [],
      "allTags": [
       "LaundryItem"
      ]
     },
     {
      "id": "Other Rooms/Laundry and cleaning/Laundry accessories",
      "name": "Laundry accessories",
      "title": "Все для стирки",
      "photo": "/hp/catalog/tree/7713c65c38b2.webp",
      "anyTags": [],
      "allTags": [
       "Ironing"
      ]
     },
     {
      "id": "Other Rooms/Laundry and cleaning/Vacuum cleaners and mops",
      "name": "Vacuum cleaners and mops",
      "title": "Пылесосы и швабры",
      "photo": "/hp/catalog/tree/ce8c9b8a1e9f.webp",
      "anyTags": [],
      "allTags": [
       "VacuumCleaner"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Other Rooms/Laundry and cleaning/Cleaning",
      "name": "Cleaning",
      "title": "Уборка",
      "photo": "/hp/catalog/tree/2e6d9f58add0.webp",
      "anyTags": [],
      "allTags": [
       "Cleaning"
      ]
     },
     {
      "id": "Other Rooms/Laundry and cleaning/Irons and Steamers",
      "name": "Irons and Steamers",
      "title": "Утюги и отпариватели",
      "photo": "/hp/catalog/tree/5d54eb419010.webp",
      "anyTags": [],
      "allTags": [
       "Iron"
      ],
      "sort": "PriceHigh"
     }
    ]
   },
   {
    "id": "Other Rooms/Fireplaces",
    "name": "Fireplaces",
    "title": "Камин",
    "photo": "/hp/catalog/tree/dba42e206ba4.webp",
    "anyTags": [],
    "allTags": [
     "Fireplace"
    ]
   },
   {
    "id": "Other Rooms/bathroom",
    "name": "bathroom",
    "title": "Ванная",
    "photo": "/hp/catalog/tree/18b399daf0ac.webp",
    "children": [
     {
      "id": "Other Rooms/bathroom/Bath and Spa",
      "name": "Bath and Spa",
      "title": "Ванна и спа",
      "photo": "/hp/catalog/tree/18b399daf0ac.webp",
      "children": [
       {
        "id": "Other Rooms/bathroom/Bath and Spa/Shower",
        "name": "Shower",
        "title": "Душ",
        "photo": "/hp/catalog/tree/18b399daf0ac.webp",
        "anyTags": [],
        "allTags": [
         "ShowerAll"
        ],
        "filters": [
         {
          "id": "Shower Cabin",
          "title": "Shower Cabin",
          "anyTags": [],
          "allTags": [
           "Shower"
          ]
         },
         {
          "id": "Shower System",
          "title": "Shower System",
          "anyTags": [
           "ShowerWall",
           "ShowerCeiling"
          ],
          "allTags": []
         },
         {
          "id": "ShowerMixer",
          "title": "ShowerMixer",
          "anyTags": [],
          "allTags": [
           "ShowerMixer"
          ]
         },
         {
          "id": "ShowerScreen",
          "title": "ShowerScreen",
          "anyTags": [],
          "allTags": [
           "ShowerScreen"
          ]
         },
         {
          "id": "ShowerTray",
          "title": "ShowerTray",
          "anyTags": [],
          "allTags": [
           "ShowerTray"
          ]
         }
        ]
       },
       {
        "id": "Other Rooms/bathroom/Bath and Spa/Bath",
        "name": "Bath",
        "title": "Ванна",
        "photo": "/hp/catalog/tree/b40f1a48e1b2.webp",
        "anyTags": [],
        "allTags": [
         "BathAll"
        ],
        "filters": [
         {
          "id": "SingleBath",
          "title": "SingleBath",
          "anyTags": [],
          "allTags": [
           "Bath"
          ]
         },
         {
          "id": "Bath Faucet",
          "title": "Bath Faucet",
          "anyTags": [],
          "allTags": [
           "FloorFaucet"
          ]
         },
         {
          "id": "Jacuzzi",
          "title": "Jacuzzi",
          "anyTags": [],
          "allTags": [
           "Jacuzzi"
          ]
         }
        ]
       },
       {
        "id": "Other Rooms/bathroom/Bath and Spa/Spa",
        "name": "Spa",
        "title": "Спа",
        "photo": "/hp/catalog/tree/26a46f3eba38.webp",
        "anyTags": [],
        "allTags": [
         "Spa"
        ]
       },
       {
        "id": "Other Rooms/bathroom/Bath and Spa/Sauna",
        "name": "Sauna",
        "title": "Сауна",
        "photo": "/hp/catalog/tree/e5ab76fb548a.webp",
        "anyTags": [],
        "allTags": [
         "Sauna"
        ]
       }
      ]
     },
     {
      "id": "Other Rooms/bathroom/Bath Accessories",
      "name": "Bath Accessories",
      "title": "Аксессуары",
      "photo": "/hp/catalog/tree/2fa853306e65.webp",
      "children": [
       {
        "id": "Other Rooms/bathroom/Bath Accessories/Towel rack",
        "name": "Towel rack",
        "title": "Вешалка для полотенца",
        "photo": "/hp/catalog/tree/2fa853306e65.webp",
        "anyTags": [],
        "allTags": [
         "Towels"
        ]
       },
       {
        "id": "Other Rooms/bathroom/Bath Accessories/Bathroom Decor",
        "name": "Bathroom Decor",
        "title": "Декор ванной",
        "photo": "/hp/catalog/tree/fbf15edf7a1f.webp",
        "anyTags": [],
        "allTags": [
         "BathroomDecor"
        ]
       },
       {
        "id": "Other Rooms/bathroom/Bath Accessories/Soap and shampoo",
        "name": "Soap and shampoo",
        "title": "Мыло и шампунь",
        "photo": "/hp/catalog/tree/6507d696ca2b.webp",
        "anyTags": [],
        "allTags": [
         "Toiletries"
        ]
       },
       {
        "id": "Other Rooms/bathroom/Bath Accessories/Toilet Paper Holder",
        "name": "Toilet Paper Holder",
        "title": "Держатель туалетной бумаги",
        "photo": "/hp/catalog/tree/46d405148f31.webp",
        "anyTags": [],
        "allTags": [
         "ToiletPaperHolder"
        ]
       },
       {
        "id": "Other Rooms/bathroom/Bath Accessories/Cosmetics",
        "name": "Cosmetics",
        "title": "Косметика",
        "photo": "/hp/catalog/tree/c7d684bf8873.webp",
        "anyTags": [
         "Cosmetics",
         "CosmeticsFlat"
        ],
        "allTags": []
       },
       {
        "id": "Other Rooms/bathroom/Bath Accessories/Toilet Brush",
        "name": "Toilet Brush",
        "title": "Щетка для унитаза",
        "photo": "/hp/catalog/tree/b8b0156786ed.webp",
        "anyTags": [],
        "allTags": [
         "ToiletBrush"
        ]
       },
       {
        "id": "Other Rooms/bathroom/Bath Accessories/Toothbrush holder",
        "name": "Toothbrush holder",
        "title": "Держатель щеток",
        "photo": "/hp/catalog/tree/287927d52240.webp",
        "anyTags": [],
        "allTags": [
         "ToothbrushHolder"
        ]
       },
       {
        "id": "Other Rooms/bathroom/Bath Accessories/Safety rack",
        "name": "Safety rack",
        "title": "Защитный поручень",
        "photo": "/hp/catalog/tree/1751da619d8b.webp",
        "anyTags": [],
        "allTags": [
         "SafetyRack"
        ]
       },
       {
        "id": "Other Rooms/bathroom/Bath Accessories/Toilet Seat",
        "name": "Toilet Seat",
        "title": "Сиденье для унитаза",
        "photo": "/hp/catalog/tree/c6067c692eec.webp",
        "anyTags": [],
        "allTags": [
         "ToiletSeat"
        ]
       },
       {
        "id": "Other Rooms/bathroom/Bath Accessories/Hair Dryers",
        "name": "Hair Dryers",
        "title": "Hair Dryers",
        "photo": "/hp/catalog/tree/f24cd6d05204.webp",
        "anyTags": [],
        "allTags": [
         "HairDryer"
        ]
       },
       {
        "id": "Other Rooms/bathroom/Bath Accessories/Hand Dryers",
        "name": "Hand Dryers",
        "title": "Hand Dryers",
        "photo": "/hp/catalog/tree/9251bc1a8192.webp",
        "anyTags": [],
        "allTags": [
         "HandDryer"
        ]
       }
      ]
     },
     {
      "id": "Other Rooms/bathroom/Lavatory pan",
      "name": "Lavatory pan",
      "title": "Унитаз",
      "photo": "/hp/catalog/tree/ab6a3b89ecbf.webp",
      "anyTags": [],
      "allTags": [
       "WC"
      ],
      "filters": [
       {
        "id": "Toilet",
        "title": "Toilet",
        "anyTags": [],
        "allTags": [
         "Toilet"
        ]
       },
       {
        "id": "Wall-mounted Toilet",
        "title": "Wall-mounted Toilet",
        "anyTags": [],
        "allTags": [
         "WallToilet"
        ]
       },
       {
        "id": "Flush",
        "title": "Слив",
        "anyTags": [],
        "allTags": [
         "Flush"
        ]
       },
       {
        "id": "Urinal",
        "title": "Urinal",
        "anyTags": [],
        "allTags": [
         "Urinal"
        ]
       },
       {
        "id": "Bidet",
        "title": "Bidet",
        "anyTags": [],
        "allTags": [
         "Bidet"
        ]
       },
       {
        "id": "Floor Toilet",
        "title": "Напольный туалет",
        "anyTags": [],
        "allTags": [
         "FloorToilet"
        ]
       },
       {
        "id": "Kid Toilet",
        "title": "Детский туалет",
        "anyTags": [],
        "allTags": [
         "ToiletKid"
        ]
       }
      ]
     }
    ]
   },
   {
    "id": "Other Rooms/outdoor",
    "name": "outdoor",
    "title": "Двор или терраса",
    "photo": "/hp/catalog/tree/ea3c8a650c88.webp",
    "children": [
     {
      "id": "Other Rooms/outdoor/Swimming pool",
      "name": "Swimming pool",
      "title": "Бассейн",
      "photo": "/hp/catalog/tree/6282738bbf26.webp",
      "children": [
       {
        "id": "Other Rooms/outdoor/Swimming pool/Swimming pool",
        "name": "Swimming pool",
        "title": "Бассейн",
        "photo": "/hp/catalog/tree/6282738bbf26.webp",
        "anyTags": [
         "Pool",
         "2DPool"
        ],
        "allTags": []
       },
       {
        "id": "Other Rooms/outdoor/Swimming pool/Sunbed",
        "name": "Sunbed",
        "title": "Шезлонг",
        "photo": "/hp/catalog/tree/2a56221dc0c4.webp",
        "anyTags": [],
        "allTags": [
         "Sunbed"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Swimming pool/Umbrella",
        "name": "Umbrella",
        "title": "Зонтик",
        "photo": "/hp/catalog/tree/8653780033a9.webp",
        "anyTags": [],
        "allTags": [
         "Umbrella"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Swimming pool/Pool Accessories",
        "name": "Pool Accessories",
        "title": "Аксессуары для бассейна",
        "photo": "/hp/catalog/tree/07ffc537824b.webp",
        "anyTags": [],
        "allTags": [
         "PoolMore"
        ]
       }
      ]
     },
     {
      "id": "Other Rooms/outdoor/Garden Structures",
      "name": "Garden Structures",
      "title": "Беседки и заборы",
      "photo": "/hp/catalog/tree/c5e6adfd5d61.webp",
      "children": [
       {
        "id": "Other Rooms/outdoor/Garden Structures/Fences",
        "name": "Fences",
        "title": "Заборы",
        "photo": "/hp/catalog/tree/c5e6adfd5d61.webp",
        "anyTags": [],
        "allTags": [
         "Fences"
        ],
        "filters": [
         {
          "id": "Fence",
          "title": "Забор",
          "anyTags": [],
          "allTags": [
           "Fence"
          ]
         },
         {
          "id": "Gate",
          "title": "Gate",
          "anyTags": [],
          "allTags": [
           "Gate"
          ]
         }
        ]
       },
       {
        "id": "Other Rooms/outdoor/Garden Structures/Balcony",
        "name": "Balcony",
        "title": "Балкон",
        "photo": "/hp/catalog/tree/cdbb1e28e767.webp",
        "anyTags": [],
        "allTags": [
         "Balcony"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Garden Structures/Umbrella",
        "name": "Umbrella",
        "title": "Зонтик",
        "photo": "/hp/catalog/tree/8653780033a9.webp",
        "anyTags": [],
        "allTags": [
         "Umbrella"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Garden Structures/Gazebo",
        "name": "Gazebo",
        "title": "Беседка",
        "photo": "/hp/catalog/tree/7af98446dbf1.webp",
        "anyTags": [],
        "allTags": [
         "Gazebo"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Garden Structures/Canopies",
        "name": "Canopies",
        "title": "Навесы",
        "photo": "/hp/catalog/tree/a456e1ac1042.webp",
        "anyTags": [],
        "allTags": [
         "Canopies"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Garden Structures/Porch",
        "name": "Porch",
        "title": "Крыльцо",
        "photo": "/hp/catalog/tree/f4afdb8a73b7.webp",
        "anyTags": [],
        "allTags": [
         "Porch"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Garden Structures/Sunhouse",
        "name": "Sunhouse",
        "title": "Теплица",
        "photo": "/hp/catalog/tree/59a70b83951f.webp",
        "anyTags": [],
        "allTags": [
         "Sunhouse"
        ]
       }
      ]
     },
     {
      "id": "Other Rooms/outdoor/Landscaping",
      "name": "Landscaping",
      "title": "Ландшафтный дизайн",
      "photo": "/hp/catalog/tree/8ceb7e2c9a4f.webp",
      "children": [
       {
        "id": "Other Rooms/outdoor/Landscaping/Flowers",
        "name": "Flowers",
        "title": "Цветы",
        "photo": "/hp/catalog/tree/7a5f5cae1aa2.webp",
        "anyTags": [],
        "allTags": [
         "Flower"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Landscaping/Phytowall",
        "name": "Phytowall",
        "title": "Фитостена",
        "photo": "/hp/catalog/tree/fa74e40e7df0.webp",
        "anyTags": [],
        "allTags": [
         "Phytowall"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Other Rooms/outdoor/Landscaping/Outdoor plants",
        "name": "Outdoor plants",
        "title": "Уличные растения",
        "photo": "/hp/catalog/tree/e51aee01c38e.webp",
        "anyTags": [],
        "allTags": [
         "OutdoorPlant"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Landscaping/Trees",
        "name": "Trees",
        "title": "Деревья",
        "photo": "/hp/catalog/tree/78cb2ab324dc.webp",
        "anyTags": [],
        "allTags": [
         "Tree"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Landscaping/Bushes",
        "name": "Bushes",
        "title": "Кусты",
        "photo": "/hp/catalog/tree/3ccff157dbfc.webp",
        "anyTags": [],
        "allTags": [
         "Bush"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Landscaping/Roads",
        "name": "Roads",
        "title": "Дороги",
        "photo": "/hp/catalog/tree/7c070c8a8742.webp",
        "anyTags": [],
        "allTags": [
         "Road"
        ],
        "filters": [
         {
          "id": "Road",
          "title": "Road",
          "anyTags": [],
          "allTags": [
           "Roads"
          ]
         },
         {
          "id": "Drain",
          "title": "Ливневка",
          "anyTags": [
           "Drain",
           "Drain3D"
          ],
          "allTags": []
         },
         {
          "id": "Luke",
          "title": "Люк",
          "anyTags": [],
          "allTags": [
           "Luke"
          ]
         }
        ]
       },
       {
        "id": "Other Rooms/outdoor/Landscaping/Fountain",
        "name": "Fountain",
        "title": "Фонтан",
        "photo": "/hp/catalog/tree/0927e3645a1e.webp",
        "anyTags": [],
        "allTags": [
         "Fountain"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Landscaping/Stones",
        "name": "Stones",
        "title": "Камни",
        "photo": "/hp/catalog/tree/43a0660e7e68.webp",
        "anyTags": [],
        "allTags": [
         "Stones"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Landscaping/Garden styles",
        "name": "Garden styles",
        "title": "Стили сада",
        "photo": "/hp/catalog/tree/26a15c430106.webp",
        "children": [
         {
          "id": "Other Rooms/outdoor/Landscaping/Garden styles/Traditional Formal Garden",
          "name": "Traditional Formal Garden",
          "title": "Традиционный формальный сад",
          "photo": "/hp/catalog/tree/26a15c430106.webp",
          "anyTags": [],
          "allTags": [
           "TraditionalFormalGarden"
          ]
         },
         {
          "id": "Other Rooms/outdoor/Landscaping/Garden styles/English Cottage Garden",
          "name": "English Cottage Garden",
          "title": "Английский коттеджный сад",
          "photo": "/hp/catalog/tree/ce00f307fe47.webp",
          "anyTags": [],
          "allTags": [
           "EnglishCottageGarden"
          ]
         },
         {
          "id": "Other Rooms/outdoor/Landscaping/Garden styles/Modern Minimalist Garden",
          "name": "Modern Minimalist Garden",
          "title": "Минималистичный сад",
          "photo": "/hp/catalog/tree/1603be6ad023.webp",
          "anyTags": [],
          "allTags": [
           "MinimalistGarden"
          ]
         },
         {
          "id": "Other Rooms/outdoor/Landscaping/Garden styles/Potager Garden",
          "name": "Potager Garden",
          "title": "Сад-огород",
          "photo": "/hp/catalog/tree/72356c744bd8.webp",
          "anyTags": [],
          "allTags": [
           "PotagerGarden"
          ]
         },
         {
          "id": "Other Rooms/outdoor/Landscaping/Garden styles/Asian Zen Garden",
          "name": "Asian Zen Garden",
          "title": "Азиатский дзен-сад",
          "photo": "/hp/catalog/tree/58a38e3b4a10.webp",
          "anyTags": [],
          "allTags": [
           "AsianGarden"
          ]
         },
         {
          "id": "Other Rooms/outdoor/Landscaping/Garden styles/Tropical Garden",
          "name": "Tropical Garden",
          "title": "Тропический сад",
          "photo": "/hp/catalog/tree/6e9c78547051.webp",
          "anyTags": [],
          "allTags": [
           "TropicalGarden"
          ]
         },
         {
          "id": "Other Rooms/outdoor/Landscaping/Garden styles/Mediterranean Garden",
          "name": "Mediterranean Garden",
          "title": "Средиземноморский сад",
          "photo": "/hp/catalog/tree/d9e0b59497a8.webp",
          "anyTags": [],
          "allTags": [
           "MediterraneanGarden"
          ]
         },
         {
          "id": "Other Rooms/outdoor/Landscaping/Garden styles/Coastal Garden",
          "name": "Coastal Garden",
          "title": "Прибрежный сад",
          "photo": "/hp/catalog/tree/e62c06c838d8.webp",
          "anyTags": [],
          "allTags": [
           "CoastalGarden"
          ]
         },
         {
          "id": "Other Rooms/outdoor/Landscaping/Garden styles/Woodland Garden",
          "name": "Woodland Garden",
          "title": "Лесной сад",
          "photo": "/hp/catalog/tree/0f4cf10286bb.webp",
          "anyTags": [],
          "allTags": [
           "WoodlandGarden"
          ]
         },
         {
          "id": "Other Rooms/outdoor/Landscaping/Garden styles/Native Prairie Garden",
          "name": "Native Prairie Garden",
          "title": "Сад прерий",
          "photo": "/hp/catalog/tree/f38b861d81d3.webp",
          "anyTags": [],
          "allTags": [
           "PrairieGarden"
          ]
         },
         {
          "id": "Other Rooms/outdoor/Landscaping/Garden styles/Xeriscape Garden",
          "name": "Xeriscape Garden",
          "title": "Пустынный сад",
          "photo": "/hp/catalog/tree/460a256ccaa0.webp",
          "anyTags": [],
          "allTags": [
           "XeriscapeGarden"
          ]
         },
         {
          "id": "Other Rooms/outdoor/Landscaping/Garden styles/Southwestern Desert Garden",
          "name": "Southwestern Desert Garden",
          "title": "Юго-западный пустынный сад",
          "photo": "/hp/catalog/tree/41f355dc9147.webp",
          "anyTags": [],
          "allTags": [
           "SouthwesternDesertGarden"
          ]
         }
        ]
       },
       {
        "id": "Other Rooms/outdoor/Landscaping/Garden Decor",
        "name": "Garden Decor",
        "title": "Садовый декор",
        "photo": "/hp/catalog/tree/6e19291f6c50.webp",
        "anyTags": [],
        "allTags": [
         "GardenDecor"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Landscaping/Garden Vases",
        "name": "Garden Vases",
        "title": "Садовые вазы",
        "photo": "/hp/catalog/tree/2dbaa4525215.webp",
        "anyTags": [],
        "allTags": [
         "GardenVase"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Landscaping/Sculpture",
        "name": "Sculpture",
        "title": "Скульптура",
        "photo": "/hp/catalog/tree/4e979e2f0fc3.webp",
        "anyTags": [],
        "allTags": [
         "Sculpture"
        ]
       },
       {
        "id": "Other Rooms/outdoor/Landscaping/Bridge",
        "name": "Bridge",
        "title": "Мост",
        "photo": "/hp/catalog/tree/ba9e659aad9a.webp",
        "anyTags": [],
        "allTags": [
         "Bridge"
        ]
       }
      ]
     }
    ]
   },
   {
    "id": "Other Rooms/homeoffice",
    "name": "homeoffice",
    "title": "Кабинет",
    "photo": "/hp/catalog/tree/659440ea2171.webp",
    "children": [
     {
      "id": "Other Rooms/homeoffice/Office storage",
      "name": "Office storage",
      "title": "Офисные стеллажи",
      "photo": "/hp/catalog/tree/c1a2b0725cd9.webp",
      "anyTags": [],
      "allTags": [
       "OfficeStorage"
      ]
     },
     {
      "id": "Other Rooms/homeoffice/Whiteboard",
      "name": "Whiteboard",
      "title": "Офисная доска",
      "photo": "/hp/catalog/tree/19a02bfabb73.webp",
      "anyTags": [],
      "allTags": [
       "Whiteboard"
      ]
     }
    ]
   },
   {
    "id": "Other Rooms/garage",
    "name": "garage",
    "title": "Гараж",
    "photo": "/hp/catalog/tree/0efaf8ca3b7f.webp",
    "children": [
     {
      "id": "Other Rooms/garage/Transport",
      "name": "Transport",
      "title": "Транспорт",
      "photo": "/hp/catalog/tree/0efaf8ca3b7f.webp",
      "children": [
       {
        "id": "Other Rooms/garage/Transport/Cars",
        "name": "Cars",
        "title": "Автомобили",
        "photo": "/hp/catalog/tree/0efaf8ca3b7f.webp",
        "anyTags": [],
        "allTags": [
         "Car"
        ]
       },
       {
        "id": "Other Rooms/garage/Transport/Bikes",
        "name": "Bikes",
        "title": "Мотоциклы",
        "photo": "/hp/catalog/tree/d2e4f0a1afff.webp",
        "anyTags": [],
        "allTags": [
         "Bike"
        ]
       },
       {
        "id": "Other Rooms/garage/Transport/Stroller",
        "name": "Stroller",
        "title": "Коляска",
        "photo": "/hp/catalog/tree/0773ce74d3c5.webp",
        "anyTags": [],
        "allTags": [
         "Stroller"
        ]
       },
       {
        "id": "Other Rooms/garage/Transport/SportTransport",
        "name": "SportTransport",
        "title": "Спорт",
        "photo": "/hp/catalog/tree/a699163060f8.webp",
        "anyTags": [],
        "allTags": [
         "SportTransport"
        ]
       }
      ]
     },
     {
      "id": "Other Rooms/garage/Garage decor",
      "name": "Garage decor",
      "title": "Гаражные аксессуары",
      "photo": "/hp/catalog/tree/9485f260f831.webp",
      "anyTags": [],
      "allTags": [
       "GarageDecor"
      ]
     }
    ]
   },
   {
    "id": "Other Rooms/laundry",
    "name": "laundry",
    "title": "Прачечная",
    "photo": "/hp/catalog/tree/1ae746753d48.webp",
    "children": [
     {
      "id": "Other Rooms/laundry/Sink",
      "name": "Sink",
      "title": "Раковина",
      "photo": "/hp/catalog/tree/aee842c5d38d.webp",
      "anyTags": [],
      "allTags": [
       "Sink"
      ],
      "filters": [
       {
        "id": "Kitchen Sinks",
        "title": "Мойки",
        "anyTags": [],
        "allTags": [
         "KitchenSink"
        ]
       },
       {
        "id": "Sink cabinet",
        "title": "Шкаф с раковиной",
        "anyTags": [],
        "allTags": [
         "SinkCabinet"
        ]
       },
       {
        "id": "Built-in Sink",
        "title": "Встроенная раковина",
        "anyTags": [],
        "allTags": [
         "BuiltinSink"
        ]
       },
       {
        "id": "Single Sink",
        "title": "Одинарная раковина",
        "anyTags": [],
        "allTags": [
         "SingleSink"
        ]
       },
       {
        "id": "Double Sink",
        "title": "Двойная мойка",
        "anyTags": [],
        "allTags": [
         "DoubleSink"
        ]
       },
       {
        "id": "Pedestal Sink",
        "title": "Раковина-тюльпан",
        "anyTags": [],
        "allTags": [
         "FloorSink"
        ]
       },
       {
        "id": "Wall Sink",
        "title": "Настенная раковина",
        "anyTags": [],
        "allTags": [
         "SinkWall"
        ]
       },
       {
        "id": "Wall Tap",
        "title": "Настенный кран",
        "anyTags": [],
        "allTags": [
         "WallTap"
        ]
       },
       {
        "id": "Faucet",
        "title": "Смеситель",
        "anyTags": [],
        "allTags": [
         "Faucet"
        ]
       },
       {
        "id": "Sink Bowl",
        "title": "Чаша раковины",
        "anyTags": [],
        "allTags": [
         "SinkBowl"
        ]
       }
      ]
     },
     {
      "id": "Other Rooms/laundry/Bath Accessories",
      "name": "Bath Accessories",
      "title": "Аксессуары",
      "photo": "/hp/catalog/tree/2fa853306e65.webp",
      "children": [
       {
        "id": "Other Rooms/laundry/Bath Accessories/Towel rack",
        "name": "Towel rack",
        "title": "Вешалка для полотенца",
        "photo": "/hp/catalog/tree/2fa853306e65.webp",
        "anyTags": [],
        "allTags": [
         "Towels"
        ],
        "filters": [
         {
          "id": "Towels",
          "title": "Полотенца",
          "anyTags": [],
          "allTags": [
           "Towel"
          ]
         },
         {
          "id": "Towel racks",
          "title": "Полотенцедержатели",
          "anyTags": [],
          "allTags": [
           "TowelRack"
          ]
         },
         {
          "id": "Towel stands",
          "title": "Стойки для полотенец",
          "anyTags": [],
          "allTags": [
           "TowelStand"
          ]
         }
        ]
       },
       {
        "id": "Other Rooms/laundry/Bath Accessories/Bathroom Decor",
        "name": "Bathroom Decor",
        "title": "Декор ванной",
        "photo": "/hp/catalog/tree/fbf15edf7a1f.webp",
        "anyTags": [],
        "allTags": [
         "BathroomDecor"
        ],
        "filters": [
         {
          "id": "Bathroom Decor Table Top",
          "title": "Столешница",
          "anyTags": [],
          "allTags": [
           "BathroomSurface"
          ]
         },
         {
          "id": "Wall Bathroom Decor",
          "title": "Настенный",
          "anyTags": [],
          "allTags": [
           "BathroomWall"
          ]
         }
        ]
       },
       {
        "id": "Other Rooms/laundry/Bath Accessories/Soap and shampoo",
        "name": "Soap and shampoo",
        "title": "Мыло и шампунь",
        "photo": "/hp/catalog/tree/6507d696ca2b.webp",
        "anyTags": [],
        "allTags": [
         "Toiletries"
        ],
        "filters": [
         {
          "id": "Soaps",
          "title": "Soaps",
          "anyTags": [],
          "allTags": [
           "Soap"
          ]
         },
         {
          "id": "Shampoo",
          "title": "Shampoo",
          "anyTags": [],
          "allTags": [
           "Shampoo"
          ]
         },
         {
          "id": "Soap Holder",
          "title": "Soap Holder",
          "anyTags": [],
          "allTags": [
           "SoapHolder"
          ]
         }
        ]
       },
       {
        "id": "Other Rooms/laundry/Bath Accessories/Toilet Paper Holder",
        "name": "Toilet Paper Holder",
        "title": "Держатель туалетной бумаги",
        "photo": "/hp/catalog/tree/46d405148f31.webp",
        "anyTags": [],
        "allTags": [
         "ToiletPaperHolder"
        ]
       },
       {
        "id": "Other Rooms/laundry/Bath Accessories/Cosmetics",
        "name": "Cosmetics",
        "title": "Косметика",
        "photo": "/hp/catalog/tree/c7d684bf8873.webp",
        "anyTags": [
         "Cosmetics",
         "CosmeticsFlat"
        ],
        "allTags": []
       },
       {
        "id": "Other Rooms/laundry/Bath Accessories/Toilet Brush",
        "name": "Toilet Brush",
        "title": "Щетка для унитаза",
        "photo": "/hp/catalog/tree/b8b0156786ed.webp",
        "anyTags": [],
        "allTags": [
         "ToiletBrush"
        ]
       },
       {
        "id": "Other Rooms/laundry/Bath Accessories/Toothbrush holder",
        "name": "Toothbrush holder",
        "title": "Держатель щеток",
        "photo": "/hp/catalog/tree/287927d52240.webp",
        "anyTags": [],
        "allTags": [
         "ToothbrushHolder"
        ]
       },
       {
        "id": "Other Rooms/laundry/Bath Accessories/Safety rack",
        "name": "Safety rack",
        "title": "Защитный поручень",
        "photo": "/hp/catalog/tree/1751da619d8b.webp",
        "anyTags": [],
        "allTags": [
         "SafetyRack"
        ]
       },
       {
        "id": "Other Rooms/laundry/Bath Accessories/Toilet Seat",
        "name": "Toilet Seat",
        "title": "Сиденье для унитаза",
        "photo": "/hp/catalog/tree/c6067c692eec.webp",
        "anyTags": [],
        "allTags": [
         "ToiletSeat"
        ]
       },
       {
        "id": "Other Rooms/laundry/Bath Accessories/Hair Dryers",
        "name": "Hair Dryers",
        "title": "Hair Dryers",
        "photo": "/hp/catalog/tree/f24cd6d05204.webp",
        "anyTags": [],
        "allTags": [
         "HairDryer"
        ]
       },
       {
        "id": "Other Rooms/laundry/Bath Accessories/Hand Dryers",
        "name": "Hand Dryers",
        "title": "Hand Dryers",
        "photo": "/hp/catalog/tree/9251bc1a8192.webp",
        "anyTags": [],
        "allTags": [
         "HandDryer"
        ]
       }
      ]
     }
    ]
   },
   {
    "id": "Other Rooms/cafe",
    "name": "cafe",
    "title": "Кафе и бар",
    "photo": "/hp/catalog/tree/a646408a2c5a.webp",
    "children": [
     {
      "id": "Other Rooms/cafe/Cafe Furniture",
      "name": "Cafe Furniture",
      "title": "Предметы для кафе",
      "photo": "/hp/catalog/tree/a646408a2c5a.webp",
      "anyTags": [],
      "allTags": [
       "CafeFurniture"
      ]
     }
    ]
   },
   {
    "id": "Other Rooms/salon",
    "name": "salon",
    "title": "Салон красоты",
    "photo": "/hp/catalog/tree/27b739ddebd6.webp",
    "children": [
     {
      "id": "Other Rooms/salon/Beauty salon",
      "name": "Beauty salon",
      "title": "Салон красоты",
      "photo": "/hp/catalog/tree/27b739ddebd6.webp",
      "anyTags": [],
      "allTags": [
       "BeautySalon"
      ]
     },
     {
      "id": "Other Rooms/salon/Beauty chairs",
      "name": "Beauty chairs",
      "title": "Beauty chairs",
      "photo": "/hp/catalog/tree/1917e26594b8.webp",
      "anyTags": [],
      "allTags": [
       "BeautySalon",
       "Armchair"
      ]
     }
    ]
   },
   {
    "id": "Other Rooms/event",
    "name": "event",
    "title": "Зал для мероприятий",
    "photo": "/hp/catalog/tree/c0fb9b1057cd.webp",
    "children": [
     {
      "id": "Other Rooms/event/Events",
      "name": "Events",
      "title": "События",
      "photo": "/hp/catalog/tree/c0fb9b1057cd.webp",
      "anyTags": [],
      "allTags": [
       "Events"
      ]
     }
    ]
   }
  ]
 },
 {
  "id": "Decoration",
  "name": "Decoration",
  "title": "Декор",
  "photo": "/hp/catalog/tree/5c53e97e290c.webp",
  "children": [
   {
    "id": "Decoration/Plants and Vases",
    "name": "Plants and Vases",
    "title": "Растения и вазы",
    "photo": "/hp/catalog/tree/5c53e97e290c.webp",
    "children": [
     {
      "id": "Decoration/Plants and Vases/Home plants",
      "name": "Home plants",
      "title": "Домашние растения",
      "photo": "/hp/catalog/tree/5c53e97e290c.webp",
      "anyTags": [],
      "allTags": [
       "HomePlant"
      ],
      "filters": [
       {
        "id": "Table plants",
        "title": "Table plants",
        "anyTags": [],
        "allTags": [
         "Plant"
        ]
       },
       {
        "id": "Succulents",
        "title": "Суккуленты",
        "anyTags": [],
        "allTags": [
         "Succulent"
        ]
       },
       {
        "id": "Wall-mount plants",
        "title": "Wall-mount plants",
        "anyTags": [],
        "allTags": [
         "WallPlant"
        ]
       },
       {
        "id": "Floor plants",
        "title": "Напольные растения",
        "anyTags": [],
        "allTags": [
         "FloorPlant"
        ]
       },
       {
        "id": "Ceiling-mount plants",
        "title": "Подвесные растения",
        "anyTags": [],
        "allTags": [
         "PlantCeiling"
        ]
       }
      ]
     },
     {
      "id": "Decoration/Plants and Vases/Vases",
      "name": "Vases",
      "title": "Вазы",
      "photo": "/hp/catalog/tree/f1d0ef808497.webp",
      "anyTags": [],
      "allTags": [
       "Vase"
      ],
      "filters": [
       {
        "id": "Table vase",
        "title": "Настольная ваза",
        "anyTags": [],
        "allTags": [
         "TableVase"
        ]
       },
       {
        "id": "Floor vase",
        "title": "Напольная ваза",
        "anyTags": [],
        "allTags": [
         "FloorVase"
        ]
       }
      ]
     },
     {
      "id": "Decoration/Plants and Vases/Plant stands",
      "name": "Plant stands",
      "title": "Стойки для растений",
      "photo": "/hp/catalog/tree/99e750687772.webp",
      "anyTags": [],
      "allTags": [
       "StandPlant"
      ]
     },
     {
      "id": "Decoration/Plants and Vases/Flowers",
      "name": "Flowers",
      "title": "Цветы",
      "photo": "/hp/catalog/tree/7a5f5cae1aa2.webp",
      "anyTags": [],
      "allTags": [
       "Flower"
      ]
     },
     {
      "id": "Decoration/Plants and Vases/Phytowall",
      "name": "Phytowall",
      "title": "Фитостена",
      "photo": "/hp/catalog/tree/fa74e40e7df0.webp",
      "anyTags": [],
      "allTags": [
       "Phytowall"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Decoration/Plants and Vases/Outdoor plants",
      "name": "Outdoor plants",
      "title": "Уличные растения",
      "photo": "/hp/catalog/tree/e51aee01c38e.webp",
      "anyTags": [],
      "allTags": [
       "OutdoorPlant"
      ]
     },
     {
      "id": "Decoration/Plants and Vases/Trees",
      "name": "Trees",
      "title": "Деревья",
      "photo": "/hp/catalog/tree/78cb2ab324dc.webp",
      "anyTags": [],
      "allTags": [
       "Tree"
      ]
     },
     {
      "id": "Decoration/Plants and Vases/Bushes",
      "name": "Bushes",
      "title": "Кусты",
      "photo": "/hp/catalog/tree/3ccff157dbfc.webp",
      "anyTags": [],
      "allTags": [
       "Bush"
      ]
     }
    ]
   },
   {
    "id": "Decoration/Wall Art",
    "name": "Wall Art",
    "title": "Настенный декор",
    "photo": "/hp/catalog/tree/207798f1ce38.webp",
    "children": [
     {
      "id": "Decoration/Wall Art/Pictures",
      "name": "Pictures",
      "title": "Картины",
      "photo": "/hp/catalog/tree/207798f1ce38.webp",
      "anyTags": [],
      "allTags": [
       "Pictures"
      ],
      "sort": "PriceHigh",
      "filters": [
       {
        "id": "Framed Art",
        "title": "Картины в рамке",
        "anyTags": [],
        "allTags": [
         "Frames"
        ]
       },
       {
        "id": "No Frame Art",
        "title": "Картины без рамки",
        "anyTags": [],
        "allTags": [
         "NoFrame"
        ]
       },
       {
        "id": "Table Frames",
        "title": "Рамки для столов",
        "anyTags": [],
        "allTags": [
         "PaintingFloor"
        ]
       },
       {
        "id": "Wall Art Set",
        "title": "Сеты картин",
        "anyTags": [],
        "allTags": [
         "ArtSet"
        ]
       },
       {
        "id": "Classic Art",
        "title": "Классические картины",
        "anyTags": [],
        "allTags": [
         "ClassicArt"
        ]
       },
       {
        "id": "Photo Art",
        "title": "Фото",
        "anyTags": [],
        "allTags": [
         "PhotoArt"
        ]
       },
       {
        "id": "Text Art",
        "title": "Текстовые картины",
        "anyTags": [],
        "allTags": [
         "TextArt"
        ]
       },
       {
        "id": "Kids Art",
        "title": "Детские картины",
        "anyTags": [],
        "allTags": [
         "KidsArt"
        ]
       },
       {
        "id": "Round Art",
        "title": "Круглые картины",
        "anyTags": [],
        "allTags": [
         "RoundArt"
        ]
       },
       {
        "id": "Sea Art",
        "title": "Морские картины",
        "anyTags": [],
        "allTags": [
         "SeaArt"
        ]
       },
       {
        "id": "Asian Art",
        "title": "Азиатское искусство",
        "anyTags": [],
        "allTags": [
         "AsianArt"
        ]
       },
       {
        "id": "Abstract Art",
        "title": "Абстрактное искусство",
        "anyTags": [],
        "allTags": [
         "AbstractArt"
        ]
       },
       {
        "id": "Modern Art",
        "title": "Картины модерн",
        "anyTags": [],
        "allTags": [
         "ModernArt"
        ]
       },
       {
        "id": "Oil Paintings",
        "title": "Картины маслом",
        "anyTags": [],
        "allTags": [
         "OilPainting"
        ]
       },
       {
        "id": "Wood Art",
        "title": "Деревянные картины",
        "anyTags": [],
        "allTags": [
         "WoodArt"
        ]
       },
       {
        "id": "Maps",
        "title": "Настенные карты",
        "anyTags": [],
        "allTags": [
         "Maps"
        ]
       },
       {
        "id": "Reproductions",
        "title": "Репродукции",
        "anyTags": [],
        "allTags": [
         "Reproduction"
        ]
       },
       {
        "id": "Canvas Painting",
        "title": "Canvas Painting",
        "anyTags": [],
        "allTags": [
         "Painting"
        ]
       }
      ]
     },
     {
      "id": "Decoration/Wall Art/Walldecor",
      "name": "Walldecor",
      "title": "Настенный декор",
      "photo": "/hp/catalog/tree/e28729f9d267.webp",
      "anyTags": [],
      "allTags": [
       "WallDecor"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Decoration/Wall Art/Posters",
      "name": "Posters",
      "title": "Плакаты",
      "photo": "/hp/catalog/tree/d735680fe38e.webp",
      "anyTags": [],
      "allTags": [
       "Poster"
      ],
      "sort": "PriceHigh",
      "filters": [
       {
        "id": "Celebrities",
        "title": "Звезды",
        "anyTags": [],
        "allTags": [
         "IconsPoster"
        ]
       },
       {
        "id": "Movies Poster",
        "title": "Фильмы,шоу",
        "anyTags": [],
        "allTags": [
         "MoviesPoster"
        ]
       },
       {
        "id": "Music Poster",
        "title": "Музыка",
        "anyTags": [],
        "allTags": [
         "MusicPoster"
        ]
       },
       {
        "id": "K-Pop Poster",
        "title": "Корейские",
        "anyTags": [],
        "allTags": [
         "KPopPoster"
        ]
       },
       {
        "id": "Anime Poster",
        "title": "Аниме",
        "anyTags": [],
        "allTags": [
         "AnimePoster"
        ]
       },
       {
        "id": "Plants Poster",
        "title": "Растения",
        "anyTags": [],
        "allTags": [
         "PlantsPoster"
        ]
       },
       {
        "id": "Fashion Poster",
        "title": "Мода",
        "anyTags": [],
        "allTags": [
         "FashionPoster"
        ]
       },
       {
        "id": "Wildlife Poster",
        "title": "Природа",
        "anyTags": [],
        "allTags": [
         "WildlifePoster"
        ]
       },
       {
        "id": "Minimalism Poster",
        "title": "Минимализм",
        "anyTags": [],
        "allTags": [
         "MinimalismPoster"
        ]
       },
       {
        "id": "Abstract Poster",
        "title": "Абстракция",
        "anyTags": [],
        "allTags": [
         "AbstractPoster"
        ]
       },
       {
        "id": "Typography Poster",
        "title": "Типографика",
        "anyTags": [],
        "allTags": [
         "TypographyPoster"
        ]
       },
       {
        "id": "Art Poster",
        "title": "Искусство",
        "anyTags": [],
        "allTags": [
         "ArtPoster"
        ]
       },
       {
        "id": "Vintage Poster",
        "title": "Винтаж",
        "anyTags": [],
        "allTags": [
         "VintagePoster"
        ]
       },
       {
        "id": "Cartoon Poster",
        "title": "Мультфильмы",
        "anyTags": [],
        "allTags": [
         "CartoonPoster"
        ]
       },
       {
        "id": "Sport Poster",
        "title": "Спорт",
        "anyTags": [],
        "allTags": [
         "SportPoster"
        ]
       },
       {
        "id": "Infographic",
        "title": "Инфографика",
        "anyTags": [],
        "allTags": [
         "Infographic"
        ]
       }
      ]
     },
     {
      "id": "Decoration/Wall Art/Wall Clocks",
      "name": "Wall Clocks",
      "title": "Настенные часы",
      "photo": "/hp/catalog/tree/1faa0869f270.webp",
      "anyTags": [],
      "allTags": [
       "WallClock"
      ]
     },
     {
      "id": "Decoration/Wall Art/Wall Stickers",
      "name": "Wall Stickers",
      "title": "Настенные наклейки",
      "photo": "/hp/catalog/tree/0d400a56b6fc.webp",
      "anyTags": [],
      "allTags": [
       "Sticker"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Decoration/Wall Art/Flags and Tapestries",
      "name": "Flags and Tapestries",
      "title": "Флаги и гобелены",
      "photo": "/hp/catalog/tree/8b0004b4e5f2.webp",
      "anyTags": [],
      "allTags": [
       "Flag"
      ]
     },
     {
      "id": "Decoration/Wall Art/Signboards",
      "name": "Signboards",
      "title": "Вывески",
      "photo": "/hp/catalog/tree/85ea69d08d99.webp",
      "anyTags": [
       "Signboards",
       "Sign"
      ],
      "allTags": [],
      "sort": "PriceHigh"
     }
    ]
   },
   {
    "id": "Decoration/Rugs",
    "name": "Rugs",
    "title": "Ковры",
    "photo": "/hp/catalog/tree/434df85fec9d.webp",
    "anyTags": [],
    "allTags": [
     "Rug"
    ],
    "filters": [
     {
      "id": "Regular Rug",
      "title": "Ковролин",
      "anyTags": [],
      "allTags": [
       "Carpet"
      ]
     },
     {
      "id": "Runner",
      "title": "Дорожка",
      "anyTags": [],
      "allTags": [
       "Runner"
      ]
     },
     {
      "id": "Round Rug",
      "title": "Круглый ковер",
      "anyTags": [],
      "allTags": [
       "RoundRug"
      ]
     },
     {
      "id": "Kids Rug",
      "title": "Детский коврик",
      "anyTags": [],
      "allTags": [
       "KidsRug"
      ]
     },
     {
      "id": "Door Mat",
      "title": "Дверной коврик",
      "anyTags": [],
      "allTags": [
       "DoorMat"
      ]
     },
     {
      "id": "Bath Mat",
      "title": "Коврик для ванной",
      "anyTags": [],
      "allTags": [
       "BathMat"
      ]
     },
     {
      "id": "Prayer Mat",
      "title": "Молитвенный коврик",
      "anyTags": [],
      "allTags": [
       "PrayerMat"
      ]
     },
     {
      "id": "Abstract Rug",
      "title": "Abstract Rug",
      "anyTags": [],
      "allTags": [
       "AbstractRug"
      ]
     }
    ]
   },
   {
    "id": "Decoration/Mirrors",
    "name": "Mirrors",
    "title": "Зеркала",
    "photo": "/hp/catalog/tree/f464b4f51666.webp",
    "children": [
     {
      "id": "Decoration/Mirrors/Wall Mirrors",
      "name": "Wall Mirrors",
      "title": "Настенные зеркала",
      "photo": "/hp/catalog/tree/f464b4f51666.webp",
      "anyTags": [
       "Mirror",
       "SquareMirror",
       "RectangleMirror",
       "RoundMirror",
       "OvalMirror",
       "AbstractMirror",
       "BacklightMirror",
       "KidsMirror",
       "ArchedMirror"
      ],
      "allTags": [],
      "filters": [
       {
        "id": "Square Mirrors",
        "title": "Квадратные зеркала",
        "anyTags": [],
        "allTags": [
         "SquareMirror"
        ]
       },
       {
        "id": "Rectangle Mirrors",
        "title": "Прямоугольные зеркала",
        "anyTags": [],
        "allTags": [
         "RectangleMirror"
        ]
       },
       {
        "id": "Round Mirrors",
        "title": "Круглые зеркала",
        "anyTags": [],
        "allTags": [
         "RoundMirror"
        ]
       },
       {
        "id": "Oval Mirrors",
        "title": "Овальные зеркала",
        "anyTags": [],
        "allTags": [
         "OvalMirror"
        ]
       },
       {
        "id": "Arched Mirrors",
        "title": "Арочные зеркала",
        "anyTags": [],
        "allTags": [
         "ArchedMirror"
        ]
       },
       {
        "id": "Accent Mirrors",
        "title": "Акцентные зеркала",
        "anyTags": [],
        "allTags": [
         "AbstractMirror"
        ]
       },
       {
        "id": "Kids Mirrors",
        "title": "Детские зеркала",
        "anyTags": [],
        "allTags": [
         "KidsMirror"
        ]
       },
       {
        "id": "Backlight Mirrors",
        "title": "Подсветка зеркал",
        "anyTags": [],
        "allTags": [
         "BacklightMirror"
        ]
       }
      ]
     },
     {
      "id": "Decoration/Mirrors/Floor Mirrors",
      "name": "Floor Mirrors",
      "title": "Напольные зеркала",
      "anyTags": [],
      "allTags": [
       "FloorMirror"
      ]
     },
     {
      "id": "Decoration/Mirrors/Table Mirrors",
      "name": "Table Mirrors",
      "title": "Настольные зеркала",
      "photo": "/hp/catalog/tree/755caa02ff41.webp",
      "anyTags": [],
      "allTags": [
       "TableMirror"
      ]
     }
    ]
   },
   {
    "id": "Decoration/Materials and Constructions",
    "name": "Materials and Constructions",
    "title": "Материалы и конструкции",
    "photo": "/hp/catalog/tree/906bc58185c9.webp",
    "children": [
     {
      "id": "Decoration/Materials and Constructions/Materials",
      "name": "Materials",
      "title": "Материалы",
      "photo": "/hp/catalog/tree/906bc58185c9.webp",
      "children": [
       {
        "id": "Decoration/Materials and Constructions/Materials/Other",
        "name": "Other",
        "title": "Другой",
        "photo": "/hp/catalog/tree/906bc58185c9.webp",
        "anyTags": [],
        "allTags": [
         "MaterialOther"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Wood",
        "name": "Wood",
        "title": "Дерево",
        "photo": "/hp/catalog/tree/41e845031787.webp",
        "anyTags": [],
        "allTags": [
         "MaterialWood"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Marble",
        "name": "Marble",
        "title": "Мрамор",
        "photo": "/hp/catalog/tree/39dfcf655bc0.webp",
        "anyTags": [],
        "allTags": [
         "MaterialMarble"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Tile",
        "name": "Tile",
        "title": "Плитка",
        "photo": "/hp/catalog/tree/e1897b268100.webp",
        "anyTags": [],
        "allTags": [
         "MaterialTile"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Slats",
        "name": "Slats",
        "title": "Ламели",
        "photo": "/hp/catalog/tree/d352584b5c5b.webp",
        "anyTags": [],
        "allTags": [
         "MaterialSlats"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Fabric",
        "name": "Fabric",
        "title": "Ткань",
        "photo": "/hp/catalog/tree/58df101a71cf.webp",
        "anyTags": [],
        "allTags": [
         "MaterialFabric"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Wallpapers",
        "name": "Wallpapers",
        "title": "Обои",
        "photo": "/hp/catalog/tree/dcaac6bf0405.webp",
        "anyTags": [],
        "allTags": [
         "MaterialWallpaper"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Finishes",
        "name": "Finishes",
        "title": "Отделка",
        "photo": "/hp/catalog/tree/604e8f8bc89b.webp",
        "anyTags": [],
        "allTags": [
         "MaterialFinishes"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Paneling",
        "name": "Paneling",
        "title": "Панели",
        "photo": "/hp/catalog/tree/3030edb035db.webp",
        "anyTags": [],
        "allTags": [
         "MaterialMoldings"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Parquet or Laminate",
        "name": "Parquet or Laminate",
        "title": "Паркет, ламинат",
        "photo": "/hp/catalog/tree/dc19cad4d593.webp",
        "anyTags": [],
        "allTags": [
         "MaterialParquetOrLaminate"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Glass",
        "name": "Glass",
        "title": "Стекло",
        "photo": "/hp/catalog/tree/7e8b217cd804.webp",
        "anyTags": [],
        "allTags": [
         "MaterialGlass"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Stone",
        "name": "Stone",
        "title": "Камень",
        "photo": "/hp/catalog/tree/ce8971d7501e.webp",
        "anyTags": [],
        "allTags": [
         "MaterialStone"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Bricks",
        "name": "Bricks",
        "title": "Кирпичи",
        "photo": "/hp/catalog/tree/cfbb39e9bae2.webp",
        "anyTags": [],
        "allTags": [
         "MaterialBricks"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Carpet",
        "name": "Carpet",
        "title": "Ковролин",
        "photo": "/hp/catalog/tree/ad2f48a1f3d2.webp",
        "anyTags": [],
        "allTags": [
         "MaterialCarpet"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/MaterialPlants",
        "name": "MaterialPlants",
        "title": "Растения",
        "photo": "/hp/catalog/tree/4517416a1b1e.webp",
        "anyTags": [],
        "allTags": [
         "MaterialLawn"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Metal",
        "name": "Metal",
        "title": "Металл",
        "photo": "/hp/catalog/tree/d71e88b81a79.webp",
        "anyTags": [],
        "allTags": [
         "MaterialMetal"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Photo Wallpaper",
        "name": "Photo Wallpaper",
        "title": "Фотообои",
        "photo": "/hp/catalog/tree/d1766a0c12c3.webp",
        "anyTags": [],
        "allTags": [
         "MaterialPhotoWallpaper"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Ground",
        "name": "Ground",
        "title": "Земля",
        "photo": "/hp/catalog/tree/813ee8c6aa7b.webp",
        "anyTags": [],
        "allTags": [
         "MaterialGround"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Granite",
        "name": "Granite",
        "title": "Гранит",
        "photo": "/hp/catalog/tree/ec3d46c92e6a.webp",
        "anyTags": [],
        "allTags": [
         "MaterialGranite"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Neon",
        "name": "Neon",
        "title": "Неон",
        "photo": "/hp/catalog/tree/958899333da9.webp",
        "anyTags": [],
        "allTags": [
         "MaterialNeon"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Water",
        "name": "Water",
        "title": "Вода",
        "photo": "/hp/catalog/tree/7fbcbbe744f2.webp",
        "anyTags": [],
        "allTags": [
         "MaterialWater"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Sky",
        "name": "Sky",
        "title": "Небо",
        "photo": "/hp/catalog/tree/5c1e52e8cdd2.webp",
        "anyTags": [],
        "allTags": [
         "MaterialSky"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Rattan",
        "name": "Rattan",
        "title": "Ротанг",
        "photo": "/hp/catalog/tree/0dcca90da1ee.webp",
        "anyTags": [],
        "allTags": [
         "MaterialRattan"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Leather",
        "name": "Leather",
        "title": "Кожа",
        "photo": "/hp/catalog/tree/8909d00d6111.webp",
        "anyTags": [],
        "allTags": [
         "MaterialLeather"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/Roof",
        "name": "Roof",
        "title": "Крыша",
        "photo": "/hp/catalog/tree/0e1100b68874.webp",
        "anyTags": [],
        "allTags": [
         "MaterialRoof"
        ]
       },
       {
        "id": "Decoration/Materials and Constructions/Materials/SciFi",
        "name": "SciFi",
        "title": "Sci-Fi",
        "photo": "/hp/catalog/tree/9e0949413a4f.webp",
        "anyTags": [],
        "allTags": [
         "MaterialSciFi"
        ]
       }
      ]
     },
     {
      "id": "Decoration/Materials and Constructions/Columns",
      "name": "Columns",
      "title": "Колонны",
      "photo": "/hp/catalog/tree/43cf89b9b516.webp",
      "anyTags": [],
      "allTags": [
       "Column"
      ]
     },
     {
      "id": "Decoration/Materials and Constructions/Screens, Paravents",
      "name": "Screens, Paravents",
      "title": "Ширмы, паравенты",
      "photo": "/hp/catalog/tree/0f7d83978533.webp",
      "anyTags": [],
      "allTags": [
       "RoomDivider"
      ]
     },
     {
      "id": "Decoration/Materials and Constructions/PlinthsAndMoldings",
      "name": "PlinthsAndMoldings",
      "title": "Плинтусы и молдинги",
      "photo": "/hp/catalog/tree/ae2ca04c00aa.webp",
      "children": [
       {
        "id": "Decoration/Materials and Constructions/PlinthsAndMoldings/Moldings",
        "name": "Moldings",
        "title": "Молдинги",
        "photo": "/hp/catalog/tree/ae2ca04c00aa.webp",
        "anyTags": [
         "Molding",
         "Moldings"
        ],
        "allTags": []
       }
      ]
     },
     {
      "id": "Decoration/Materials and Constructions/DecorCeiling",
      "name": "DecorCeiling",
      "title": "Потолочные украшения",
      "photo": "/hp/catalog/tree/c8db746e568a.webp",
      "anyTags": [],
      "allTags": [
       "CeilingDecor"
      ],
      "sort": "PriceHigh"
     }
    ]
   },
   {
    "id": "Decoration/Table Decor",
    "name": "Table Decor",
    "title": "Декор для стола",
    "photo": "/hp/catalog/tree/396ffdb8c17c.webp",
    "children": [
     {
      "id": "Decoration/Table Decor/Vases",
      "name": "Vases",
      "title": "Вазы",
      "photo": "/hp/catalog/tree/43976af69ac3.webp",
      "anyTags": [],
      "allTags": [
       "Vase"
      ]
     },
     {
      "id": "Decoration/Table Decor/Room decor",
      "name": "Room decor",
      "title": "Декор",
      "photo": "/hp/catalog/tree/87b4d6bbfd59.webp",
      "anyTags": [],
      "allTags": [
       "RoomDecor"
      ]
     },
     {
      "id": "Decoration/Table Decor/Candles",
      "name": "Candles",
      "title": "Свечи",
      "photo": "/hp/catalog/tree/f015d97fd712.webp",
      "anyTags": [],
      "allTags": [
       "Candle"
      ]
     },
     {
      "id": "Decoration/Table Decor/Statues",
      "name": "Statues",
      "title": "Статуи",
      "photo": "/hp/catalog/tree/7fa289b9033f.webp",
      "anyTags": [],
      "allTags": [
       "Statue"
      ]
     },
     {
      "id": "Decoration/Table Decor/Tableware",
      "name": "Tableware",
      "title": "Столовая посуда",
      "photo": "/hp/catalog/tree/5ab6c6ad728a.webp",
      "children": [
       {
        "id": "Decoration/Table Decor/Tableware/Cups and glasses",
        "name": "Cups and glasses",
        "title": "Чашки и стаканы",
        "photo": "/hp/catalog/tree/5ab6c6ad728a.webp",
        "anyTags": [],
        "allTags": [
         "CupsMugs"
        ]
       },
       {
        "id": "Decoration/Table Decor/Tableware/Plates",
        "name": "Plates",
        "title": "Тарелки",
        "photo": "/hp/catalog/tree/8a1bcdd87d20.webp",
        "anyTags": [],
        "allTags": [
         "Plates"
        ]
       },
       {
        "id": "Decoration/Table Decor/Tableware/Drinks",
        "name": "Drinks",
        "title": "Напитки",
        "photo": "/hp/catalog/tree/f65b4807b191.webp",
        "anyTags": [],
        "allTags": [
         "Drinks"
        ]
       },
       {
        "id": "Decoration/Table Decor/Tableware/Serving",
        "name": "Serving",
        "title": "Сервировка",
        "photo": "/hp/catalog/tree/98c946e48d12.webp",
        "anyTags": [],
        "allTags": [
         "DiningServing"
        ]
       },
       {
        "id": "Decoration/Table Decor/Tableware/Desserts",
        "name": "Desserts",
        "title": "Десерты",
        "photo": "/hp/catalog/tree/0cbf044cb75f.webp",
        "anyTags": [],
        "allTags": [
         "Desserts"
        ]
       },
       {
        "id": "Decoration/Table Decor/Tableware/Food",
        "name": "Food",
        "title": "Еда",
        "photo": "/hp/catalog/tree/920b623e3a11.webp",
        "anyTags": [],
        "allTags": [
         "KitchenFood"
        ]
       }
      ]
     },
     {
      "id": "Decoration/Table Decor/Table Clocks",
      "name": "Table Clocks",
      "title": "Настольные часы",
      "photo": "/hp/catalog/tree/11c602e8ccca.webp",
      "anyTags": [],
      "allTags": [
       "Clock"
      ]
     },
     {
      "id": "Decoration/Table Decor/Table Mirrors",
      "name": "Table Mirrors",
      "title": "Зеркала",
      "photo": "/hp/catalog/tree/cd21f9a0aa0c.webp",
      "anyTags": [],
      "allTags": [
       "TableMirror"
      ]
     }
    ]
   },
   {
    "id": "Decoration/Work and Study",
    "name": "Work and Study",
    "title": "Работа и учеба",
    "photo": "/hp/catalog/tree/3f0c449f77a0.webp",
    "children": [
     {
      "id": "Decoration/Work and Study/Books",
      "name": "Books",
      "title": "Книги",
      "photo": "/hp/catalog/tree/3f0c449f77a0.webp",
      "anyTags": [],
      "allTags": [
       "Books"
      ]
     },
     {
      "id": "Decoration/Work and Study/Office Accessories",
      "name": "Office Accessories",
      "title": "Офисный декор",
      "photo": "/hp/catalog/tree/689b686b96de.webp",
      "anyTags": [],
      "allTags": [
       "OfficeDecor"
      ]
     },
     {
      "id": "Decoration/Work and Study/Memo Boards",
      "name": "Memo Boards",
      "title": "Доска для заметок",
      "photo": "/hp/catalog/tree/8dcf68da4f5c.webp",
      "anyTags": [],
      "allTags": [
       "MemoBoard"
      ]
     },
     {
      "id": "Decoration/Work and Study/Clocks",
      "name": "Clocks",
      "title": "Часы",
      "photo": "/hp/catalog/tree/1faa0869f270.webp",
      "anyTags": [
       "Clock",
       "WallClock"
      ],
      "allTags": []
     },
     {
      "id": "Decoration/Work and Study/Whiteboards",
      "name": "Whiteboards",
      "title": "Доски",
      "photo": "/hp/catalog/tree/19a02bfabb73.webp",
      "anyTags": [],
      "allTags": [
       "Whiteboard"
      ]
     }
    ]
   },
   {
    "id": "Decoration/Organizers and Bins",
    "name": "Organizers and Bins",
    "title": "Органайзеры и ящики",
    "photo": "/hp/catalog/tree/1ae746753d48.webp",
    "children": [
     {
      "id": "Decoration/Organizers and Bins/Decorative Baskets",
      "name": "Decorative Baskets",
      "title": "Декоративные корзины",
      "photo": "/hp/catalog/tree/1ae746753d48.webp",
      "anyTags": [],
      "allTags": [
       "Basket"
      ]
     },
     {
      "id": "Decoration/Organizers and Bins/Trash bin",
      "name": "Trash bin",
      "title": "Мусорные ведра",
      "photo": "/hp/catalog/tree/98105a2a6844.webp",
      "anyTags": [],
      "allTags": [
       "TrashCan"
      ]
     },
     {
      "id": "Decoration/Organizers and Bins/Storage Boxes",
      "name": "Storage Boxes",
      "title": "Ящики для хранения",
      "photo": "/hp/catalog/tree/dfa00044688d.webp",
      "anyTags": [],
      "allTags": [
       "Box"
      ]
     },
     {
      "id": "Decoration/Organizers and Bins/Tray",
      "name": "Tray",
      "title": "Подносы",
      "photo": "/hp/catalog/tree/5f2e86872e2d.webp",
      "anyTags": [],
      "allTags": [
       "Tray"
      ]
     }
    ]
   },
   {
    "id": "Decoration/Kids Decor",
    "name": "Kids Decor",
    "title": "Детский декор",
    "photo": "/hp/catalog/tree/f1b889102b5a.webp",
    "children": [
     {
      "id": "Decoration/Kids Decor/Toys",
      "name": "Toys",
      "title": "Игрушки",
      "photo": "/hp/catalog/tree/f1b889102b5a.webp",
      "anyTags": [],
      "allTags": [
       "Toys"
      ]
     },
     {
      "id": "Decoration/Kids Decor/KidsDecor",
      "name": "KidsDecor",
      "title": "Детский декор",
      "photo": "/hp/catalog/tree/5656699ca4d9.webp",
      "anyTags": [],
      "allTags": [
       "KidsDecor"
      ]
     },
     {
      "id": "Decoration/Kids Decor/Kids Art",
      "name": "Kids Art",
      "title": "Детские картины",
      "photo": "/hp/catalog/tree/ae5f6fcef706.webp",
      "anyTags": [],
      "allTags": [
       "KidsArt"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Decoration/Kids Decor/Kids Rugs",
      "name": "Kids Rugs",
      "title": "Детские коврики",
      "photo": "/hp/catalog/tree/9ffd7938c423.webp",
      "anyTags": [],
      "allTags": [
       "KidsRug"
      ]
     },
     {
      "id": "Decoration/Kids Decor/Kids Mirrors",
      "name": "Kids Mirrors",
      "title": "Детские зеркала",
      "photo": "/hp/catalog/tree/d1ae9b6f95fa.webp",
      "anyTags": [],
      "allTags": [
       "KidsMirror"
      ]
     }
    ]
   },
   {
    "id": "Decoration/Curtains and Dividers",
    "name": "Curtains and Dividers",
    "title": "Шторы и перегородки",
    "photo": "/hp/catalog/tree/455b1db06c4a.webp",
    "children": [
     {
      "id": "Decoration/Curtains and Dividers/CeilingCurtains",
      "name": "CeilingCurtains",
      "title": "Потолочные шторы",
      "photo": "/hp/catalog/tree/127483acf83e.webp",
      "anyTags": [],
      "allTags": [
       "CurtainsCeiling"
      ]
     },
     {
      "id": "Decoration/Curtains and Dividers/Window Curtains",
      "name": "Window Curtains",
      "title": "Оконные шторы",
      "photo": "/hp/catalog/tree/071a573a2d16.webp",
      "anyTags": [
       "Curtains",
       "CurtainsWall"
      ],
      "allTags": []
     },
     {
      "id": "Decoration/Curtains and Dividers/Screens, Paravents",
      "name": "Screens, Paravents",
      "title": "Ширмы, паравенты",
      "photo": "/hp/catalog/tree/0f7d83978533.webp",
      "anyTags": [],
      "allTags": [
       "RoomDivider"
      ]
     }
    ]
   },
   {
    "id": "Decoration/Characters and Pets",
    "name": "Characters and Pets",
    "title": "Персонажи и питомцы",
    "photo": "/hp/catalog/tree/1a3a3ce1e46d.webp",
    "children": [
     {
      "id": "Decoration/Characters and Pets/Pets",
      "name": "Pets",
      "title": "Животные",
      "photo": "/hp/catalog/tree/45c4ef65ff52.webp",
      "anyTags": [],
      "allTags": [
       "AllPets"
      ],
      "filters": [
       {
        "id": "Cat",
        "title": "Кот",
        "anyTags": [],
        "allTags": [
         "Cat"
        ]
       },
       {
        "id": "Dog",
        "title": "Собака",
        "anyTags": [],
        "allTags": [
         "Dog"
        ]
       },
       {
        "id": "Fish",
        "title": "Fish",
        "anyTags": [
         "FishTank",
         "Aquarium"
        ],
        "allTags": []
       },
       {
        "id": "Other Pets",
        "title": "Other Pets",
        "anyTags": [],
        "allTags": [
         "Pet"
        ]
       }
      ]
     },
     {
      "id": "Decoration/Characters and Pets/Characters",
      "name": "Characters",
      "title": "Персонажи",
      "photo": "/hp/catalog/tree/aacb1b38ddcf.webp",
      "anyTags": [
       "People",
       "CharacterOther"
      ],
      "allTags": [],
      "filters": [
       {
        "id": "Men",
        "title": "Мужчины",
        "anyTags": [],
        "allTags": [
         "Man"
        ]
       },
       {
        "id": "Women",
        "title": "Женщины",
        "anyTags": [],
        "allTags": [
         "Woman"
        ]
       },
       {
        "id": "Kids",
        "title": "Дети",
        "anyTags": [],
        "allTags": [
         "Kid"
        ]
       },
       {
        "id": "Groups",
        "title": "Группы",
        "anyTags": [],
        "allTags": [
         "Groups"
        ]
       },
       {
        "id": "Special Characters",
        "title": "Особое",
        "anyTags": [],
        "allTags": [
         "CharacterOther"
        ]
       }
      ]
     },
     {
      "id": "Decoration/Characters and Pets/Pet Supplies",
      "name": "Pet Supplies",
      "title": "Товары для питомцев",
      "photo": "/hp/catalog/tree/a11a25b3bcdf.webp",
      "anyTags": [],
      "allTags": [
       "AnimalFurniture"
      ],
      "filters": [
       {
        "id": "Pet Bed",
        "title": "Beds",
        "anyTags": [],
        "allTags": [
         "PetBed"
        ]
       },
       {
        "id": "Pet House",
        "title": "Домик для питомца",
        "anyTags": [],
        "allTags": [
         "PetHouse"
        ]
       },
       {
        "id": "Pet Feeder",
        "title": "Кормушка для питомца",
        "anyTags": [],
        "allTags": [
         "PetFeeder"
        ]
       },
       {
        "id": "Pet Accessories",
        "title": "Аксессуары",
        "anyTags": [],
        "allTags": [
         "PetItem"
        ]
       }
      ]
     }
    ]
   },
   {
    "id": "Decoration/Holiday Decor",
    "name": "Holiday Decor",
    "title": "Праздничный декор",
    "photo": "/hp/catalog/tree/c6194c175076.webp",
    "children": [
     {
      "id": "Decoration/Holiday Decor/Wedding",
      "name": "Wedding",
      "title": "Свадьба",
      "photo": "/hp/catalog/tree/504b334dd0dd.webp",
      "anyTags": [],
      "allTags": [
       "Wedding"
      ]
     },
     {
      "id": "Decoration/Holiday Decor/Christmas",
      "name": "Christmas",
      "title": "Рождество",
      "photo": "/hp/catalog/tree/a6789a6a7081.webp",
      "anyTags": [
       "Christmas",
       "XmasFireplace"
      ],
      "allTags": []
     },
     {
      "id": "Decoration/Holiday Decor/Halloween",
      "name": "Halloween",
      "title": "Хеллоуин",
      "photo": "/hp/catalog/tree/a9b7d7fc1f79.webp",
      "anyTags": [],
      "allTags": [
       "Halloween"
      ]
     }
    ]
   }
  ]
 },
 {
  "id": "Storage",
  "name": "Storage",
  "title": "Шкафы, полки",
  "photo": "/hp/catalog/tree/d82562f1249a.webp",
  "children": [
   {
    "id": "Storage/Wardrobe",
    "name": "Wardrobe",
    "title": "Шкаф-купе",
    "photo": "/hp/catalog/tree/d82562f1249a.webp",
    "anyTags": [
     "Wardrobe",
     "BuiltinWardrobe"
    ],
    "allTags": [],
    "filters": [
     {
      "id": "Sliding Door Wardrobe",
      "title": "Шкаф-купе",
      "anyTags": [],
      "allTags": [
       "SlidingWardrobe"
      ]
     },
     {
      "id": "Clothes Rack",
      "title": "Вешалка",
      "anyTags": [],
      "allTags": [
       "ClothesRack"
      ]
     },
     {
      "id": "Wardrobe cabinet",
      "title": "Шкаф-гардероб",
      "anyTags": [],
      "allTags": [
       "WardrobeCabinet"
      ]
     },
     {
      "id": "Wardrobe System",
      "title": "Гардеробная система",
      "anyTags": [],
      "allTags": [
       "WardrobeSystem"
      ]
     }
    ]
   },
   {
    "id": "Storage/Base Cabinets",
    "name": "Base Cabinets",
    "title": "Нижние шкафы",
    "photo": "/hp/catalog/tree/e559c69b4dc1.webp",
    "anyTags": [],
    "allTags": [
     "BaseCabinet"
    ]
   },
   {
    "id": "Storage/Sink",
    "name": "Sink",
    "title": "Раковина",
    "photo": "/hp/catalog/tree/310eb0ef313f.webp",
    "anyTags": [],
    "allTags": [
     "Sink"
    ]
   },
   {
    "id": "Storage/Shelving",
    "name": "Shelving",
    "title": "Стеллаж",
    "photo": "/hp/catalog/tree/a40c3c1b11e4.webp",
    "anyTags": [],
    "allTags": [
     "Shelving"
    ],
    "filters": [
     {
      "id": "Bookshelve",
      "title": "Книжная полка",
      "anyTags": [],
      "allTags": [
       "Bookshelve"
      ]
     },
     {
      "id": "Pantry",
      "title": "Стеллаж",
      "anyTags": [],
      "allTags": [
       "Pantry"
      ]
     },
     {
      "id": "Wall pantry",
      "title": "Настенный пенал",
      "anyTags": [],
      "allTags": [
       "PantryWall"
      ]
     },
     {
      "id": "Storage rack",
      "title": "Стеллаж",
      "anyTags": [],
      "allTags": [
       "StorageRack"
      ]
     },
     {
      "id": "Corner shelves",
      "title": "Угловые полки",
      "anyTags": [],
      "allTags": [
       "CornerShelves"
      ]
     },
     {
      "id": "Ladder shelf",
      "title": "Полка-лестница",
      "anyTags": [],
      "allTags": [
       "LadderShelf"
      ]
     },
     {
      "id": "Lower Shelving",
      "title": "Нижние полки",
      "anyTags": [],
      "allTags": [
       "LowerShelving"
      ]
     }
    ]
   },
   {
    "id": "Storage/Wall shelve",
    "name": "Wall shelve",
    "title": "Настенная полка",
    "photo": "/hp/catalog/tree/902b76f73da3.webp",
    "anyTags": [],
    "allTags": [
     "WallShelve"
    ],
    "filters": [
     {
      "id": "Corner shelve",
      "title": "Угловая полка",
      "anyTags": [],
      "allTags": [
       "CornerShelve"
      ]
     },
     {
      "id": "Art shelve",
      "title": "Арт-полка",
      "anyTags": [],
      "allTags": [
       "ArtShelve"
      ]
     },
     {
      "id": "Paper shelve",
      "title": "Полка для бумаги",
      "anyTags": [],
      "allTags": [
       "PapersShelve"
      ]
     },
     {
      "id": "Square shelve",
      "title": "Квадратная полка",
      "anyTags": [],
      "allTags": [
       "SquareShelve"
      ]
     },
     {
      "id": "Open shelve",
      "title": "Открытая полка",
      "anyTags": [],
      "allTags": [
       "OpenShelve"
      ]
     },
     {
      "id": "Closed shelve",
      "title": "Закрытая полка",
      "anyTags": [],
      "allTags": [
       "ClosedShelve"
      ]
     },
     {
      "id": "Kitchen shelve",
      "title": "Кухонная полка",
      "anyTags": [],
      "allTags": [
       "KitchenShelf"
      ]
     },
     {
      "id": "Storage unit",
      "title": "Модуль хранения",
      "anyTags": [],
      "allTags": [
       "StorageUnit"
      ]
     }
    ]
   },
   {
    "id": "Storage/Kitchen Island",
    "name": "Kitchen Island",
    "title": "Кухонный остров",
    "photo": "/hp/catalog/tree/59f07742ae68.webp",
    "anyTags": [],
    "allTags": [
     "KitchenIsland"
    ]
   },
   {
    "id": "Storage/TV Storage",
    "name": "TV Storage",
    "title": "Хранение ТВ",
    "photo": "/hp/catalog/tree/5a605a417aac.webp",
    "anyTags": [],
    "allTags": [
     "TVfurniture"
    ],
    "filters": [
     {
      "id": "TV Stands",
      "title": "TV Stands",
      "anyTags": [],
      "allTags": [
       "TVStand"
      ]
     },
     {
      "id": "Wall Units",
      "title": "Wall Units",
      "anyTags": [],
      "allTags": [
       "TVStorage"
      ]
     },
     {
      "id": "Entertainment Centers",
      "title": "Entertainment Centers",
      "anyTags": [],
      "allTags": [
       "TVset"
      ]
     }
    ]
   },
   {
    "id": "Storage/Wall Cabinets",
    "name": "Wall Cabinets",
    "title": "Настенные шкафы",
    "photo": "/hp/catalog/tree/7c2d8b91310d.webp",
    "anyTags": [],
    "allTags": [
     "WallCabinet"
    ]
   },
   {
    "id": "Storage/Built In Storage",
    "name": "Built In Storage",
    "title": "Встроенное хранение",
    "photo": "/hp/catalog/tree/0fec3ac4f768.webp",
    "anyTags": [
     "WallStorage",
     "BuiltinWardrobe"
    ],
    "allTags": []
   },
   {
    "id": "Storage/Dressers",
    "name": "Dressers",
    "title": "Ящики",
    "photo": "/hp/catalog/tree/48f0756855c9.webp",
    "anyTags": [],
    "allTags": [
     "Drawers"
    ],
    "filters": [
     {
      "id": "Drawer",
      "title": "Комод",
      "anyTags": [],
      "allTags": [
       "Drawer"
      ]
     },
     {
      "id": "Drawer Chest",
      "title": "Комод",
      "anyTags": [],
      "allTags": [
       "ChestOfDrawers"
      ]
     },
     {
      "id": "Dresser",
      "title": "Комод",
      "anyTags": [],
      "allTags": [
       "Dresser"
      ]
     }
    ]
   },
   {
    "id": "Storage/CabinetsRegular",
    "name": "CabinetsRegular",
    "title": "Шкафчики",
    "photo": "/hp/catalog/tree/3f4234cf0fde.webp",
    "anyTags": [
     "Cabinet",
     "Secretary",
     "CornerCabinetLow",
     "StaircaseCabinet"
    ],
    "allTags": [],
    "filters": [
     {
      "id": "Secretary",
      "title": "Письменный стол",
      "anyTags": [],
      "allTags": [
       "Secretary"
      ]
     },
     {
      "id": "Corner cabinet Low",
      "title": "Угловой шкаф",
      "anyTags": [],
      "allTags": [
       "CornerCabinetLow"
      ]
     },
     {
      "id": "Staircase cabinet",
      "title": "Шкаф-лестница",
      "anyTags": [],
      "allTags": [
       "StaircaseCabinet"
      ]
     }
    ]
   },
   {
    "id": "Storage/Shoe storage",
    "name": "Shoe storage",
    "title": "Обувные шкафы",
    "photo": "/hp/catalog/tree/615480943967.webp",
    "anyTags": [],
    "allTags": [
     "ShoeCabinet"
    ],
    "filters": [
     {
      "id": "Shoe Rack",
      "title": "Обувная полка",
      "anyTags": [],
      "allTags": [
       "ShoeRack"
      ]
     },
     {
      "id": "Shoe Benches",
      "title": "Обувные скамьи",
      "anyTags": [],
      "allTags": [
       "ShoeBench"
      ]
     },
     {
      "id": "Shoe Tower",
      "title": "Высокие обувницы",
      "anyTags": [],
      "allTags": [
       "ShoeTower"
      ]
     },
     {
      "id": "Mounted Unit",
      "title": "Обувница",
      "anyTags": [],
      "allTags": [
       "ShoeWallUnit"
      ]
     },
     {
      "id": "Shoe Organizer",
      "title": "Органайзер для обуви",
      "anyTags": [],
      "allTags": [
       "ShoeOrganizer"
      ]
     }
    ]
   },
   {
    "id": "Storage/WallCabinetsRegular",
    "name": "WallCabinetsRegular",
    "title": "Навесные шкафы",
    "photo": "/hp/catalog/tree/5c2fb14cbf52.webp",
    "anyTags": [],
    "allTags": [
     "WallCabinetRegular"
    ],
    "filters": [
     {
      "id": "Single Door Cabinets",
      "title": "Однодверный",
      "anyTags": [],
      "allTags": [
       "WallCabinetSingle"
      ]
     },
     {
      "id": "Double Door Cabinets",
      "title": "Двухдверный",
      "anyTags": [],
      "allTags": [
       "WallCabinetDouble"
      ]
     },
     {
      "id": "Glass Door Cabinets",
      "title": "Стеклянные",
      "anyTags": [],
      "allTags": [
       "WallCabinetGlass"
      ]
     },
     {
      "id": "Mirrored Door Cabinets",
      "title": "С зеркалом",
      "anyTags": [],
      "allTags": [
       "WallCabinetMirror"
      ]
     },
     {
      "id": "Open Shelve Cabinets",
      "title": "С полками",
      "anyTags": [],
      "allTags": [
       "WallCabinetShelves"
      ]
     },
     {
      "id": "Corner Cabinets",
      "title": "Угловые шкафы",
      "anyTags": [],
      "allTags": [
       "WallCabinetCorner"
      ]
     },
     {
      "id": "Cabinet Sets",
      "title": "Комплекты шкафов",
      "anyTags": [],
      "allTags": [
       "WallCabinetSets"
      ]
     }
    ]
   },
   {
    "id": "Storage/Countertops",
    "name": "Countertops",
    "title": "Столешницы",
    "photo": "/hp/catalog/tree/1a68d5901bf5.webp",
    "anyTags": [],
    "allTags": [
     "Countertop"
    ]
   },
   {
    "id": "Storage/Clothes",
    "name": "Clothes",
    "title": "Одежда",
    "photo": "/hp/catalog/tree/048c152732cc.webp",
    "anyTags": [],
    "allTags": [
     "Clothes"
    ],
    "filters": [
     {
      "id": "Cloth",
      "title": "Одежда",
      "anyTags": [],
      "allTags": [
       "Cloth"
      ]
     },
     {
      "id": "Shoes",
      "title": "Shoes",
      "anyTags": [],
      "allTags": [
       "Shoes"
      ]
     },
     {
      "id": "Bags",
      "title": "Сумки",
      "anyTags": [],
      "allTags": [
       "Bags"
      ]
     },
     {
      "id": "Hats",
      "title": "Головные уборы",
      "anyTags": [],
      "allTags": [
       "Hats"
      ]
     },
     {
      "id": "Accessories",
      "title": "Аксессуары",
      "anyTags": [],
      "allTags": [
       "Accessories"
      ]
     }
    ]
   },
   {
    "id": "Storage/High Cabinets",
    "name": "High Cabinets",
    "title": "Высокие шкафы",
    "photo": "/hp/catalog/tree/2b4c526cdc0e.webp",
    "anyTags": [],
    "allTags": [
     "HighCabinet"
    ]
   },
   {
    "id": "Storage/HighCabinetsRegular",
    "name": "HighCabinetsRegular",
    "title": "High cabinets",
    "photo": "/hp/catalog/tree/90e7bc06ed02.webp",
    "anyTags": [],
    "allTags": [
     "HighCab"
    ],
    "filters": [
     {
      "id": "Single High Cabinets",
      "title": "Одинарные высокие шкафы",
      "anyTags": [],
      "allTags": [
       "SingleHighCabinet"
      ]
     },
     {
      "id": "Double High Cabinets",
      "title": "Двойные высокие шкафы",
      "anyTags": [],
      "allTags": [
       "DoubleHighCabinet"
      ]
     },
     {
      "id": "Open High Cabinets",
      "title": "Открытые высокие шкафы",
      "anyTags": [],
      "allTags": [
       "OpenHighCabinet"
      ]
     }
    ]
   },
   {
    "id": "Storage/Tall cabinets",
    "name": "Tall cabinets",
    "title": "Высокие шкафы",
    "photo": "/hp/catalog/tree/bb1feb8a3daa.webp",
    "anyTags": [],
    "allTags": [
     "CabinetTall"
    ],
    "filters": [
     {
      "id": "Bookcase",
      "title": "Книжный шкаф",
      "anyTags": [],
      "allTags": [
       "Bookcase"
      ]
     },
     {
      "id": "Corner cabinet High",
      "title": "Угловой шкаф",
      "anyTags": [],
      "allTags": [
       "CornerCabinetHigh"
      ]
     }
    ]
   },
   {
    "id": "Storage/Coat stand",
    "name": "Coat stand",
    "title": "Вешалка",
    "photo": "/hp/catalog/tree/753a00903e2c.webp",
    "anyTags": [],
    "allTags": [
     "CoatStand"
    ],
    "filters": [
     {
      "id": "Free-standing",
      "title": "Напольная вешалка",
      "anyTags": [],
      "allTags": [
       "FreeCoatStand"
      ]
     },
     {
      "id": "Hallway Units",
      "title": "Прихожие модули",
      "anyTags": [],
      "allTags": [
       "HallwayUnits"
      ]
     },
     {
      "id": "Umbrella Stand",
      "title": "Подставка для зонтов",
      "anyTags": [],
      "allTags": [
       "UmbrellaStand"
      ]
     }
    ]
   },
   {
    "id": "Storage/Hanger",
    "name": "Hanger",
    "title": "Вешалка",
    "photo": "/hp/catalog/tree/1f543a021d43.webp",
    "anyTags": [],
    "allTags": [
     "Hanger"
    ],
    "filters": [
     {
      "id": "Hooks",
      "title": "Крючки",
      "anyTags": [],
      "allTags": [
       "Hook"
      ]
     },
     {
      "id": "Hook Rails",
      "title": "Рейки с крючками",
      "anyTags": [],
      "allTags": [
       "HookRail"
      ]
     },
     {
      "id": "Wall Mount Hanger",
      "title": "Настенная вешалка",
      "anyTags": [],
      "allTags": [
       "WallHanger"
      ]
     },
     {
      "id": "Accent Hanger",
      "title": "Акцентная вешалка",
      "anyTags": [],
      "allTags": [
       "AccentHanger"
      ]
     }
    ]
   },
   {
    "id": "Storage/Moldings",
    "name": "Moldings",
    "title": "Молдинги",
    "photo": "/hp/catalog/tree/ae2ca04c00aa.webp",
    "anyTags": [
     "Molding",
     "Moldings"
    ],
    "allTags": []
   },
   {
    "id": "Storage/Hutch",
    "name": "Hutch",
    "title": "Сервант",
    "photo": "/hp/catalog/tree/44cb662aac22.webp",
    "anyTags": [],
    "allTags": [
     "Hutch"
    ]
   },
   {
    "id": "Storage/Office storage",
    "name": "Office storage",
    "title": "Офисные стеллажи",
    "photo": "/hp/catalog/tree/c1a2b0725cd9.webp",
    "anyTags": [],
    "allTags": [
     "OfficeStorage"
    ]
   },
   {
    "id": "Storage/Kids Storage",
    "name": "Kids Storage",
    "title": "Детские шкафы",
    "photo": "/hp/catalog/tree/8ec7f0ddf28c.webp",
    "anyTags": [],
    "allTags": [
     "KidsStorage"
    ]
   },
   {
    "id": "Storage/Showcase",
    "name": "Showcase",
    "title": "Витрина",
    "photo": "/hp/catalog/tree/c77091880f88.webp",
    "anyTags": [],
    "allTags": [
     "Showcase"
    ]
   },
   {
    "id": "Storage/Locker",
    "name": "Locker",
    "title": "Шкафчик",
    "photo": "/hp/catalog/tree/c117cf070576.webp",
    "anyTags": [],
    "allTags": [
     "Locker"
    ]
   },
   {
    "id": "Storage/Sideboards",
    "name": "Sideboards",
    "title": "Тумба",
    "photo": "/hp/catalog/tree/5f4c6265e35d.webp",
    "anyTags": [],
    "allTags": [
     "Sideboards"
    ],
    "filters": [
     {
      "id": "Sideboard",
      "title": "Тумба",
      "anyTags": [],
      "allTags": [
       "Sideboard"
      ]
     },
     {
      "id": "Console Table",
      "title": "Console Table",
      "anyTags": [],
      "allTags": [
       "ConsoleTable"
      ]
     },
     {
      "id": "Credenza",
      "title": "Буфет",
      "anyTags": [],
      "allTags": [
       "Credenza"
      ]
     },
     {
      "id": "Server",
      "title": "Сервер",
      "anyTags": [],
      "allTags": [
       "Server"
      ]
     },
     {
      "id": "Buffet",
      "title": "Буфет",
      "anyTags": [],
      "allTags": [
       "Buffet"
      ]
     }
    ]
   },
   {
    "id": "Storage/Room divider",
    "name": "Room divider",
    "title": "Перегородка",
    "photo": "/hp/catalog/tree/c37af491031d.webp",
    "anyTags": [],
    "allTags": [
     "RoomDivider"
    ],
    "filters": [
     {
      "id": "Room partition",
      "title": "Перегородка",
      "anyTags": [],
      "allTags": [
       "RoomPartition"
      ]
     },
     {
      "id": "Paravent",
      "title": "Паравент",
      "anyTags": [],
      "allTags": [
       "Paravent"
      ]
     },
     {
      "id": "Storage partition",
      "title": "Стеллаж-перегородка",
      "anyTags": [],
      "allTags": [
       "RoomDividerStorage"
      ]
     }
    ]
   },
   {
    "id": "Storage/Knobs,handles",
    "name": "Knobs,handles",
    "title": "Ручки",
    "photo": "/hp/catalog/tree/2c48c3265c0a.webp",
    "anyTags": [],
    "allTags": [
     "Knob"
    ],
    "filters": [
     {
      "id": "Entry Locks",
      "title": "Дверные замки",
      "anyTags": [],
      "allTags": [
       "EntryLocks"
      ]
     },
     {
      "id": "Door Levers",
      "title": "Дверные ручки",
      "anyTags": [],
      "allTags": [
       "DoorLevers"
      ]
     },
     {
      "id": "Cabinet Pulls",
      "title": "Ручки шкафов",
      "anyTags": [],
      "allTags": [
       "CabinetPulls"
      ]
     },
     {
      "id": "Cabinet Knobs",
      "title": "Ручки-кнопки шкафов",
      "anyTags": [],
      "allTags": [
       "CabinetKnobs"
      ]
     }
    ]
   },
   {
    "id": "Storage/Wine Cabinets",
    "name": "Wine Cabinets",
    "title": "Винные шкафы",
    "photo": "/hp/catalog/tree/281d2a7ca7fc.webp",
    "anyTags": [],
    "allTags": [
     "WineCabinet"
    ]
   },
   {
    "id": "Storage/Kitchen Cart",
    "name": "Kitchen Cart",
    "title": "Кухонная тележка",
    "photo": "/hp/catalog/tree/dae9bd9f2a60.webp",
    "anyTags": [],
    "allTags": [
     "KitchenCart"
    ]
   }
  ]
 },
 {
  "id": "TablesAndChairs",
  "name": "TablesAndChairs",
  "title": "Столы и стулья",
  "photo": "/hp/catalog/tree/e3250a69e1eb.webp",
  "children": [
   {
    "id": "TablesAndChairs/Desk",
    "name": "Desk",
    "title": "Рабочий стол",
    "photo": "/hp/catalog/tree/e3250a69e1eb.webp",
    "anyTags": [],
    "allTags": [
     "Desk"
    ],
    "filters": [
     {
      "id": "Writing Desk",
      "title": "Письменный стол",
      "anyTags": [],
      "allTags": [
       "ClassicDesk"
      ]
     },
     {
      "id": "Executive Desk",
      "title": "Представительский стол",
      "anyTags": [],
      "allTags": [
       "StorageDesk"
      ]
     },
     {
      "id": "Simple Table",
      "title": "Simple Table",
      "anyTags": [],
      "allTags": [
       "Table"
      ]
     },
     {
      "id": "Laptop Stand",
      "title": "Подставка для ноутбука",
      "anyTags": [],
      "allTags": [
       "LaptopStand"
      ]
     },
     {
      "id": "Floating Desk",
      "title": "Настенный стол",
      "anyTags": [],
      "allTags": [
       "WallDesk"
      ]
     },
     {
      "id": "Junior Table",
      "title": "Детский стол",
      "anyTags": [],
      "allTags": [
       "JuniorTable"
      ]
     },
     {
      "id": "Work Station",
      "title": "Рабочая станция",
      "anyTags": [],
      "allTags": [
       "WorkStation"
      ]
     },
     {
      "id": "Standing Desk",
      "title": "Стол с ножками",
      "anyTags": [],
      "allTags": [
       "ModernDesk"
      ]
     },
     {
      "id": "Ladder Desk",
      "title": "Стол-лестница",
      "anyTags": [],
      "allTags": [
       "LadderDesk"
      ]
     },
     {
      "id": "Corner Desk",
      "title": "Угловой стол",
      "anyTags": [],
      "allTags": [
       "CornerDesk"
      ]
     },
     {
      "id": "Conference Table",
      "title": "Конференц-стол",
      "anyTags": [],
      "allTags": [
       "ConferenceTable"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/Kitchen Island",
    "name": "Kitchen Island",
    "title": "Кухонный остров",
    "photo": "/hp/catalog/tree/59f07742ae68.webp",
    "anyTags": [],
    "allTags": [
     "KitchenIsland"
    ],
    "filters": [
     {
      "id": "Rectangular Island",
      "title": "Прямоугольный остров",
      "anyTags": [],
      "allTags": [
       "RectangularIsland"
      ]
     },
     {
      "id": "Round Island",
      "title": "Круглый остров",
      "anyTags": [],
      "allTags": [
       "RoundIsland"
      ]
     },
     {
      "id": "Small Island",
      "title": "Небольшой остров",
      "anyTags": [],
      "allTags": [
       "SmallIsland"
      ]
     },
     {
      "id": "Integrated Island",
      "title": "Остров с техникой",
      "anyTags": [],
      "allTags": [
       "IntegratedIsland"
      ]
     },
     {
      "id": "Island with Shelving",
      "title": "Остров с полками",
      "anyTags": [],
      "allTags": [
       "ShelvingIsland"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/Coffee table",
    "name": "Coffee table",
    "title": "Столик",
    "photo": "/hp/catalog/tree/cb75fd59f6dc.webp",
    "anyTags": [],
    "allTags": [
     "CoffeeTable"
    ]
   },
   {
    "id": "TablesAndChairs/Dressing table",
    "name": "Dressing table",
    "title": "Туалетный столик",
    "photo": "/hp/catalog/tree/2e2d967dd3f9.webp",
    "anyTags": [],
    "allTags": [
     "DressingTable"
    ],
    "filters": [
     {
      "id": "Vanity table",
      "title": "Туалетный столик",
      "anyTags": [],
      "allTags": [
       "VanityTable"
      ]
     },
     {
      "id": "Vanity Dressers",
      "title": "Туалетные комоды",
      "anyTags": [],
      "allTags": [
       "VanityDressers"
      ]
     },
     {
      "id": "Mirrored Vanities",
      "title": "Туалетные столики с зеркалом",
      "anyTags": [],
      "allTags": [
       "MirroredVanity"
      ]
     },
     {
      "id": "Round Mirror Units",
      "title": "Круглые зеркала",
      "anyTags": [],
      "allTags": [
       "RoundMirrorsVanity"
      ]
     },
     {
      "id": "Lighted Vanities",
      "title": "С подсветкой",
      "anyTags": [],
      "allTags": [
       "LightedVanities"
      ]
     },
     {
      "id": "Tri-fold Vanities",
      "title": "Трёхстворчатые",
      "anyTags": [],
      "allTags": [
       "TrifoldVanities"
      ]
     },
     {
      "id": "Wall-mount Vanities",
      "title": "Настенные тумбы",
      "anyTags": [],
      "allTags": [
       "WallVanities"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/Dining set",
    "name": "Dining set",
    "title": "Столовая мебель",
    "photo": "/hp/catalog/tree/5d517b94be11.webp",
    "anyTags": [],
    "allTags": [
     "DiningSet"
    ],
    "filters": [
     {
      "id": "Set for 2",
      "title": "На 2 персоны",
      "anyTags": [],
      "allTags": [
       "DiningSet2"
      ]
     },
     {
      "id": "Set for 3",
      "title": "На 3 персоны",
      "anyTags": [],
      "allTags": [
       "DiningSet3"
      ]
     },
     {
      "id": "Set for 4",
      "title": "На 4 персоны",
      "anyTags": [],
      "allTags": [
       "DiningSet4"
      ]
     },
     {
      "id": "Set for 6",
      "title": "На 6 персон",
      "anyTags": [],
      "allTags": [
       "DiningSet6"
      ]
     },
     {
      "id": "Set for 8+",
      "title": "На 8+ персон",
      "anyTags": [],
      "allTags": [
       "DiningSet8"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/DiningTables",
    "name": "DiningTables",
    "title": "Обеденный стол",
    "photo": "/hp/catalog/tree/bb2a1b6aa411.webp",
    "anyTags": [],
    "allTags": [
     "DiningTable"
    ],
    "filters": [
     {
      "id": "Rectangle Table",
      "title": "Rectangle Table",
      "anyTags": [],
      "allTags": [
       "RectangleTable"
      ]
     },
     {
      "id": "Round Table",
      "title": "Round Table",
      "anyTags": [],
      "allTags": [
       "RoundTable"
      ]
     },
     {
      "id": "Square Table",
      "title": "Square Table",
      "anyTags": [],
      "allTags": [
       "SquareTable"
      ]
     },
     {
      "id": "Oval Table",
      "title": "Oval Table",
      "anyTags": [],
      "allTags": [
       "OvalTable"
      ]
     },
     {
      "id": "Abstract Table",
      "title": "Abstract Table",
      "anyTags": [],
      "allTags": [
       "AbstractTable"
      ]
     },
     {
      "id": "Sliding Table",
      "title": "Sliding Table",
      "anyTags": [],
      "allTags": [
       "SlidingTable"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/Office Chair",
    "name": "Office Chair",
    "title": "Офисное кресло",
    "photo": "/hp/catalog/tree/6edd1c2bb552.webp",
    "anyTags": [],
    "allTags": [
     "OfficeChair"
    ]
   },
   {
    "id": "TablesAndChairs/Side table",
    "name": "Side table",
    "title": "Столик",
    "photo": "/hp/catalog/tree/14fce5b6f3c6.webp",
    "anyTags": [],
    "allTags": [
     "SideTable"
    ]
   },
   {
    "id": "TablesAndChairs/Chair",
    "name": "Chair",
    "title": "Стул",
    "photo": "/hp/catalog/tree/cefaf24c7096.webp",
    "anyTags": [],
    "allTags": [
     "Chair"
    ],
    "filters": [
     {
      "id": "Non Upholstered Chair",
      "title": "Стул без обивки",
      "anyTags": [],
      "allTags": [
       "NonUpholsteredChair"
      ]
     },
     {
      "id": "Upholstered Chair",
      "title": "Мягкий стул",
      "anyTags": [],
      "allTags": [
       "UpholsteredChair"
      ]
     },
     {
      "id": "Folding Chair",
      "title": "Складной стул",
      "anyTags": [],
      "allTags": [
       "FoldingChair"
      ]
     },
     {
      "id": "Conference Chair",
      "title": "Кресло для конференции",
      "anyTags": [],
      "allTags": [
       "ConferenceChair"
      ]
     },
     {
      "id": "School Chair",
      "title": "Школьный стул",
      "anyTags": [],
      "allTags": [
       "SchoolChair"
      ]
     },
     {
      "id": "Tulip Chair",
      "title": "Стул «Тюльпан»",
      "anyTags": [],
      "allTags": [
       "TulipChair"
      ]
     },
     {
      "id": "Butterfly Chair",
      "title": "Кресло «Бабочка»",
      "anyTags": [],
      "allTags": [
       "ButterflyChair"
      ]
     },
     {
      "id": "Swivel Chair",
      "title": "Рабочий стул",
      "anyTags": [],
      "allTags": [
       "SwivelChair"
      ]
     },
     {
      "id": "Care Chair",
      "title": "Стул для ухода",
      "anyTags": [],
      "allTags": [
       "CareChair"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/Barstool",
    "name": "Barstool",
    "title": "Барные стулья",
    "photo": "/hp/catalog/tree/9fe634debd50.webp",
    "anyTags": [],
    "allTags": [
     "BarStool"
    ],
    "filters": [
     {
      "id": "SwivelBarstool",
      "title": "Поворотный барный стул",
      "anyTags": [],
      "allTags": [
       "SwivelBarstool"
      ]
     },
     {
      "id": "LowBackBarstool",
      "title": "Барный стул с низкой спинкой",
      "anyTags": [],
      "allTags": [
       "LowBackBarstool"
      ]
     },
     {
      "id": "FullBackBarstool",
      "title": "Барный стул со спинкой",
      "anyTags": [],
      "allTags": [
       "FullBackBarstool"
      ]
     },
     {
      "id": "BacklessBarstool",
      "title": "Барный табурет без спинки",
      "anyTags": [],
      "allTags": [
       "BacklessBarstool"
      ]
     },
     {
      "id": "RoundBarstool",
      "title": "Круглый барный стул",
      "anyTags": [],
      "allTags": [
       "RoundBarstool"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/Stool",
    "name": "Stool",
    "title": "Табурет",
    "photo": "/hp/catalog/tree/4f0d50a77479.webp",
    "anyTags": [],
    "allTags": [
     "Stool"
    ],
    "filters": [
     {
      "id": "Legged Stool",
      "title": "Табурет с ножками",
      "anyTags": [],
      "allTags": [
       "LeggedStool"
      ]
     },
     {
      "id": "Solid Stool",
      "title": "Цельный табурет",
      "anyTags": [],
      "allTags": [
       "SolidStool"
      ]
     },
     {
      "id": "Square Stool",
      "title": "Квадратный табурет",
      "anyTags": [],
      "allTags": [
       "SquareStool"
      ]
     },
     {
      "id": "Round Stool",
      "title": "Круглая табуретка",
      "anyTags": [],
      "allTags": [
       "RoundStool"
      ]
     },
     {
      "id": "Backrest Stool",
      "title": "Табуретка со спинкой",
      "anyTags": [],
      "allTags": [
       "BackrestStool"
      ]
     },
     {
      "id": "Upholstered Stool",
      "title": "Мягкая табуретка",
      "anyTags": [],
      "allTags": [
       "UpholsteredStool"
      ]
     },
     {
      "id": "Accent Stool",
      "title": "Акцентная табуретка",
      "anyTags": [],
      "allTags": [
       "AccentStool"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/Bar Table",
    "name": "Bar Table",
    "title": "Барный стол",
    "photo": "/hp/catalog/tree/536da6dfc302.webp",
    "anyTags": [],
    "allTags": [
     "BarTable"
    ],
    "filters": [
     {
      "id": "Rectangle Table",
      "title": "Rectangle Table",
      "anyTags": [],
      "allTags": [
       "RectangleTable"
      ]
     },
     {
      "id": "Round Table",
      "title": "Round Table",
      "anyTags": [],
      "allTags": [
       "RoundTable"
      ]
     },
     {
      "id": "Square Table",
      "title": "Square Table",
      "anyTags": [],
      "allTags": [
       "SquareTable"
      ]
     },
     {
      "id": "Oval Table",
      "title": "Oval Table",
      "anyTags": [],
      "allTags": [
       "OvalTable"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/Outdoor Dining",
    "name": "Outdoor Dining",
    "title": "Мебель для улицы",
    "photo": "/hp/catalog/tree/ea3c8a650c88.webp",
    "anyTags": [],
    "allTags": [
     "OutdoorDining"
    ],
    "filters": [
     {
      "id": "Outdoor Dining Set",
      "title": "Outdoor Set",
      "anyTags": [],
      "allTags": [
       "OutdoorSet"
      ]
     },
     {
      "id": "Outdoor Dining Table",
      "title": "Tables",
      "anyTags": [],
      "allTags": [
       "OutdoorTable"
      ]
     },
     {
      "id": "Outdoor Dining Chairs",
      "title": "Chairs",
      "anyTags": [],
      "allTags": [
       "OutdoorSeating"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/Reception",
    "name": "Reception",
    "title": "Ресепшн",
    "photo": "/hp/catalog/tree/58c07fcc0470.webp",
    "anyTags": [],
    "allTags": [
     "ComFurniture"
    ],
    "filters": [
     {
      "id": "Straight Reception",
      "title": "Прямая стойка",
      "anyTags": [],
      "allTags": [
       "StraightReception"
      ]
     },
     {
      "id": "Curved Reception",
      "title": "Изогнутая стойка",
      "anyTags": [],
      "allTags": [
       "CurvedReception"
      ]
     },
     {
      "id": "L-shape Reception",
      "title": "Г-образная стойка",
      "anyTags": [],
      "allTags": [
       "LshapeReception"
      ]
     },
     {
      "id": "U-shape Reception",
      "title": "П-образная стойка",
      "anyTags": [],
      "allTags": [
       "UshapeReception"
      ]
     },
     {
      "id": "Stone Reception",
      "title": "Каменная стойка",
      "anyTags": [],
      "allTags": [
       "StoneReception"
      ]
     },
     {
      "id": "Wooden Reception",
      "title": "Деревянная стойка",
      "anyTags": [],
      "allTags": [
       "WoodenReception"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/Kids furniture",
    "name": "Kids furniture",
    "title": "Детская мебель",
    "photo": "/hp/catalog/tree/546d97e64742.webp",
    "children": [
     {
      "id": "TablesAndChairs/Kids furniture/Kids Table Sets",
      "name": "Kids Table Sets",
      "title": "Сеты",
      "photo": "/hp/catalog/tree/546d97e64742.webp",
      "anyTags": [],
      "allTags": [
       "KidsSet"
      ]
     },
     {
      "id": "TablesAndChairs/Kids furniture/Kids Tables",
      "name": "Kids Tables",
      "title": "Детские столы",
      "photo": "/hp/catalog/tree/c295d404c130.webp",
      "anyTags": [],
      "allTags": [
       "KidTable"
      ]
     },
     {
      "id": "TablesAndChairs/Kids furniture/Kids Chairs",
      "name": "Kids Chairs",
      "title": "Детские стулья",
      "photo": "/hp/catalog/tree/5aa372ff175e.webp",
      "anyTags": [],
      "allTags": [
       "KidChair"
      ]
     },
     {
      "id": "TablesAndChairs/Kids furniture/Junior Chair",
      "name": "Junior Chair",
      "title": "Детский стул",
      "photo": "/hp/catalog/tree/90b51db2c29e.webp",
      "anyTags": [
       "JuniorChair",
       "SchoolChair"
      ],
      "allTags": []
     },
     {
      "id": "TablesAndChairs/Kids furniture/Kids Desk",
      "name": "Kids Desk",
      "title": "Детский стол",
      "photo": "/hp/catalog/tree/802c08374796.webp",
      "anyTags": [],
      "allTags": [
       "JuniorTable"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/Coworking",
    "name": "Coworking",
    "title": "Коворкинг места",
    "photo": "/hp/catalog/tree/35ca320ce202.webp",
    "anyTags": [],
    "allTags": [
     "Coworking"
    ],
    "filters": [
     {
      "id": "Coworking seats",
      "title": "Коворкинг места",
      "anyTags": [],
      "allTags": [
       "CoworkingSeats"
      ]
     },
     {
      "id": "Cubicle",
      "title": "Офисный уголок",
      "anyTags": [],
      "allTags": [
       "Cubicle"
      ]
     },
     {
      "id": "Office Set",
      "title": "Для офиса",
      "anyTags": [],
      "allTags": [
       "OfficeSet"
      ]
     }
    ]
   },
   {
    "id": "TablesAndChairs/High Chair",
    "name": "High Chair",
    "title": "Высокий стул",
    "photo": "/hp/catalog/tree/b9cd34c39250.webp",
    "anyTags": [],
    "allTags": [
     "HighChair"
    ]
   },
   {
    "id": "TablesAndChairs/Step stool",
    "name": "Step stool",
    "title": "Табурет-стремянка",
    "photo": "/hp/catalog/tree/23fa4aa5bfa0.webp",
    "anyTags": [],
    "allTags": [
     "StepStool"
    ]
   }
  ]
 },
 {
  "id": "Electronic Devices",
  "name": "Electronic Devices",
  "title": "Электронные устройства",
  "photo": "/hp/catalog/tree/ef26398e747c.webp",
  "children": [
   {
    "id": "Electronic Devices/TV / Media",
    "name": "TV / Media",
    "title": "ТВ / Медиа",
    "photo": "/hp/catalog/tree/ef26398e747c.webp",
    "children": [
     {
      "id": "Electronic Devices/TV / Media/Wall TV",
      "name": "Wall TV",
      "title": "Настенный телевизор",
      "photo": "/hp/catalog/tree/274d173300c7.webp",
      "anyTags": [],
      "allTags": [
       "TVWall"
      ]
     },
     {
      "id": "Electronic Devices/TV / Media/TV Storage",
      "name": "TV Storage",
      "title": "Хранение ТВ",
      "photo": "/hp/catalog/tree/5a605a417aac.webp",
      "anyTags": [],
      "allTags": [
       "TVfurniture"
      ]
     },
     {
      "id": "Electronic Devices/TV / Media/Table TV",
      "name": "Table TV",
      "title": "ТВ",
      "photo": "/hp/catalog/tree/ef26398e747c.webp",
      "anyTags": [],
      "allTags": [
       "TV"
      ]
     },
     {
      "id": "Electronic Devices/TV / Media/TV set-top box",
      "name": "TV set-top box",
      "title": "ТВ-приставка",
      "photo": "/hp/catalog/tree/207f35ec96d2.webp",
      "anyTags": [],
      "allTags": [
       "TVbox"
      ]
     },
     {
      "id": "Electronic Devices/TV / Media/Sound",
      "name": "Sound",
      "title": "Звуковое оборудование",
      "photo": "/hp/catalog/tree/d766dfeb5d36.webp",
      "anyTags": [],
      "allTags": [
       "Speaker"
      ]
     },
     {
      "id": "Electronic Devices/TV / Media/Projector",
      "name": "Projector",
      "title": "Проектор",
      "photo": "/hp/catalog/tree/ca3c37e6554d.webp",
      "anyTags": [],
      "allTags": [
       "Projector"
      ]
     }
    ]
   },
   {
    "id": "Electronic Devices/KitchenAppliances",
    "name": "KitchenAppliances",
    "title": "Кухонные приборы",
    "photo": "/hp/catalog/tree/6a10a5cc505c.webp",
    "children": [
     {
      "id": "Electronic Devices/KitchenAppliances/Refrigerators",
      "name": "Refrigerators",
      "title": "Холодильники",
      "photo": "/hp/catalog/tree/6a10a5cc505c.webp",
      "anyTags": [],
      "allTags": [
       "Refrigerators"
      ],
      "filters": [
       {
        "id": "Side-by-Side Fridge",
        "title": "Side-by-Side Fridge",
        "anyTags": [],
        "allTags": [
         "2DoorFridge"
        ]
       },
       {
        "id": "Mini Fridge",
        "title": "Mini Fridge",
        "anyTags": [],
        "allTags": [
         "MiniFridge"
        ]
       },
       {
        "id": "Top Freezer Fridge",
        "title": "Top Freezer Fridge",
        "anyTags": [],
        "allTags": [
         "1DoorFridge"
        ]
       },
       {
        "id": "Beverage Fridge",
        "title": "Холодильник для напитков",
        "anyTags": [
         "OpenFridge",
         "WineFridge",
         "BuiltinFridge"
        ],
        "allTags": []
       }
      ]
     },
     {
      "id": "Electronic Devices/KitchenAppliances/Cooktop",
      "name": "Cooktop",
      "title": "Варочные панели",
      "photo": "/hp/catalog/tree/61eaff335a58.webp",
      "anyTags": [
       "Cooktop",
       "CooktopBuiltin"
      ],
      "allTags": [],
      "filters": [
       {
        "id": "Gas Cooktop",
        "title": "Gas Cooktop",
        "anyTags": [],
        "allTags": [
         "GasCooktop"
        ]
       },
       {
        "id": "Electric Cooktop",
        "title": "Electric Cooktop",
        "anyTags": [],
        "allTags": [
         "ElectricCooktop"
        ]
       }
      ]
     },
     {
      "id": "Electronic Devices/KitchenAppliances/Cooker Hood",
      "name": "Cooker Hood",
      "title": "Вытяжки",
      "photo": "/hp/catalog/tree/cfad2766164f.webp",
      "anyTags": [],
      "allTags": [
       "CookerHood"
      ],
      "filters": [
       {
        "id": "Canopy Hood",
        "title": "Купольная вытяжка",
        "anyTags": [],
        "allTags": [
         "CanopyHood"
        ]
       },
       {
        "id": "T-shaped Hood",
        "title": "T-shaped Hood",
        "anyTags": [],
        "allTags": [
         "TshapedHood"
        ]
       },
       {
        "id": "Telescopic Hood",
        "title": "Телескопическая вытяжка",
        "anyTags": [],
        "allTags": [
         "TelescopicHood"
        ]
       },
       {
        "id": "Builtin Hood",
        "title": "Builtin Hood",
        "anyTags": [],
        "allTags": [
         "BuiltinHood"
        ]
       },
       {
        "id": "Island Hood",
        "title": "Island Hood",
        "anyTags": [],
        "allTags": [
         "CookerHoodIsland"
        ]
       },
       {
        "id": "Angled Hood",
        "title": "Angled Hood",
        "anyTags": [],
        "allTags": [
         "AngledHood"
        ]
       }
      ]
     },
     {
      "id": "Electronic Devices/KitchenAppliances/Ovens",
      "name": "Ovens",
      "title": "Духовки",
      "photo": "/hp/catalog/tree/4231683957af.webp",
      "anyTags": [],
      "allTags": [
       "Ovens"
      ],
      "filters": [
       {
        "id": "Range",
        "title": "Range",
        "anyTags": [],
        "allTags": [
         "Range"
        ]
       },
       {
        "id": "Gas Oven",
        "title": "Gas Oven",
        "anyTags": [],
        "allTags": [
         "GasOven"
        ]
       },
       {
        "id": "Electric Oven",
        "title": "Electric Oven",
        "anyTags": [],
        "allTags": [
         "ElectricOven"
        ]
       },
       {
        "id": "Combined Oven",
        "title": "Комбинированная духовка",
        "anyTags": [],
        "allTags": [
         "CombinedOven"
        ]
       },
       {
        "id": "Builtin Oven",
        "title": "Builtin Oven",
        "anyTags": [],
        "allTags": [
         "BuiltinOven"
        ]
       }
      ]
     },
     {
      "id": "Electronic Devices/KitchenAppliances/Coffee Maker",
      "name": "Coffee Maker",
      "title": "Кофеварка",
      "photo": "/hp/catalog/tree/473b838870e8.webp",
      "anyTags": [],
      "allTags": [
       "CoffeeMaker"
      ]
     },
     {
      "id": "Electronic Devices/KitchenAppliances/Microwave",
      "name": "Microwave",
      "title": "Микроволновка",
      "photo": "/hp/catalog/tree/8383e2e5c675.webp",
      "anyTags": [],
      "allTags": [
       "Microwave"
      ]
     },
     {
      "id": "Electronic Devices/KitchenAppliances/KitchenTableElectronics",
      "name": "KitchenTableElectronics",
      "title": "Больше кухонных приборов",
      "photo": "/hp/catalog/tree/10d33dd3951f.webp",
      "anyTags": [],
      "allTags": [
       "KitchenTableElectronics"
      ]
     },
     {
      "id": "Electronic Devices/KitchenAppliances/Water purifier",
      "name": "Water purifier",
      "title": "Водоочиститель",
      "photo": "/hp/catalog/tree/3446a979c3f8.webp",
      "anyTags": [],
      "allTags": [
       "WaterPurifier"
      ]
     },
     {
      "id": "Electronic Devices/KitchenAppliances/Dishwashers",
      "name": "Dishwashers",
      "title": "Посудомоечные машины",
      "photo": "/hp/catalog/tree/dc039751efc9.webp",
      "anyTags": [
       "Dishwasher",
       "BuiltinDishwasher"
      ],
      "allTags": []
     },
     {
      "id": "Electronic Devices/KitchenAppliances/Kettle",
      "name": "Kettle",
      "title": "Чайник",
      "photo": "/hp/catalog/tree/d3f0448fa51a.webp",
      "anyTags": [],
      "allTags": [
       "Kettle"
      ]
     },
     {
      "id": "Electronic Devices/KitchenAppliances/Multi cooker,Rice cooker",
      "name": "Multi cooker,Rice cooker",
      "title": "Мультиварка, рисоварка",
      "photo": "/hp/catalog/tree/cb30ba9dca0f.webp",
      "anyTags": [],
      "allTags": [
       "MultiCooker"
      ]
     },
     {
      "id": "Electronic Devices/KitchenAppliances/Toaster",
      "name": "Toaster",
      "title": "Тостер",
      "photo": "/hp/catalog/tree/d18e55218b12.webp",
      "anyTags": [],
      "allTags": [
       "Toaster"
      ]
     },
     {
      "id": "Electronic Devices/KitchenAppliances/Blender,Mixer,Food processor",
      "name": "Blender,Mixer,Food processor",
      "title": "Кухонный комбайн",
      "photo": "/hp/catalog/tree/c5b0c73126a8.webp",
      "anyTags": [],
      "allTags": [
       "Blender"
      ]
     },
     {
      "id": "Electronic Devices/KitchenAppliances/Drying cabinet",
      "name": "Drying cabinet",
      "title": "Сушильный шкаф",
      "photo": "/hp/catalog/tree/2b42097e8057.webp",
      "anyTags": [],
      "allTags": [
       "DryingCabinet"
      ]
     }
    ]
   },
   {
    "id": "Electronic Devices/Climate electronics",
    "name": "Climate electronics",
    "title": "Климатическая электроника",
    "photo": "/hp/catalog/tree/8cbd84da7b49.webp",
    "children": [
     {
      "id": "Electronic Devices/Climate electronics/Conditioner",
      "name": "Conditioner",
      "title": "Кондиционер",
      "photo": "/hp/catalog/tree/8cbd84da7b49.webp",
      "anyTags": [],
      "allTags": [
       "Conditioner"
      ]
     },
     {
      "id": "Electronic Devices/Climate electronics/Ceiling fan",
      "name": "Ceiling fan",
      "title": "Потолочный вентилятор",
      "photo": "/hp/catalog/tree/d47213ab3176.webp",
      "anyTags": [],
      "allTags": [
       "CeilingFan"
      ]
     },
     {
      "id": "Electronic Devices/Climate electronics/Heating",
      "name": "Heating",
      "title": "Отопление",
      "photo": "/hp/catalog/tree/a3ffca9715f3.webp",
      "anyTags": [],
      "allTags": [
       "Heating"
      ],
      "filters": [
       {
        "id": "Wall Radiator",
        "title": "Настенный радиатор",
        "anyTags": [],
        "allTags": [
         "WallRadiator"
        ]
       },
       {
        "id": "Floor Radiator",
        "title": "Напольный радиатор",
        "anyTags": [],
        "allTags": [
         "FloorRadiator"
        ]
       },
       {
        "id": "Towel Dryer",
        "title": "Сушилка для полотенец",
        "anyTags": [],
        "allTags": [
         "TowelDryer"
        ]
       }
      ]
     },
     {
      "id": "Electronic Devices/Climate electronics/Ventilation",
      "name": "Ventilation",
      "title": "Вентиляция",
      "photo": "/hp/catalog/tree/997e611df544.webp",
      "anyTags": [],
      "allTags": [
       "AirVent"
      ]
     },
     {
      "id": "Electronic Devices/Climate electronics/Fan",
      "name": "Fan",
      "title": "Вентилятор",
      "photo": "/hp/catalog/tree/536dc03ad328.webp",
      "anyTags": [],
      "allTags": [
       "Fan"
      ]
     },
     {
      "id": "Electronic Devices/Climate electronics/Air purifier",
      "name": "Air purifier",
      "title": "Очиститель воздуха",
      "photo": "/hp/catalog/tree/42b025ea0290.webp",
      "anyTags": [],
      "allTags": [
       "Purifier"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Electronic Devices/Climate electronics/Water heater",
      "name": "Water heater",
      "title": "Бойлер",
      "photo": "/hp/catalog/tree/60828117711f.webp",
      "anyTags": [],
      "allTags": [
       "WaterHeater"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Electronic Devices/Climate electronics/Thermometer",
      "name": "Thermometer",
      "title": "Термометр",
      "photo": "/hp/catalog/tree/abb8d6dcd07e.webp",
      "anyTags": [],
      "allTags": [
       "Thermometer"
      ],
      "sort": "PriceHigh"
     }
    ]
   },
   {
    "id": "Electronic Devices/LightingOutletsSwitches",
    "name": "LightingOutletsSwitches",
    "title": "Розетки, выключатели",
    "photo": "/hp/catalog/tree/67b082c3d91a.webp",
    "anyTags": [],
    "allTags": [
     "WiringDevices"
    ]
   },
   {
    "id": "Electronic Devices/Washers / Dryers",
    "name": "Washers / Dryers",
    "title": "Стир.машины",
    "photo": "/hp/catalog/tree/f09bf7d93532.webp",
    "anyTags": [],
    "allTags": [
     "LaundryItem"
    ],
    "filters": [
     {
      "id": "Washing Machines",
      "title": "Washing Machines",
      "anyTags": [],
      "allTags": [
       "Washer"
      ]
     },
     {
      "id": "Drying Machines",
      "title": "Сушилки",
      "anyTags": [],
      "allTags": [
       "Dryer"
      ]
     },
     {
      "id": "Top Load Washers",
      "title": "Top Load Washers",
      "anyTags": [],
      "allTags": [
       "VerticalWasher"
      ]
     },
     {
      "id": "Laundry Sets",
      "title": "Laundry Sets",
      "anyTags": [],
      "allTags": [
       "WashersDryers"
      ]
     },
     {
      "id": "Clothes Drying",
      "title": "Сушилка для одежды",
      "anyTags": [],
      "allTags": [
       "ClothesDryer"
      ]
     }
    ]
   },
   {
    "id": "Electronic Devices/Office electronics",
    "name": "Office electronics",
    "title": "Офисная электроника",
    "photo": "/hp/catalog/tree/5391759304bf.webp",
    "anyTags": [
     "Electronics",
     "PlaneElectronics"
    ],
    "allTags": [],
    "filters": [
     {
      "id": "Laptops",
      "title": "Ноутбуки",
      "anyTags": [],
      "allTags": [
       "Laptop"
      ]
     },
     {
      "id": "PC",
      "title": "ПК",
      "anyTags": [],
      "allTags": [
       "PC"
      ]
     },
     {
      "id": "Monitors",
      "title": "Мониторы",
      "anyTags": [],
      "allTags": [
       "Monitor"
      ]
     },
     {
      "id": "Keyboard",
      "title": "Клавиатура",
      "anyTags": [],
      "allTags": [
       "Keyboard"
      ]
     },
     {
      "id": "Mouse",
      "title": "Мышка",
      "anyTags": [],
      "allTags": [
       "Mouse"
      ]
     },
     {
      "id": "Printer",
      "title": "Принтер",
      "anyTags": [],
      "allTags": [
       "Printer"
      ]
     },
     {
      "id": "Microphone",
      "title": "Микрофон",
      "anyTags": [],
      "allTags": [
       "Microphone"
      ]
     },
     {
      "id": "Headphones",
      "title": "Наушники",
      "anyTags": [],
      "allTags": [
       "Headphones"
      ]
     }
    ]
   },
   {
    "id": "Electronic Devices/Gaming",
    "name": "Gaming",
    "title": "Игры",
    "photo": "/hp/catalog/tree/a3c2a170ff31.webp",
    "children": [
     {
      "id": "Electronic Devices/Gaming/Phones and Tablets",
      "name": "Phones and Tablets",
      "title": "Телефоны и планшеты",
      "photo": "/hp/catalog/tree/409d1b4c66c4.webp",
      "anyTags": [],
      "allTags": [
       "Phones"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Electronic Devices/Gaming/Consoles",
      "name": "Consoles",
      "title": "Игровая консоль",
      "photo": "/hp/catalog/tree/a920a278f9a7.webp",
      "anyTags": [],
      "allTags": [
       "GameConsole"
      ]
     },
     {
      "id": "Electronic Devices/Gaming/Gaming setups",
      "name": "Gaming setups",
      "title": "Игровые сборки",
      "photo": "/hp/catalog/tree/3167872246f7.webp",
      "anyTags": [],
      "allTags": [
       "GamingSetup"
      ]
     },
     {
      "id": "Electronic Devices/Gaming/Monitors",
      "name": "Monitors",
      "title": "Мониторы",
      "photo": "/hp/catalog/tree/695bbdf22b94.webp",
      "anyTags": [],
      "allTags": [
       "Monitor"
      ]
     },
     {
      "id": "Electronic Devices/Gaming/Gaming decor",
      "name": "Gaming decor",
      "title": "Игровой декор",
      "photo": "/hp/catalog/tree/53ab39c4faa5.webp",
      "anyTags": [],
      "allTags": [
       "GamingDecor"
      ]
     },
     {
      "id": "Electronic Devices/Gaming/PCs",
      "name": "PCs",
      "title": "Компьютер",
      "photo": "/hp/catalog/tree/6756ece250a6.webp",
      "anyTags": [],
      "allTags": [
       "PC"
      ]
     },
     {
      "id": "Electronic Devices/Gaming/Gaming desks",
      "name": "Gaming desks",
      "title": "Игровые столы",
      "photo": "/hp/catalog/tree/c7fd7214fd99.webp",
      "anyTags": [],
      "allTags": [
       "GamingDesk"
      ]
     },
     {
      "id": "Electronic Devices/Gaming/Gaming audio",
      "name": "Gaming audio",
      "title": "Игровой звук",
      "photo": "/hp/catalog/tree/207f35ec96d2.webp",
      "anyTags": [
       "Speaker",
       "Headphones",
       "Microphone"
      ],
      "allTags": []
     },
     {
      "id": "Electronic Devices/Gaming/VR",
      "name": "VR",
      "title": "VR",
      "photo": "/hp/catalog/tree/838327f07fea.webp",
      "anyTags": [],
      "allTags": [
       "VR"
      ]
     },
     {
      "id": "Electronic Devices/Gaming/Gaming chairs",
      "name": "Gaming chairs",
      "title": "Игровые кресла",
      "photo": "/hp/catalog/tree/6c6df04fbd9f.webp",
      "anyTags": [],
      "allTags": [
       "GamingChair"
      ]
     },
     {
      "id": "Electronic Devices/Gaming/Laptops",
      "name": "Laptops",
      "title": "Ноутбуки",
      "photo": "/hp/catalog/tree/2fd8731aa840.webp",
      "anyTags": [],
      "allTags": [
       "Laptop"
      ]
     },
     {
      "id": "Electronic Devices/Gaming/Keyboards,Mouses",
      "name": "Keyboards,Mouses",
      "title": "Клавиатуры,мышки",
      "photo": "/hp/catalog/tree/1532e6aaee33.webp",
      "anyTags": [],
      "allTags": [
       "InputDevice"
      ],
      "filters": [
       {
        "id": "Keyboard",
        "title": "Клавиатура",
        "anyTags": [],
        "allTags": [
         "Keyboard"
        ]
       },
       {
        "id": "Mouse",
        "title": "Мышка",
        "anyTags": [],
        "allTags": [
         "Mouse"
        ]
       }
      ]
     },
     {
      "id": "Electronic Devices/Gaming/TV",
      "name": "TV",
      "title": "Телевизор",
      "photo": "/hp/catalog/tree/ef26398e747c.webp",
      "anyTags": [
       "TV",
       "TVWall"
      ],
      "allTags": []
     }
    ]
   },
   {
    "id": "Electronic Devices/Sound equipment",
    "name": "Sound equipment",
    "title": "Музыка",
    "photo": "/hp/catalog/tree/d766dfeb5d36.webp",
    "anyTags": [],
    "allTags": [
     "Sound"
    ],
    "filters": [
     {
      "id": "Speaker",
      "title": "Колонка",
      "anyTags": [],
      "allTags": [
       "Speaker"
      ]
     },
     {
      "id": "Smart Speaker",
      "title": "Умная колонка",
      "anyTags": [],
      "allTags": [
       "SmartSpeaker"
      ]
     },
     {
      "id": "Microphone",
      "title": "Микрофон",
      "anyTags": [],
      "allTags": [
       "Microphone"
      ]
     },
     {
      "id": "Headphones",
      "title": "Наушники",
      "anyTags": [],
      "allTags": [
       "Headphones"
      ]
     },
     {
      "id": "Recorder",
      "title": "Проигрыватель",
      "anyTags": [],
      "allTags": [
       "Recorder"
      ]
     }
    ]
   },
   {
    "id": "Electronic Devices/SpecificElectronics",
    "name": "SpecificElectronics",
    "title": "Больше электроники",
    "photo": "/hp/catalog/tree/199f84225031.webp",
    "children": [
     {
      "id": "Electronic Devices/SpecificElectronics/Intercom",
      "name": "Intercom",
      "title": "Домофон",
      "photo": "/hp/catalog/tree/199f84225031.webp",
      "anyTags": [],
      "allTags": [
       "Intercom"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Electronic Devices/SpecificElectronics/Security camera",
      "name": "Security camera",
      "title": "Камера",
      "photo": "/hp/catalog/tree/525b15a1bd44.webp",
      "anyTags": [],
      "allTags": [
       "SecurityCamera"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Electronic Devices/SpecificElectronics/Router",
      "name": "Router",
      "title": "Роутер",
      "photo": "/hp/catalog/tree/ad0b74f2c894.webp",
      "anyTags": [],
      "allTags": [
       "Router"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Electronic Devices/SpecificElectronics/HomeAppliances",
      "name": "HomeAppliances",
      "title": "Больше электроники",
      "photo": "/hp/catalog/tree/188c1237241e.webp",
      "anyTags": [],
      "allTags": [
       "HomeAppliances"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Electronic Devices/SpecificElectronics/Antenna",
      "name": "Antenna",
      "title": "Антенна",
      "photo": "/hp/catalog/tree/c073ce3e6cc2.webp",
      "anyTags": [],
      "allTags": [
       "Antenna"
      ],
      "sort": "PriceHigh"
     }
    ]
   },
   {
    "id": "Electronic Devices/Phones and Tablets",
    "name": "Phones and Tablets",
    "title": "Телефоны и планшеты",
    "photo": "/hp/catalog/tree/409d1b4c66c4.webp",
    "anyTags": [],
    "allTags": [
     "Phones"
    ],
    "sort": "PriceHigh",
    "filters": [
     {
      "id": "Phones",
      "title": "Телефоны",
      "anyTags": [],
      "allTags": [
       "Phone"
      ]
     },
     {
      "id": "Mobile Phones",
      "title": "Mobile Phones",
      "anyTags": [],
      "allTags": [
       "MobilePhone"
      ]
     },
     {
      "id": "Tablets",
      "title": "Tablets",
      "anyTags": [],
      "allTags": [
       "Tablet"
      ]
     }
    ]
   },
   {
    "id": "Electronic Devices/Home care electronics",
    "name": "Home care electronics",
    "title": "Уход за домом",
    "photo": "/hp/catalog/tree/3dbcb3a6540d.webp",
    "children": [
     {
      "id": "Electronic Devices/Home care electronics/Vacuum cleaners and mops",
      "name": "Vacuum cleaners and mops",
      "title": "Пылесосы и швабры",
      "photo": "/hp/catalog/tree/ce8c9b8a1e9f.webp",
      "anyTags": [],
      "allTags": [
       "VacuumCleaner"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Electronic Devices/Home care electronics/Irons and Steamers",
      "name": "Irons and Steamers",
      "title": "Утюги и отпариватели",
      "photo": "/hp/catalog/tree/5d54eb419010.webp",
      "anyTags": [],
      "allTags": [
       "Iron"
      ],
      "sort": "PriceHigh"
     }
    ]
   },
   {
    "id": "Electronic Devices/Commercial electronics",
    "name": "Commercial electronics",
    "title": "Коммерческая электроника",
    "photo": "/hp/catalog/tree/ba1ff0784c50.webp",
    "children": [
     {
      "id": "Electronic Devices/Commercial electronics/POS system",
      "name": "POS system",
      "title": "POS-система",
      "photo": "/hp/catalog/tree/ba1ff0784c50.webp",
      "anyTags": [],
      "allTags": [
       "PosSystem"
      ]
     },
     {
      "id": "Electronic Devices/Commercial electronics/Security camera",
      "name": "Security camera",
      "title": "Камера",
      "photo": "/hp/catalog/tree/01397f2d8831.webp",
      "anyTags": [],
      "allTags": [
       "SecurityCamera"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "Electronic Devices/Commercial electronics/Commercial items",
      "name": "Commercial items",
      "title": "Коммерческие объекты",
      "photo": "/hp/catalog/tree/d5958fb4eaf7.webp",
      "anyTags": [],
      "allTags": [
       "ComEquipment"
      ]
     },
     {
      "id": "Electronic Devices/Commercial electronics/Water Cooler",
      "name": "Water Cooler",
      "title": "Кулер",
      "photo": "/hp/catalog/tree/d9bdc6348e32.webp",
      "anyTags": [],
      "allTags": [
       "WaterCooler"
      ]
     },
     {
      "id": "Electronic Devices/Commercial electronics/Vending Machine",
      "name": "Vending Machine",
      "title": "Торговый автомат",
      "photo": "/hp/catalog/tree/efa9ae4e8d97.webp",
      "anyTags": [],
      "allTags": [
       "VendingMachine"
      ]
     }
    ]
   }
  ]
 },
 {
  "id": "Seating furniture",
  "name": "Seating furniture",
  "title": "Мебель для сидения",
  "photo": "/hp/catalog/tree/1522059d6d38.webp",
  "children": [
   {
    "id": "Seating furniture/Sofa",
    "name": "Sofa",
    "title": "Диван",
    "photo": "/hp/catalog/tree/1522059d6d38.webp",
    "anyTags": [],
    "allTags": [
     "Sofa"
    ],
    "filters": [
     {
      "id": "3-Seat Sofa",
      "title": "3-Seat Sofa",
      "anyTags": [],
      "allTags": [
       "3seat"
      ]
     },
     {
      "id": "Loveseat Sofa",
      "title": "Диванчик",
      "anyTags": [
       "Loveseat",
       "2seat"
      ],
      "allTags": []
     },
     {
      "id": "L-Shaped Sofa",
      "title": "L-Shaped Sofa",
      "anyTags": [
       "RightSofa",
       "CornerSofa"
      ],
      "allTags": []
     },
     {
      "id": "Modular Sofa",
      "title": "Modular Sofa",
      "anyTags": [
       "SofaConstructor",
       "CollectionVallentuna"
      ],
      "allTags": []
     },
     {
      "id": "Chaise Lounge",
      "title": "Chaise Lounge",
      "anyTags": [],
      "allTags": [
       "Lounge"
      ]
     },
     {
      "id": "Chesterfield Sofa",
      "title": "Диван честерфилд",
      "anyTags": [],
      "allTags": [
       "ChesterfieldSofa"
      ]
     },
     {
      "id": "Curved Sofa",
      "title": "Изогнутый диван",
      "anyTags": [],
      "allTags": [
       "CurvedSofa"
      ]
     },
     {
      "id": "Round Sofa",
      "title": "Круглый диван",
      "anyTags": [],
      "allTags": [
       "RoundSofa"
      ]
     },
     {
      "id": "P-shaped Sofa",
      "title": "P-shaped Sofa",
      "anyTags": [],
      "allTags": [
       "PshapedSofa"
      ]
     },
     {
      "id": "Tuxedo Sofa",
      "title": "Диван таксидо",
      "anyTags": [],
      "allTags": [
       "TuxedoSofa"
      ]
     },
     {
      "id": "Marshmallow Sofa",
      "title": "Диван Marshmallow",
      "anyTags": [],
      "allTags": [
       "MarshmallowSofa"
      ]
     },
     {
      "id": "Settee Sofa",
      "title": "Мини-диван",
      "anyTags": [],
      "allTags": [
       "SetteeSofa"
      ]
     },
     {
      "id": "Sleeper Sofa",
      "title": "Диван-кровать",
      "anyTags": [],
      "allTags": [
       "SleeperSofa"
      ]
     },
     {
      "id": "SofaBed",
      "title": "Диван-кровать",
      "anyTags": [],
      "allTags": [
       "SofaBed"
      ]
     }
    ]
   },
   {
    "id": "Seating furniture/Coffee table",
    "name": "Coffee table",
    "title": "Столик",
    "photo": "/hp/catalog/tree/cb75fd59f6dc.webp",
    "anyTags": [],
    "allTags": [
     "CoffeeTable"
    ],
    "filters": [
     {
      "id": "Rectangle Table",
      "title": "Rectangle Table",
      "anyTags": [],
      "allTags": [
       "RectangleTable"
      ]
     },
     {
      "id": "Round Table",
      "title": "Round Table",
      "anyTags": [],
      "allTags": [
       "RoundTable"
      ]
     },
     {
      "id": "Square Table",
      "title": "Square Table",
      "anyTags": [],
      "allTags": [
       "SquareTable"
      ]
     },
     {
      "id": "Oval Table",
      "title": "Oval Table",
      "anyTags": [],
      "allTags": [
       "OvalTable"
      ]
     },
     {
      "id": "Abstract Table",
      "title": "Abstract Table",
      "anyTags": [],
      "allTags": [
       "AbstractTable"
      ]
     },
     {
      "id": "Sliding Table",
      "title": "Sliding Table",
      "anyTags": [],
      "allTags": [
       "SlidingTable"
      ]
     }
    ]
   },
   {
    "id": "Seating furniture/Armchair",
    "name": "Armchair",
    "title": "Кресло",
    "photo": "/hp/catalog/tree/29e6d9884085.webp",
    "anyTags": [],
    "allTags": [
     "Armchair"
    ],
    "filters": [
     {
      "id": "Wingback Chair",
      "title": "Кресло с крыльями",
      "anyTags": [],
      "allTags": [
       "WingbackChair"
      ]
     },
     {
      "id": "Barrel Chair",
      "title": "Кресло-бочка",
      "anyTags": [],
      "allTags": [
       "BarrelChair"
      ]
     },
     {
      "id": "Club Chair",
      "title": "Клубное кресло",
      "anyTags": [],
      "allTags": [
       "ClubChair"
      ]
     },
     {
      "id": "Recliner Chair",
      "title": "Кресло с откидной спинкой",
      "anyTags": [],
      "allTags": [
       "ReclinerChair"
      ]
     },
     {
      "id": "Chesterfield Chair",
      "title": "Кресло Честерфилд",
      "anyTags": [],
      "allTags": [
       "ChesterfieldChair"
      ]
     },
     {
      "id": "Accent Chair",
      "title": "Акцентное кресло",
      "anyTags": [],
      "allTags": [
       "AccentChair"
      ]
     },
     {
      "id": "Slipper Chair",
      "title": "Кресло без подлокотников",
      "anyTags": [],
      "allTags": [
       "SlipperChair"
      ]
     },
     {
      "id": "Armchair With Ottoman",
      "title": "Armchair With Ottoman",
      "anyTags": [],
      "allTags": [
       "ArmchairWithOttoman"
      ]
     },
     {
      "id": "Corner Chair",
      "title": "Угловое кресло",
      "anyTags": [],
      "allTags": [
       "CornerChair"
      ]
     },
     {
      "id": "Round Chair",
      "title": "Круглое кресло",
      "anyTags": [],
      "allTags": [
       "RoundChair"
      ]
     },
     {
      "id": "Egg Chair",
      "title": "Кресло «Яйцо»",
      "anyTags": [],
      "allTags": [
       "EggChair"
      ]
     },
     {
      "id": "Massage Chair",
      "title": "Массажное кресло",
      "anyTags": [],
      "allTags": [
       "MassageChair"
      ]
     }
    ]
   },
   {
    "id": "Seating furniture/Office Chair",
    "name": "Office Chair",
    "title": "Офисное кресло",
    "photo": "/hp/catalog/tree/e65e37127abb.webp",
    "anyTags": [],
    "allTags": [
     "OfficeChair"
    ],
    "filters": [
     {
      "id": "Gaming Chair",
      "title": "Игровой стул",
      "anyTags": [],
      "allTags": [
       "GamingChair"
      ]
     },
     {
      "id": "Executive Chair",
      "title": "Кресло директора",
      "anyTags": [],
      "allTags": [
       "ExecutiveChair"
      ]
     },
     {
      "id": "Swan Chair",
      "title": "Кресло «Лебедь»",
      "anyTags": [],
      "allTags": [
       "SwanChair"
      ]
     }
    ]
   },
   {
    "id": "Seating furniture/Side table",
    "name": "Side table",
    "title": "Столик",
    "photo": "/hp/catalog/tree/14fce5b6f3c6.webp",
    "anyTags": [],
    "allTags": [
     "SideTable"
    ],
    "filters": [
     {
      "id": "Rectangle Table",
      "title": "Rectangle Table",
      "anyTags": [],
      "allTags": [
       "RectangleTable"
      ]
     },
     {
      "id": "Round Table",
      "title": "Round Table",
      "anyTags": [],
      "allTags": [
       "RoundTable"
      ]
     },
     {
      "id": "Square Table",
      "title": "Square Table",
      "anyTags": [],
      "allTags": [
       "SquareTable"
      ]
     },
     {
      "id": "Oval Table",
      "title": "Oval Table",
      "anyTags": [],
      "allTags": [
       "OvalTable"
      ]
     },
     {
      "id": "Abstract Table",
      "title": "Abstract Table",
      "anyTags": [],
      "allTags": [
       "AbstractTable"
      ]
     },
     {
      "id": "C Table",
      "title": "С-образный стол",
      "anyTags": [],
      "allTags": [
       "CshapeTable"
      ]
     },
     {
      "id": "Nesting Table",
      "title": "Nesting Table",
      "anyTags": [],
      "allTags": [
       "SlidingTable"
      ]
     }
    ]
   },
   {
    "id": "Seating furniture/Chaise",
    "name": "Chaise",
    "title": "Кресло для отдыха",
    "photo": "/hp/catalog/tree/2f47e06f13ee.webp",
    "anyTags": [],
    "allTags": [
     "Chaise"
    ]
   },
   {
    "id": "Seating furniture/Pouf, Footstool",
    "name": "Pouf, Footstool",
    "title": "Пуф, табурет",
    "photo": "/hp/catalog/tree/cfdf4df52426.webp",
    "anyTags": [],
    "allTags": [
     "Pouf"
    ],
    "filters": [
     {
      "id": "Ottoman,Footstool",
      "title": "Оттоманка",
      "anyTags": [
       "Ottoman",
       "Footstool"
      ],
      "allTags": []
     },
     {
      "id": "Round pouf",
      "title": "Круглый пуфик",
      "anyTags": [],
      "allTags": [
       "RoundPouf"
      ]
     },
     {
      "id": "Oval pouf",
      "title": "Овальный пуфик",
      "anyTags": [],
      "allTags": [
       "OvalPouf"
      ]
     },
     {
      "id": "Square pouf",
      "title": "Квадратный пуфик",
      "anyTags": [],
      "allTags": [
       "SquarePouf"
      ]
     },
     {
      "id": "Rectangle pouf",
      "title": "Прямоугольный пуфик",
      "anyTags": [],
      "allTags": [
       "RectanglePouf"
      ]
     },
     {
      "id": "Abstract pouf",
      "title": "Абстрактный пуфик",
      "anyTags": [],
      "allTags": [
       "AbstractPouf"
      ]
     },
     {
      "id": "Storage pouf",
      "title": "Пуфик с ящиком",
      "anyTags": [],
      "allTags": [
       "StoragePouf"
      ]
     },
     {
      "id": "Low pouf",
      "title": "Низкий пуфик",
      "anyTags": [],
      "allTags": [
       "LowPouf"
      ]
     }
    ]
   },
   {
    "id": "Seating furniture/Pillow",
    "name": "Pillow",
    "title": "Подушка",
    "photo": "/hp/catalog/tree/96e5894bd735.webp",
    "anyTags": [],
    "allTags": [
     "Pillow"
    ]
   },
   {
    "id": "Seating furniture/Bean Bag",
    "name": "Bean Bag",
    "title": "Кресло-мешок",
    "photo": "/hp/catalog/tree/b9af202d7974.webp",
    "anyTags": [],
    "allTags": [
     "BeanBag"
    ]
   },
   {
    "id": "Seating furniture/Outdoor Furniture",
    "name": "Outdoor Furniture",
    "title": "Мебель для улицы",
    "photo": "/hp/catalog/tree/5d4578a7ef8a.webp",
    "anyTags": [],
    "allTags": [
     "OutdoorLounge"
    ],
    "filters": [
     {
      "id": "Conversation Set",
      "title": "Conversation Set",
      "anyTags": [],
      "allTags": [
       "OutdoorSetSoft"
      ]
     },
     {
      "id": "Outdoor Sofa",
      "title": "Скамья",
      "anyTags": [],
      "allTags": [
       "OutdoorSofa"
      ]
     },
     {
      "id": "Outdoor Armchair",
      "title": "Кресло",
      "anyTags": [],
      "allTags": [
       "OutdoorChair"
      ]
     },
     {
      "id": "Adirondack Chair",
      "title": "Стул адирондак",
      "anyTags": [],
      "allTags": [
       "AdirondackChair"
      ]
     }
    ]
   },
   {
    "id": "Seating furniture/CommercialSeating",
    "name": "CommercialSeating",
    "title": "Коммерческая мебель",
    "photo": "/hp/catalog/tree/ff60555a0270.webp",
    "children": [
     {
      "id": "Seating furniture/CommercialSeating/Cafe Seating",
      "name": "Cafe Seating",
      "title": "Мебель кафе",
      "photo": "/hp/catalog/tree/ff60555a0270.webp",
      "anyTags": [],
      "allTags": [
       "CafeSeating"
      ]
     },
     {
      "id": "Seating furniture/CommercialSeating/Waiting Room Chairs",
      "name": "Waiting Room Chairs",
      "title": "Стулья для зала ожидания",
      "photo": "/hp/catalog/tree/510f602a9349.webp",
      "anyTags": [],
      "allTags": [
       "ReceptionChair"
      ],
      "filters": [
       {
        "id": "1 Chair",
        "title": "1-местные",
        "anyTags": [],
        "allTags": [
         "ReceptionChair1"
        ]
       },
       {
        "id": "2 Chairs",
        "title": "2-местные",
        "anyTags": [],
        "allTags": [
         "ReceptionChair2"
        ]
       },
       {
        "id": "3 Chairs",
        "title": "3-местные",
        "anyTags": [],
        "allTags": [
         "ReceptionChair3"
        ]
       },
       {
        "id": "3+ Chairs",
        "title": "3+ мест",
        "anyTags": [],
        "allTags": [
         "ReceptionChair3plus"
        ]
       }
      ]
     },
     {
      "id": "Seating furniture/CommercialSeating/Beauty chairs",
      "name": "Beauty chairs",
      "title": "Beauty chairs",
      "photo": "/hp/catalog/tree/1917e26594b8.webp",
      "anyTags": [],
      "allTags": [
       "BeautySalon",
       "Armchair"
      ]
     },
     {
      "id": "Seating furniture/CommercialSeating/Tribune",
      "name": "Tribune",
      "title": "Трибуна",
      "photo": "/hp/catalog/tree/4f4c4ccc2101.webp",
      "anyTags": [],
      "allTags": [
       "Tribune"
      ]
     },
     {
      "id": "Seating furniture/CommercialSeating/Theater Chairs",
      "name": "Theater Chairs",
      "title": "Театральные стулья",
      "photo": "/hp/catalog/tree/ccb0ea8e3255.webp",
      "anyTags": [],
      "allTags": [
       "TheaterChair"
      ],
      "filters": [
       {
        "id": "1-seat",
        "title": "1-местные",
        "anyTags": [],
        "allTags": [
         "TheaterChair1"
        ]
       },
       {
        "id": "2-seat",
        "title": "2-местные",
        "anyTags": [],
        "allTags": [
         "TheaterChair2"
        ]
       },
       {
        "id": "3-seat",
        "title": "3-местные",
        "anyTags": [],
        "allTags": [
         "TheaterChair3"
        ]
       },
       {
        "id": "3+ seats",
        "title": "3+ мест",
        "anyTags": [],
        "allTags": [
         "TheaterChair3plus"
        ]
       }
      ]
     }
    ]
   },
   {
    "id": "Seating furniture/Rocking chair",
    "name": "Rocking chair",
    "title": "Кресло-качалка",
    "photo": "/hp/catalog/tree/853a2fab254d.webp",
    "anyTags": [],
    "allTags": [
     "RockingChair"
    ]
   },
   {
    "id": "Seating furniture/Hammock",
    "name": "Hammock",
    "title": "Гамак",
    "photo": "/hp/catalog/tree/509d72af2e7b.webp",
    "anyTags": [],
    "allTags": [
     "Hammock"
    ],
    "filters": [
     {
      "id": "Hanging Hammock",
      "title": "Подвесной гамак",
      "anyTags": [],
      "allTags": [
       "HangingHammock"
      ]
     },
     {
      "id": "Ceiling Hammock",
      "title": "Потолочный гамак",
      "anyTags": [],
      "allTags": [
       "CeilingHammock"
      ]
     },
     {
      "id": "Standing Hammock",
      "title": "Напольный гамак",
      "anyTags": [],
      "allTags": [
       "StandingHammock"
      ]
     }
    ]
   },
   {
    "id": "Seating furniture/Outdoor Bench",
    "name": "Outdoor Bench",
    "title": "Уличная скамейка",
    "photo": "/hp/catalog/tree/28a3eac9970d.webp",
    "anyTags": [],
    "allTags": [
     "OutdoorBench"
    ],
    "filters": [
     {
      "id": "Outdoor Bench Backless",
      "title": "Скамейка без спинки",
      "anyTags": [],
      "allTags": [
       "OutdoorBenchBackless"
      ]
     },
     {
      "id": "Backrest Outdoor Bench",
      "title": "Скамейка со спинкой",
      "anyTags": [],
      "allTags": [
       "OutdoorBenchBackrest"
      ]
     },
     {
      "id": "Concrete Outdoor Bench",
      "title": "Бетонная скамейка",
      "anyTags": [],
      "allTags": [
       "OutdoorBenchConcrete"
      ]
     },
     {
      "id": "Planter Outdoor Bench",
      "title": "Скамейка с цветником",
      "anyTags": [],
      "allTags": [
       "OutdoorBenchPlanter"
      ]
     },
     {
      "id": "Wooden Outdoor Bench",
      "title": "Деревянная скамейка",
      "anyTags": [],
      "allTags": [
       "OutdoorBenchWooden"
      ]
     },
     {
      "id": "Metal Outdoor Bench",
      "title": "Металлическая скамейка",
      "anyTags": [],
      "allTags": [
       "OutdoorBenchMetal"
      ]
     },
     {
      "id": "Upholstered Outdoor Bench",
      "title": "Скамейка с обивкой",
      "anyTags": [],
      "allTags": [
       "OutdoorBenchUpholstered"
      ]
     },
     {
      "id": "Abstract Outdoor Bench",
      "title": "Абстрактная скамейка",
      "anyTags": [],
      "allTags": [
       "OutdoorBenchAbstract"
      ]
     },
     {
      "id": "Public Outdoor Bench",
      "title": "Общественная скамейка",
      "anyTags": [],
      "allTags": [
       "OutdoorBenchPublic"
      ]
     },
     {
      "id": "Garden Outdoor Bench",
      "title": "Садовая скамейка",
      "anyTags": [],
      "allTags": [
       "OutdoorBenchGarden"
      ]
     }
    ]
   },
   {
    "id": "Seating furniture/Sunbed",
    "name": "Sunbed",
    "title": "Шезлонг",
    "photo": "/hp/catalog/tree/464b4959f635.webp",
    "anyTags": [],
    "allTags": [
     "Sunbed"
    ],
    "filters": [
     {
      "id": "Single Sunbed",
      "title": "Одноместный шезлонг",
      "anyTags": [],
      "allTags": [
       "SingleSunbed"
      ]
     },
     {
      "id": "Double Sunbed",
      "title": "Двухместный шезлонг",
      "anyTags": [],
      "allTags": [
       "DoubleSunbed"
      ]
     },
     {
      "id": "Upholstered Sunbed",
      "title": "Мягкий шезлонг",
      "anyTags": [],
      "allTags": [
       "UpholsteredSunbed"
      ]
     },
     {
      "id": "Wooden Sunbed",
      "title": "Деревянный шезлонг",
      "anyTags": [],
      "allTags": [
       "WoodenSunbed"
      ]
     },
     {
      "id": "Plastic Sunbed",
      "title": "Пластиковый шезлонг",
      "anyTags": [],
      "allTags": [
       "PlasticSunbed"
      ]
     },
     {
      "id": "Metal Sunbed",
      "title": "Металлический шезлонг",
      "anyTags": [],
      "allTags": [
       "MetalSunbed"
      ]
     },
     {
      "id": "Rattan Sunbed",
      "title": "Ротанговый шезлонг",
      "anyTags": [],
      "allTags": [
       "RattanSunbed"
      ]
     },
     {
      "id": "Adjustable Backrest",
      "title": "Регулируемая спинка",
      "anyTags": [],
      "allTags": [
       "AdjustableBackrestSunbed"
      ]
     }
    ]
   },
   {
    "id": "Seating furniture/Swings",
    "name": "Swings",
    "title": "Качели",
    "photo": "/hp/catalog/tree/7afa1e504e7d.webp",
    "anyTags": [],
    "allTags": [
     "Swings"
    ],
    "filters": [
     {
      "id": "Standing Swings",
      "title": "Напольные качели",
      "anyTags": [],
      "allTags": [
       "StandSwings"
      ]
     },
     {
      "id": "Swing Chair",
      "title": "Кресло-качели",
      "anyTags": [],
      "allTags": [
       "SwingChair"
      ]
     },
     {
      "id": "Hanging Chair",
      "title": "Подвесное кресло",
      "anyTags": [],
      "allTags": [
       "HangingChair"
      ]
     },
     {
      "id": "Hanging Swings",
      "title": "Подвесные качели",
      "anyTags": [],
      "allTags": [
       "HangingSwings"
      ]
     }
    ]
   }
  ]
 },
 {
  "id": "kitchens",
  "name": "kitchens",
  "title": "Кухня",
  "photo": "/hp/catalog/tree/21b8702e727a.webp",
  "children": [
   {
    "id": "kitchens/Kitchen collections",
    "name": "Kitchen collections",
    "title": "Кухонные коллекции",
    "photo": "/hp/catalog/tree/21b8702e727a.webp",
    "children": [
     {
      "id": "kitchens/Kitchen collections/Kitchen sets",
      "name": "Kitchen sets",
      "title": "Кухонные наборы",
      "photo": "/hp/catalog/tree/21b8702e727a.webp",
      "anyTags": [],
      "allTags": [
       "KitchenSet"
      ],
      "filters": [
       {
        "id": "Base Only Kitchen",
        "title": "Только низ",
        "anyTags": [],
        "allTags": [
         "KitchenSetBase"
        ]
       },
       {
        "id": "Straight Kitchen",
        "title": "Прямая кухня",
        "anyTags": [],
        "allTags": [
         "KitchenSetStraight"
        ]
       },
       {
        "id": "L-shaped kitchen",
        "title": "L-shaped kitchen",
        "anyTags": [],
        "allTags": [
         "KitchenSetL"
        ]
       },
       {
        "id": "U-shaped Kitchen",
        "title": "U-shaped Kitchen",
        "anyTags": [],
        "allTags": [
         "KitchenSetU"
        ]
       },
       {
        "id": "II-shaped Kitchen",
        "title": "II-shaped Kitchen",
        "anyTags": [],
        "allTags": [
         "KitchenSetII"
        ]
       },
       {
        "id": "Full Wall Kitchen",
        "title": "Кухня-стенка",
        "anyTags": [],
        "allTags": [
         "KitchenSetWall"
        ]
       }
      ]
     },
     {
      "id": "kitchens/Kitchen collections/Base Cabinets",
      "name": "Base Cabinets",
      "title": "Нижние шкафы",
      "photo": "/hp/catalog/tree/e559c69b4dc1.webp",
      "anyTags": [],
      "allTags": [
       "BaseCabinet"
      ]
     },
     {
      "id": "kitchens/Kitchen collections/Kitchen Island",
      "name": "Kitchen Island",
      "title": "Кухонный остров",
      "photo": "/hp/catalog/tree/59f07742ae68.webp",
      "anyTags": [],
      "allTags": [
       "KitchenIsland"
      ]
     },
     {
      "id": "kitchens/Kitchen collections/Wall Cabinets",
      "name": "Wall Cabinets",
      "title": "Настенные шкафы",
      "photo": "/hp/catalog/tree/7c2d8b91310d.webp",
      "anyTags": [],
      "allTags": [
       "WallCabinet"
      ]
     },
     {
      "id": "kitchens/Kitchen collections/Kitchen High Cabinets",
      "name": "Kitchen High Cabinets",
      "title": "Высокие шкафы",
      "photo": "/hp/catalog/tree/2b4c526cdc0e.webp",
      "anyTags": [],
      "allTags": [
       "HighCabinet"
      ]
     },
     {
      "id": "kitchens/Kitchen collections/Countertops",
      "name": "Countertops",
      "title": "Столешницы",
      "photo": "/hp/catalog/tree/1a68d5901bf5.webp",
      "anyTags": [],
      "allTags": [
       "Countertop"
      ]
     },
     {
      "id": "kitchens/Kitchen collections/Knoxhult",
      "name": "Knoxhult",
      "title": "Knoxhult",
      "photo": "/hp/catalog/tree/89682f3b4d88.webp",
      "anyTags": [],
      "allTags": [
       "BrandIkea",
       "CollectionKnoxhult"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "kitchens/Kitchen collections/Axstad",
      "name": "Axstad",
      "title": "Axstad",
      "photo": "/hp/catalog/tree/5ebad79d6f42.webp",
      "anyTags": [],
      "allTags": [
       "BrandIkea",
       "CollectionAxstad"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "kitchens/Kitchen collections/Traditional kitchen",
      "name": "Traditional kitchen",
      "title": "Традиционная кухня",
      "photo": "/hp/catalog/tree/599289afdd33.webp",
      "anyTags": [],
      "allTags": [
       "TradKitchen"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "kitchens/Kitchen collections/Enhet",
      "name": "Enhet",
      "title": "Enhet",
      "photo": "/hp/catalog/tree/6471512e333f.webp",
      "anyTags": [],
      "allTags": [
       "BrandIkea",
       "CollectionEnhet"
      ],
      "sort": "PriceHigh"
     },
     {
      "id": "kitchens/Kitchen collections/Hittarp",
      "name": "Hittarp",
      "title": "Hittarp",
      "photo": "/hp/catalog/tree/0dff1388d6d9.webp",
      "anyTags": [],
      "allTags": [
       "BrandIkea",
       "CollectionHittarp"
      ],
      "sort": "PriceHigh"
     }
    ]
   },
   {
    "id": "kitchens/Kitchenware",
    "name": "Kitchenware",
    "title": "Кухонная утварь",
    "photo": "/hp/catalog/tree/718172adbb8d.webp",
    "children": [
     {
      "id": "kitchens/Kitchenware/Kitchen decor",
      "name": "Kitchen decor",
      "title": "Кухонный декор",
      "photo": "/hp/catalog/tree/718172adbb8d.webp",
      "anyTags": [],
      "allTags": [
       "KitchenSurface"
      ]
     },
     {
      "id": "kitchens/Kitchenware/Jars and boxes",
      "name": "Jars and boxes",
      "title": "Баночки и коробки",
      "photo": "/hp/catalog/tree/52a894eafbe8.webp",
      "anyTags": [],
      "allTags": [
       "KitchenJars"
      ]
     },
     {
      "id": "kitchens/Kitchenware/Cups and glasses",
      "name": "Cups and glasses",
      "title": "Чашки и стаканы",
      "photo": "/hp/catalog/tree/5ab6c6ad728a.webp",
      "anyTags": [],
      "allTags": [
       "CupsMugs"
      ]
     },
     {
      "id": "kitchens/Kitchenware/Plates",
      "name": "Plates",
      "title": "Тарелки",
      "photo": "/hp/catalog/tree/8a1bcdd87d20.webp",
      "anyTags": [],
      "allTags": [
       "Plates"
      ]
     },
     {
      "id": "kitchens/Kitchenware/Railings and wall storage",
      "name": "Railings and wall storage",
      "title": "Настенное хранение",
      "photo": "/hp/catalog/tree/cdbe28228d99.webp",
      "anyTags": [],
      "allTags": [
       "KitchenWall"
      ]
     },
     {
      "id": "kitchens/Kitchenware/Ingredients",
      "name": "Ingredients",
      "title": "Ингредиенты",
      "photo": "/hp/catalog/tree/920b623e3a11.webp",
      "anyTags": [],
      "allTags": [
       "KitchenFood"
      ]
     },
     {
      "id": "kitchens/Kitchenware/Drinks",
      "name": "Drinks",
      "title": "Напитки",
      "photo": "/hp/catalog/tree/f65b4807b191.webp",
      "anyTags": [],
      "allTags": [
       "Drinks"
      ]
     },
     {
      "id": "kitchens/Kitchenware/Cutting boards",
      "name": "Cutting boards",
      "title": "Разделочные доски",
      "photo": "/hp/catalog/tree/17361f320c7a.webp",
      "anyTags": [],
      "allTags": [
       "CuttingBoard"
      ]
     },
     {
      "id": "kitchens/Kitchenware/Serving",
      "name": "Serving",
      "title": "Сервировка",
      "photo": "/hp/catalog/tree/98c946e48d12.webp",
      "anyTags": [],
      "allTags": [
       "DiningServing"
      ]
     },
     {
      "id": "kitchens/Kitchenware/Desserts",
      "name": "Desserts",
      "title": "Десерты",
      "photo": "/hp/catalog/tree/0cbf044cb75f.webp",
      "anyTags": [],
      "allTags": [
       "Desserts"
      ]
     },
     {
      "id": "kitchens/Kitchenware/Pans",
      "name": "Pans",
      "title": "Посуда для готовки",
      "photo": "/hp/catalog/tree/8cfe839ca825.webp",
      "anyTags": [],
      "allTags": [
       "Pans"
      ]
     }
    ]
   }
  ]
 },
 {
  "id": "AllBed",
  "name": "AllBed",
  "title": "Кровать",
  "photo": "/hp/catalog/tree/d057fe2060b1.webp",
  "children": [
   {
    "id": "AllBed/Bed",
    "name": "Bed",
    "title": "Кровать",
    "photo": "/hp/catalog/tree/d057fe2060b1.webp",
    "anyTags": [],
    "allTags": [
     "Bed"
    ],
    "filters": [
     {
      "id": "TwinBed",
      "title": "Односпальная|кровать",
      "anyTags": [],
      "allTags": [
       "Twin"
      ]
     },
     {
      "id": "FullBed",
      "title": "Full Bed",
      "anyTags": [],
      "allTags": [
       "FullSize"
      ]
     },
     {
      "id": "QueenBed",
      "title": "Queen Bed",
      "anyTags": [],
      "allTags": [
       "Queen"
      ]
     },
     {
      "id": "KingBed",
      "title": "King Bed",
      "anyTags": [],
      "allTags": [
       "King"
      ]
     },
     {
      "id": "SuperKingBed",
      "title": "Super King Bed",
      "anyTags": [],
      "allTags": [
       "SuperKing"
      ]
     },
     {
      "id": "2LevelsBed",
      "title": "Двухъярусная",
      "anyTags": [],
      "allTags": [
       "2LevelsBed"
      ]
     },
     {
      "id": "LoftBed",
      "title": "Loft Bed",
      "anyTags": [],
      "allTags": [
       "LoftBed"
      ]
     },
     {
      "id": "FourPosterBed",
      "title": "Four-poster Bed",
      "anyTags": [],
      "allTags": [
       "FourPoster"
      ]
     },
     {
      "id": "FoldingBed",
      "title": "Раскладная кровать",
      "anyTags": [],
      "allTags": [
       "FoldingBed"
      ]
     },
     {
      "id": "CornerBed",
      "title": "Угловая кровать",
      "anyTags": [],
      "allTags": [
       "CornerBed"
      ]
     },
     {
      "id": "RoundBed",
      "title": "Круглая кровать",
      "anyTags": [],
      "allTags": [
       "RoundBed"
      ]
     },
     {
      "id": "OttomanBed",
      "title": "Кровать с подъёмным механизмом",
      "anyTags": [],
      "allTags": [
       "OttomanBed"
      ]
     },
     {
      "id": "StorageBed",
      "title": "Кровать с ящиками",
      "anyTags": [],
      "allTags": [
       "StorageBed"
      ]
     },
     {
      "id": "ConvertibleBed",
      "title": "Кровать-трансформер",
      "anyTags": [],
      "allTags": [
       "ConvertibleBed"
      ]
     },
     {
      "id": "PlatformBed",
      "title": "Кровать-платформа",
      "anyTags": [],
      "allTags": [
       "PlatformBed"
      ]
     },
     {
      "id": "NoHeadboardBed",
      "title": "Кровать без изголовья",
      "anyTags": [],
      "allTags": [
       "NoHeadboardBed"
      ]
     },
     {
      "id": "LeggedBed",
      "title": "Кровать на ножках",
      "anyTags": [],
      "allTags": [
       "LeggedBed"
      ]
     },
     {
      "id": "BedFrames",
      "title": "Каркасы кроватей",
      "anyTags": [],
      "allTags": [
       "BedFrame"
      ]
     },
     {
      "id": "Daybed",
      "title": "Кровать-лежак",
      "anyTags": [],
      "allTags": [
       "Daybed"
      ]
     },
     {
      "id": "WallHeadboardBed",
      "title": "Wall headboard bed",
      "anyTags": [],
      "allTags": [
       "WallHeadboardBed"
      ]
     }
    ]
   },
   {
    "id": "AllBed/Nightstand",
    "name": "Nightstand",
    "title": "Прикроватная тумба",
    "photo": "/hp/catalog/tree/8826df2d537b.webp",
    "anyTags": [],
    "allTags": [
     "Nightstand"
    ],
    "filters": [
     {
      "id": "Nightstand with Door",
      "title": "Тумба с дверцей",
      "anyTags": [],
      "allTags": [
       "DoorNightstand"
      ]
     },
     {
      "id": "Nightstand with Drawers",
      "title": "Тумба с ящиками",
      "anyTags": [],
      "allTags": [
       "DrawerNightstand"
      ]
     },
     {
      "id": "1 Drawer Nightstand",
      "title": "Тумба с одним ящиком",
      "anyTags": [],
      "allTags": [
       "1DrawerNightstand"
      ]
     },
     {
      "id": "Nightstand with Shelves",
      "title": "Тумба с полками",
      "anyTags": [],
      "allTags": [
       "ShelveNightstand"
      ]
     },
     {
      "id": "Round Nightstand",
      "title": "Круглая тумба",
      "anyTags": [],
      "allTags": [
       "RoundNightstand"
      ]
     },
     {
      "id": "Corner Nightstand",
      "title": "Угловая тумба",
      "anyTags": [],
      "allTags": [
       "CornerNightstand"
      ]
     },
     {
      "id": "No legs Nightstand",
      "title": "Тумба без ножек",
      "anyTags": [],
      "allTags": [
       "NoLegsNightstand"
      ]
     },
     {
      "id": "Solid Nightstand",
      "title": "Цельная тумба",
      "anyTags": [],
      "allTags": [
       "SolidNightstand"
      ]
     },
     {
      "id": "Wall Nightstand",
      "title": "Настенная тумба",
      "anyTags": [],
      "allTags": [
       "WallNightstand"
      ]
     }
    ]
   },
   {
    "id": "AllBed/Dressing table",
    "name": "Dressing table",
    "title": "Туалетный столик",
    "photo": "/hp/catalog/tree/2e2d967dd3f9.webp",
    "anyTags": [],
    "allTags": [
     "DressingTable"
    ]
   },
   {
    "id": "AllBed/Bedding",
    "name": "Bedding",
    "title": "Постельное белье",
    "photo": "/hp/catalog/tree/9606eae00efc.webp",
    "anyTags": [],
    "allTags": [
     "Bedding"
    ],
    "filters": [
     {
      "id": "Twin bedding",
      "title": "Односпальное бельё",
      "anyTags": [],
      "allTags": [
       "TwinBedding"
      ]
     },
     {
      "id": "Queen bedding",
      "title": "Двуспальное бельё",
      "anyTags": [],
      "allTags": [
       "QueenBedding"
      ]
     },
     {
      "id": "King bedding",
      "title": "Трехспальное бельё",
      "anyTags": [],
      "allTags": [
       "KingBedding"
      ]
     },
     {
      "id": "Blankets,plaids",
      "title": "Blankets,plaids",
      "anyTags": [],
      "allTags": [
       "Blanket"
      ]
     },
     {
      "id": "Mattress",
      "title": "Матрас",
      "anyTags": [],
      "allTags": [
       "Mattress"
      ]
     },
     {
      "id": "Baby bedding",
      "title": "Детское бельё",
      "anyTags": [],
      "allTags": [
       "BabyBedding"
      ]
     }
    ]
   },
   {
    "id": "AllBed/KidBed",
    "name": "KidBed",
    "title": "Детская кровать",
    "photo": "/hp/catalog/tree/938f61a3fddc.webp",
    "anyTags": [],
    "allTags": [
     "JuniorBed"
    ],
    "filters": [
     {
      "id": "TwinBed",
      "title": "Односпальная|кровать",
      "anyTags": [],
      "allTags": [
       "Twin"
      ]
     },
     {
      "id": "DoubleBed",
      "title": "Двуспальная кровать",
      "anyTags": [
       "King",
       "Queen",
       "DoubleBed"
      ],
      "allTags": []
     },
     {
      "id": "StorageBed",
      "title": "Кровать с ящиками",
      "anyTags": [],
      "allTags": [
       "StorageBed"
      ]
     },
     {
      "id": "Car Bed",
      "title": "Car Bed",
      "anyTags": [],
      "allTags": [
       "CarBed"
      ]
     },
     {
      "id": "2 kids Bed",
      "title": "2 kids Bed",
      "anyTags": [],
      "allTags": [
       "2KidsBed"
      ]
     },
     {
      "id": "Multitask Bed Zone",
      "title": "Multitask Bed Zone",
      "anyTags": [],
      "allTags": [
       "BedZone"
      ]
     },
     {
      "id": "House Bed",
      "title": "House Bed",
      "anyTags": [],
      "allTags": [
       "HouseBed"
      ]
     }
    ]
   },
   {
    "id": "AllBed/Pillow",
    "name": "Pillow",
    "title": "Подушка",
    "photo": "/hp/catalog/tree/96e5894bd735.webp",
    "anyTags": [],
    "allTags": [
     "Pillow"
    ],
    "filters": [
     {
      "id": "Square pillow",
      "title": "Квадратная подушка",
      "anyTags": [],
      "allTags": [
       "SquarePillow"
      ]
     },
     {
      "id": "Round pillow",
      "title": "Круглая подушка",
      "anyTags": [],
      "allTags": [
       "RoundPillow"
      ]
     },
     {
      "id": "Rectangle pillow",
      "title": "Прямоугольная подушка",
      "anyTags": [],
      "allTags": [
       "RectanglePillow"
      ]
     },
     {
      "id": "Abstract pillow",
      "title": "Абстрактная подушка",
      "anyTags": [],
      "allTags": [
       "AbstractPillow"
      ]
     },
     {
      "id": "Pillow set",
      "title": "Набор подушек",
      "anyTags": [],
      "allTags": [
       "PillowSet"
      ]
     },
     {
      "id": "Sleep pillow",
      "title": "Подушка для сна",
      "anyTags": [],
      "allTags": [
       "SleepPillow"
      ]
     },
     {
      "id": "Roll pillow",
      "title": "Подушка-валик",
      "anyTags": [],
      "allTags": [
       "RollPillow"
      ]
     },
     {
      "id": "Orthopedic pillow",
      "title": "Ортопедическая подушка",
      "anyTags": [],
      "allTags": [
       "OrthopedicPillow"
      ]
     },
     {
      "id": "Knot pillow",
      "title": "Подушка-узел",
      "anyTags": [],
      "allTags": [
       "KnotPillow"
      ]
     },
     {
      "id": "Seat pillow",
      "title": "Подушка-сидушка",
      "anyTags": [],
      "allTags": [
       "SeatPillow"
      ]
     }
    ]
   },
   {
    "id": "AllBed/Bed End Bench",
    "name": "Bed End Bench",
    "title": "Скамья",
    "photo": "/hp/catalog/tree/98112577a759.webp",
    "anyTags": [
     "Bench",
     "StorageBench",
     "WoodenBench",
     "UpholsteredBench",
     "OvalBench",
     "ArmrestBench",
     "BackBench",
     "ShelveBench"
    ],
    "allTags": [],
    "filters": [
     {
      "id": "Storage Bench",
      "title": "Скамья с ящиком",
      "anyTags": [],
      "allTags": [
       "StorageBench"
      ]
     },
     {
      "id": "Wooden Bench",
      "title": "Деревянная скамья",
      "anyTags": [],
      "allTags": [
       "WoodenBench"
      ]
     },
     {
      "id": "Upholstered Bench",
      "title": "Мягкая скамья",
      "anyTags": [],
      "allTags": [
       "UpholsteredBench"
      ]
     },
     {
      "id": "Oval Bench",
      "title": "Овальная скамья",
      "anyTags": [],
      "allTags": [
       "OvalBench"
      ]
     },
     {
      "id": "Bench with Armrests",
      "title": "Скамья с подлокотниками",
      "anyTags": [],
      "allTags": [
       "ArmrestBench"
      ]
     },
     {
      "id": "Bench with Back",
      "title": "Скамья со спинкой",
      "anyTags": [],
      "allTags": [
       "BackBench"
      ]
     },
     {
      "id": "Bench with Shelve",
      "title": "Скамья с полкой",
      "anyTags": [],
      "allTags": [
       "ShelveBench"
      ]
     }
    ]
   },
   {
    "id": "AllBed/Headboard",
    "name": "Headboard",
    "title": "Изголовье",
    "photo": "/hp/catalog/tree/d2cfd3c40831.webp",
    "anyTags": [],
    "allTags": [
     "Headboard"
    ],
    "filters": [
     {
      "id": "Upholstered headboard",
      "title": "Мягкое изголовье",
      "anyTags": [],
      "allTags": [
       "UpholsteredHeadboard"
      ]
     },
     {
      "id": "Wooden headboard",
      "title": "Деревянное изголовье",
      "anyTags": [],
      "allTags": [
       "WoodenHeadboard"
      ]
     },
     {
      "id": "Rattan headboard",
      "title": "Ротанговое изголовье",
      "anyTags": [],
      "allTags": [
       "RattanHeadboard"
      ]
     },
     {
      "id": "Storage headboard",
      "title": "Изголовье с ящиками",
      "anyTags": [],
      "allTags": [
       "StorageHeadboard"
      ]
     },
     {
      "id": "Lighted headboard",
      "title": "Изголовье со светом",
      "anyTags": [],
      "allTags": [
       "LightedHeadboard"
      ]
     },
     {
      "id": "Legged headboard",
      "title": "Изголовье на ножках",
      "anyTags": [],
      "allTags": [
       "LeggedHeadboard"
      ]
     },
     {
      "id": "Solid headboard",
      "title": "Сплошное изголовье",
      "anyTags": [],
      "allTags": [
       "SolidHeadboard"
      ]
     }
    ]
   },
   {
    "id": "AllBed/Crib",
    "name": "Crib",
    "title": "Кроватка",
    "photo": "/hp/catalog/tree/9c8e04247383.webp",
    "anyTags": [],
    "allTags": [
     "Crib"
    ],
    "filters": [
     {
      "id": "Standard crib",
      "title": "Стандартная кроватка",
      "anyTags": [],
      "allTags": [
       "StandardCrib"
      ]
     },
     {
      "id": "Convertible crib",
      "title": "Кроватка-трансформер",
      "anyTags": [],
      "allTags": [
       "ConvertibleCrib"
      ]
     },
     {
      "id": "Rattan crib",
      "title": "Ротанговая кроватка",
      "anyTags": [],
      "allTags": [
       "RattanCrib"
      ]
     },
     {
      "id": "Mesh crib",
      "title": "Сетчатая кроватка",
      "anyTags": [],
      "allTags": [
       "MeshCrib"
      ]
     },
     {
      "id": "Cradle",
      "title": "Колыбель",
      "anyTags": [],
      "allTags": [
       "Cradle"
      ]
     },
     {
      "id": "Storage crib",
      "title": "Кроватка с хранением",
      "anyTags": [],
      "allTags": [
       "StorageCrib"
      ]
     },
     {
      "id": "Oval crib",
      "title": "Овальная кроватка",
      "anyTags": [],
      "allTags": [
       "OvalCrib"
      ]
     },
     {
      "id": "Crib decor",
      "title": "Декор кроватки",
      "anyTags": [],
      "allTags": [
       "CribDecor"
      ]
     }
    ]
   },
   {
    "id": "AllBed/Bed Canopy",
    "name": "Bed Canopy",
    "title": "Балдахин",
    "photo": "/hp/catalog/tree/999748afc76d.webp",
    "anyTags": [],
    "allTags": [
     "BedCanopy"
    ]
   }
  ]
 },
 {
  "id": "Lighting",
  "name": "Lighting",
  "title": "Освещение",
  "photo": "/hp/catalog/tree/d5fe92503272.webp",
  "children": [
   {
    "id": "Lighting/Ceiling Lighting",
    "name": "Ceiling Lighting",
    "title": "Потолочное освещение",
    "photo": "/hp/catalog/tree/d5fe92503272.webp",
    "anyTags": [],
    "allTags": [
     "CeilingLamp"
    ],
    "filters": [
     {
      "id": "Chandelier",
      "title": "Люстра",
      "anyTags": [],
      "allTags": [
       "ChandelierLamp"
      ]
     },
     {
      "id": "Pendant Lamps",
      "title": "Подвесные светильники",
      "anyTags": [],
      "allTags": [
       "PendantLamp"
      ]
     },
     {
      "id": "Track Lights",
      "title": "Трековые светильники",
      "anyTags": [],
      "allTags": [
       "TrackLight"
      ]
     },
     {
      "id": "Flush Mount Lights",
      "title": "Светильники скрытого монтажа",
      "anyTags": [],
      "allTags": [
       "FlushMountLights"
      ]
     },
     {
      "id": "Semi Flush Mount Lights",
      "title": "Светильники полускрытого монтажа",
      "anyTags": [],
      "allTags": [
       "SemiFlushMountLights"
      ]
     },
     {
      "id": "Direct and Spot Lights",
      "title": "Прямой и точечный свет",
      "anyTags": [],
      "allTags": [
       "SpotLights"
      ]
     },
     {
      "id": "Telescopic Lamps",
      "title": "Телескопические лампы",
      "anyTags": [],
      "allTags": [
       "TelescopicLamp"
      ]
     },
     {
      "id": "Kitchen Island Lighting",
      "title": "Освещение кухонного острова",
      "anyTags": [],
      "allTags": [
       "KitchenIslandLights"
      ]
     },
     {
      "id": "Raindrop Lamps",
      "title": "Каскадные лампы",
      "anyTags": [],
      "allTags": [
       "RainLamp"
      ]
     },
     {
      "id": "Classic Lamps",
      "title": "Классические лампы",
      "anyTags": [],
      "allTags": [
       "CeilingLamp",
       "StyleClassic"
      ]
     },
     {
      "id": "LED Lighting",
      "title": "LED освещение",
      "anyTags": [],
      "allTags": [
       "CeilingLED"
      ]
     }
    ]
   },
   {
    "id": "Lighting/LightingOutletsSwitches",
    "name": "LightingOutletsSwitches",
    "title": "Розетки, выключатели",
    "photo": "/hp/catalog/tree/303c59bbc2b2.webp",
    "anyTags": [],
    "allTags": [
     "WiringDevices"
    ],
    "filters": [
     {
      "id": "Switches",
      "title": "Выключатели",
      "anyTags": [],
      "allTags": [
       "WallSwitch"
      ]
     },
     {
      "id": "Outlets",
      "title": "Розетки",
      "anyTags": [],
      "allTags": [
       "WallOutlet"
      ]
     },
     {
      "id": "SwitchesOutlets",
      "title": "Комбинация",
      "anyTags": [],
      "allTags": [
       "SwitchCombo"
      ]
     }
    ]
   },
   {
    "id": "Lighting/Table Lamp",
    "name": "Table Lamp",
    "title": "Лампа",
    "photo": "/hp/catalog/tree/3373737679cd.webp",
    "anyTags": [],
    "allTags": [
     "TableLamp"
    ],
    "filters": [
     {
      "id": "Desk Lamp",
      "title": "Настольная лампа",
      "anyTags": [],
      "allTags": [
       "DeskLamp"
      ]
     },
     {
      "id": "Bedside Lamp",
      "title": "Прикроватная лампа",
      "anyTags": [],
      "allTags": [
       "BedsideLamp"
      ]
     },
     {
      "id": "Arched Lamp",
      "title": "Арочный торшер",
      "anyTags": [],
      "allTags": [
       "ArchedLamp"
      ]
     },
     {
      "id": "Accent Lamp",
      "title": "Акцентная лампа",
      "anyTags": [],
      "allTags": [
       "AccentLamp"
      ]
     },
     {
      "id": "Buffet Lamp",
      "title": "Буфетная лампа",
      "anyTags": [],
      "allTags": [
       "BuffetLamp"
      ]
     }
    ]
   },
   {
    "id": "Lighting/Floor Lamp",
    "name": "Floor Lamp",
    "title": "Торшер",
    "photo": "/hp/catalog/tree/4ac5edba3246.webp",
    "anyTags": [],
    "allTags": [
     "FloorLamp"
    ],
    "filters": [
     {
      "id": "Arc Floor Lamp",
      "title": "Arc Floor Lamp",
      "anyTags": [],
      "allTags": [
       "ArcFloorLamp"
      ]
     },
     {
      "id": "Console Floor Lamp",
      "title": "Console Floor Lamp",
      "anyTags": [],
      "allTags": [
       "ConsoleFloorLamp"
      ]
     },
     {
      "id": "Torchiere Floor Lamp",
      "title": "Torchiere Floor Lamp",
      "anyTags": [],
      "allTags": [
       "TorchiereFloorLamp"
      ]
     },
     {
      "id": "Multiple Floor Lamp",
      "title": "Multiple Floor Lamp",
      "anyTags": [],
      "allTags": [
       "MultipleFloorLamp"
      ]
     },
     {
      "id": "StudioLight",
      "title": "StudioLight",
      "anyTags": [],
      "allTags": [
       "StudioLight"
      ]
     }
    ]
   },
   {
    "id": "Lighting/Wall Sconce",
    "name": "Wall Sconce",
    "title": "Бра",
    "photo": "/hp/catalog/tree/52a81e38ac2a.webp",
    "anyTags": [],
    "allTags": [
     "WallSconces"
    ],
    "filters": [
     {
      "id": "Armed Lamp",
      "title": "Armed Lamp",
      "anyTags": [],
      "allTags": [
       "ArmedWallLamp"
      ]
     },
     {
      "id": "Swing Arm Lamp",
      "title": "Swing Arm Lamp",
      "anyTags": [],
      "allTags": [
       "SwingArmWallLamp"
      ]
     },
     {
      "id": "Flush-mount Lamp",
      "title": "Flush-mount Lamp",
      "anyTags": [],
      "allTags": [
       "FlushMountWallLamp"
      ]
     },
     {
      "id": "Candle Lamp",
      "title": "Candle Lamp",
      "anyTags": [],
      "allTags": [
       "CandleWallLamp"
      ]
     },
     {
      "id": "Recessed Step Lamp",
      "title": "Recessed Step Lamp",
      "anyTags": [],
      "allTags": [
       "RecessedWallLamp"
      ]
     },
     {
      "id": "Wallchiere",
      "title": "Настенный торшер",
      "anyTags": [],
      "allTags": [
       "Wallchiere"
      ]
     },
     {
      "id": "Spotlight Lamp",
      "title": "Spotlight Lamp",
      "anyTags": [],
      "allTags": [
       "SpotlightWallLamp"
      ]
     },
     {
      "id": "Barn Lamp",
      "title": "Barn Lamp",
      "anyTags": [],
      "allTags": [
       "BarnWallLamp"
      ]
     },
     {
      "id": "Half Moon Lamp",
      "title": "Half Moon Lamp",
      "anyTags": [],
      "allTags": [
       "HalfMoonWallLamp"
      ]
     },
     {
      "id": "Under Cabinet Light",
      "title": "Under Cabinet Light",
      "anyTags": [],
      "allTags": [
       "UnderCabinetLight"
      ]
     },
     {
      "id": "Vanity Lamp",
      "title": "Vanity Lamp",
      "anyTags": [],
      "allTags": [
       "VanityWallLamp"
      ]
     },
     {
      "id": "Picture Lamp",
      "title": "Picture Lamp",
      "anyTags": [],
      "allTags": [
       "PictureWallLamp"
      ]
     },
     {
      "id": "Track Lamp",
      "title": "Track Lamp",
      "anyTags": [],
      "allTags": [
       "TrackWallLamp"
      ]
     },
     {
      "id": "Neon Lamp",
      "title": "Neon Lamp",
      "anyTags": [],
      "allTags": [
       "NeonWallLamp"
      ]
     },
     {
      "id": "Corner Wall Lamp",
      "title": "Corner Wall Lamp",
      "anyTags": [],
      "allTags": [
       "CornerWallLamp"
      ]
     },
     {
      "id": "Saber Wall Light",
      "title": "Бра-меч",
      "anyTags": [],
      "allTags": [
       "SaberWallLamp"
      ]
     },
     {
      "id": "Double Wall Lamp",
      "title": "Двойное бра",
      "anyTags": [],
      "allTags": [
       "DoubleWallLamp"
      ]
     },
     {
      "id": "Multi Wall Lamp",
      "title": "Бра на несколько ламп",
      "anyTags": [],
      "allTags": [
       "MultiWallLamp"
      ]
     },
     {
      "id": "Accent Wall Lamp",
      "title": "Акцентное бра",
      "anyTags": [],
      "allTags": [
       "AccentWallLamp"
      ]
     },
     {
      "id": "Wired Wall Lamp",
      "title": "Бра на проводах",
      "anyTags": [],
      "allTags": [
       "WiredWallLamp"
      ]
     }
    ]
   },
   {
    "id": "Lighting/Technical Lighting",
    "name": "Technical Lighting",
    "title": "Техническое освещение",
    "photo": "/hp/catalog/tree/7d6bf02a1eaf.webp",
    "anyTags": [],
    "allTags": [
     "TechLight"
    ]
   },
   {
    "id": "Lighting/LED backlight",
    "name": "LED backlight",
    "title": "Светодиодная подсветка",
    "photo": "/hp/catalog/tree/4822a77fd180.webp",
    "anyTags": [],
    "allTags": [
     "LEDlight"
    ]
   },
   {
    "id": "Lighting/Light Garland",
    "name": "Light Garland",
    "title": "Световая гирлянда",
    "photo": "/hp/catalog/tree/e8df59798afa.webp",
    "anyTags": [],
    "allTags": [
     "LightGarland"
    ]
   },
   {
    "id": "Lighting/Ceiling fan",
    "name": "Ceiling fan",
    "title": "Потолочный вентилятор",
    "photo": "/hp/catalog/tree/d47213ab3176.webp",
    "anyTags": [],
    "allTags": [
     "CeilingFan"
    ]
   },
   {
    "id": "Lighting/Kid Lamp",
    "name": "Kid Lamp",
    "title": "Детский светильник",
    "photo": "/hp/catalog/tree/253838e7ae39.webp",
    "anyTags": [],
    "allTags": [
     "KidLamp"
    ]
   },
   {
    "id": "Lighting/Outdoor Lighting",
    "name": "Outdoor Lighting",
    "title": "Наружное освещение",
    "photo": "/hp/catalog/tree/b51e281988ad.webp",
    "anyTags": [],
    "allTags": [
     "OutdoorLight"
    ],
    "filters": [
     {
      "id": "Roadway lights",
      "title": "Уличные фонари",
      "anyTags": [],
      "allTags": [
       "RoadwayLight"
      ]
     },
     {
      "id": "Ground lights",
      "title": "Наземные светильники",
      "anyTags": [],
      "allTags": [
       "GroundLight"
      ]
     },
     {
      "id": "Lantern",
      "title": "Фонарик",
      "anyTags": [],
      "allTags": [
       "Lantern"
      ]
     }
    ]
   }
  ]
 },
 {
  "id": "HobbyAndEntertainment",
  "name": "HobbyAndEntertainment",
  "title": "Хобби и развлечения",
  "photo": "/hp/catalog/tree/d766dfeb5d36.webp",
  "children": [
   {
    "id": "HobbyAndEntertainment/Sound equipment",
    "name": "Sound equipment",
    "title": "Музыка",
    "photo": "/hp/catalog/tree/d766dfeb5d36.webp",
    "anyTags": [],
    "allTags": [
     "Sound"
    ]
   },
   {
    "id": "HobbyAndEntertainment/Sport Equipment",
    "name": "Sport Equipment",
    "title": "Спорт",
    "photo": "/hp/catalog/tree/6470d8df579a.webp",
    "anyTags": [],
    "allTags": [
     "Gym"
    ]
   },
   {
    "id": "HobbyAndEntertainment/Musical instruments",
    "name": "Musical instruments",
    "title": "Музыкальные инструменты",
    "photo": "/hp/catalog/tree/63eb521efc3c.webp",
    "anyTags": [],
    "allTags": [
     "MusicInstrument"
    ],
    "sort": "PriceHigh",
    "filters": [
     {
      "id": "Keyboard instruments",
      "title": "Keyboard instruments",
      "anyTags": [],
      "allTags": [
       "Piano"
      ]
     },
     {
      "id": "String instruments",
      "title": "String instruments",
      "anyTags": [],
      "allTags": [
       "Guitar"
      ]
     },
     {
      "id": "Other instruments",
      "title": "Другие инструменты",
      "anyTags": [],
      "allTags": [
       "InstrumentOther"
      ]
     }
    ]
   },
   {
    "id": "HobbyAndEntertainment/Movies and games",
    "name": "Movies and games",
    "title": "Фильмы и игры",
    "photo": "/hp/catalog/tree/ff2c1098ba7c.webp",
    "anyTags": [
     "MoviesGaming",
     "TV"
    ],
    "allTags": [],
    "filters": [
     {
      "id": "Movies",
      "title": "Фильмы",
      "anyTags": [],
      "allTags": [
       "Movies"
      ]
     },
     {
      "id": "Gaming",
      "title": "Игры",
      "anyTags": [],
      "allTags": [
       "Gaming"
      ]
     }
    ]
   },
   {
    "id": "HobbyAndEntertainment/More Hobby",
    "name": "More Hobby",
    "title": "Больше хобби",
    "photo": "/hp/catalog/tree/1e8628ae8dd0.webp",
    "anyTags": [],
    "allTags": [
     "Hobby"
    ]
   },
   {
    "id": "HobbyAndEntertainment/Playground",
    "name": "Playground",
    "title": "Детская площадка",
    "photo": "/hp/catalog/tree/999de44f9886.webp",
    "anyTags": [],
    "allTags": [
     "Playground"
    ]
   },
   {
    "id": "HobbyAndEntertainment/Game table",
    "name": "Game table",
    "title": "Игровой стол",
    "photo": "/hp/catalog/tree/319d1522b8ed.webp",
    "anyTags": [],
    "allTags": [
     "GameTable"
    ]
   },
   {
    "id": "HobbyAndEntertainment/Art equipment",
    "name": "Art equipment",
    "title": "Арт-материалы",
    "photo": "/hp/catalog/tree/fa25ceab14b5.webp",
    "anyTags": [],
    "allTags": [
     "Art"
    ]
   },
   {
    "id": "HobbyAndEntertainment/Dance",
    "name": "Dance",
    "title": "Танцы",
    "photo": "/hp/catalog/tree/db67c1aaf608.webp",
    "anyTags": [],
    "allTags": [
     "Dance"
    ]
   },
   {
    "id": "HobbyAndEntertainment/Events",
    "name": "Events",
    "title": "События",
    "photo": "/hp/catalog/tree/21e9d106311c.webp",
    "anyTags": [],
    "allTags": [
     "Events"
    ],
    "filters": [
     {
      "id": "Stage",
      "title": "Сцена",
      "anyTags": [],
      "allTags": [
       "Stage"
      ]
     }
    ]
   },
   {
    "id": "HobbyAndEntertainment/Photo and video",
    "name": "Photo and video",
    "title": "Фото и видео",
    "photo": "/hp/catalog/tree/51ce1eb637e0.webp",
    "anyTags": [],
    "allTags": [
     "Photo"
    ]
   },
   {
    "id": "HobbyAndEntertainment/Workshop equipment",
    "name": "Workshop equipment",
    "title": "Оборудование мастерской",
    "photo": "/hp/catalog/tree/a37494ce1371.webp",
    "anyTags": [],
    "allTags": [
     "Workshop"
    ]
   },
   {
    "id": "HobbyAndEntertainment/Grill",
    "name": "Grill",
    "title": "Гриль",
    "photo": "/hp/catalog/tree/acd47fad556b.webp",
    "anyTags": [],
    "allTags": [
     "Grill"
    ]
   },
   {
    "id": "HobbyAndEntertainment/Sewing",
    "name": "Sewing",
    "title": "Шитье",
    "photo": "/hp/catalog/tree/2042ee51949d.webp",
    "anyTags": [],
    "allTags": [
     "Sewing"
    ]
   },
   {
    "id": "HobbyAndEntertainment/Garden tools",
    "name": "Garden tools",
    "title": "Садовые инструменты",
    "photo": "/hp/catalog/tree/4527a0ca190a.webp",
    "anyTags": [],
    "allTags": [
     "GardenTools"
    ]
   }
  ]
 },
 {
  "id": "Special",
  "name": "Special",
  "title": "Ещё",
  "photo": "/hp/catalog/tree/37e31aaf4e5a.webp",
  "children": [
   {
    "id": "Special/Categories",
    "name": "Categories",
    "title": "Категории",
    "photo": "/hp/catalog/tree/bca1c1ff51be.webp",
    "children": [
     {
      "id": "Special/Categories/Styles",
      "name": "Styles",
      "title": "Стили",
      "photo": "/hp/catalog/tree/bca1c1ff51be.webp",
      "children": [
       {
        "id": "Special/Categories/Styles/Classic",
        "name": "Classic",
        "title": "Классический",
        "photo": "/hp/catalog/tree/c23005adb21c.webp",
        "anyTags": [
         "StyleClassic",
         "CollectionIsala"
        ],
        "allTags": [],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Contemporary",
        "name": "Contemporary",
        "title": "Современный",
        "photo": "/hp/catalog/tree/e5eca40613de.webp",
        "anyTags": [
         "StyleContemporary",
         "CollectionPlatsa",
         "CollectionVallentuna",
         "CollectionKivik"
        ],
        "allTags": [],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Shabby Chic",
        "name": "Shabby Chic",
        "title": "Шебби шик",
        "photo": "/hp/catalog/tree/72f7e80272ff.webp",
        "anyTags": [],
        "allTags": [
         "StyleShabby"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Boho",
        "name": "Boho",
        "title": "Бохо",
        "photo": "/hp/catalog/tree/472f62b76576.webp",
        "anyTags": [],
        "allTags": [
         "StyleBoho"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Memphis",
        "name": "Memphis",
        "title": "Мемфис",
        "photo": "/hp/catalog/tree/b36ba23ba01a.webp",
        "anyTags": [],
        "allTags": [
         "StyleMemphis"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Scandinavian",
        "name": "Scandinavian",
        "title": "Скандинавский",
        "photo": "/hp/catalog/tree/37c2a5d90d64.webp",
        "anyTags": [
         "StyleScandi",
         "CollectionStockholm",
         "CollectionLack"
        ],
        "allTags": [],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Coastal,Beach",
        "name": "Coastal,Beach",
        "title": "Прибрежный, Пляжный",
        "photo": "/hp/catalog/tree/7550dff46874.webp",
        "anyTags": [],
        "allTags": [
         "StyleCoastal"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Victorian",
        "name": "Victorian",
        "title": "Викторианский",
        "photo": "/hp/catalog/tree/bb2ff15d7b88.webp",
        "anyTags": [],
        "allTags": [
         "StyleVictorian"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Industrial",
        "name": "Industrial",
        "title": "Лофт",
        "photo": "/hp/catalog/tree/7640ebc6bf32.webp",
        "anyTags": [
         "StyleLoft",
         "CollectionVittsjo"
        ],
        "allTags": [],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Rustic,Farmhouse",
        "name": "Rustic,Farmhouse",
        "title": "Рустикальный, Фермерский",
        "photo": "/hp/catalog/tree/68a3bbd97efa.webp",
        "anyTags": [
         "StyleRustic",
         "CollectionHemnes",
         "CollectionBilly",
         "CollectionLiatorp",
         "CollectionNorden",
         "CollectionStenstorp",
         "CollectionBrimnes"
        ],
        "allTags": [],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Transitional",
        "name": "Transitional",
        "title": "Переходный",
        "photo": "/hp/catalog/tree/3d84065bfbeb.webp",
        "anyTags": [],
        "allTags": [
         "StyleTransitional"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Wabi-sabi",
        "name": "Wabi-sabi",
        "title": "Ваби-саби",
        "photo": "/hp/catalog/tree/88259ad0e283.webp",
        "anyTags": [],
        "allTags": [
         "StyleWabisabi"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Neoclassic",
        "name": "Neoclassic",
        "title": "Неоклассический",
        "photo": "/hp/catalog/tree/ada11601f82b.webp",
        "anyTags": [
         "StyleNeoclassic",
         "CollectionIsala"
        ],
        "allTags": [],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Retro",
        "name": "Retro",
        "title": "Ретро",
        "photo": "/hp/catalog/tree/882f4097f3d4.webp",
        "anyTags": [],
        "allTags": [
         "StyleRetro"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/70s",
        "name": "70s",
        "title": "70-е",
        "photo": "/hp/catalog/tree/b65102f5804c.webp",
        "anyTags": [],
        "allTags": [
         "Style70s"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Mediterranean",
        "name": "Mediterranean",
        "title": "Средиземноморский",
        "photo": "/hp/catalog/tree/77687cac7566.webp",
        "anyTags": [],
        "allTags": [
         "StyleMediterranean"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Oriental, Asian",
        "name": "Oriental, Asian",
        "title": "Ориентальный, азиатский",
        "photo": "/hp/catalog/tree/62f120c1f95f.webp",
        "anyTags": [],
        "allTags": [
         "StyleOriental"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Craftsman",
        "name": "Craftsman",
        "title": "Ремесленный",
        "photo": "/hp/catalog/tree/0bf54a1e4e4a.webp",
        "anyTags": [],
        "allTags": [
         "StyleCraftsman"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Tropical",
        "name": "Tropical",
        "title": "Тропический",
        "photo": "/hp/catalog/tree/533f202373f1.webp",
        "anyTags": [],
        "allTags": [
         "StyleTropical"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Mid-century Modern",
        "name": "Mid-century Modern",
        "title": "Модерн 50-х годов",
        "photo": "/hp/catalog/tree/145c24b25785.webp",
        "anyTags": [
         "StyleModern",
         "CollectionKlippan"
        ],
        "allTags": [],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Eclectic",
        "name": "Eclectic",
        "title": "Эклектика",
        "photo": "/hp/catalog/tree/0ef078982bea.webp",
        "anyTags": [],
        "allTags": [
         "StyleEclectic"
        ],
        "sort": "PriceHigh"
       },
       {
        "id": "Special/Categories/Styles/Southwestern",
        "name": "Southwestern",
        "title": "Юго-западный",
        "photo": "/hp/catalog/tree/f4e25364fe3f.webp",
        "anyTags": [],
        "allTags": [
         "StyleSouthwestern"
        ],
        "sort": "PriceHigh"
       }
      ]
     },
     {
      "id": "Special/Categories/Collections",
      "name": "Collections",
      "title": "Темы",
      "photo": "/hp/catalog/tree/391b6a1057ee.webp",
      "children": [
       {
        "id": "Special/Categories/Collections/Thanksgiving",
        "name": "Thanksgiving",
        "title": "День благодарения",
        "photo": "/hp/catalog/tree/b684e1fead28.webp",
        "anyTags": [],
        "allTags": [
         "Thanksgiving"
        ]
       },
       {
        "id": "Special/Categories/Collections/Events",
        "name": "Events",
        "title": "События",
        "photo": "/hp/catalog/tree/c0fb9b1057cd.webp",
        "anyTags": [],
        "allTags": [
         "Events"
        ],
        "filters": [
         {
          "id": "Stage",
          "title": "Сцена",
          "anyTags": [],
          "allTags": [
           "Stage"
          ]
         }
        ]
       },
       {
        "id": "Special/Categories/Collections/Wedding",
        "name": "Wedding",
        "title": "Свадьба",
        "photo": "/hp/catalog/tree/504b334dd0dd.webp",
        "anyTags": [],
        "allTags": [
         "Wedding"
        ]
       },
       {
        "id": "Special/Categories/Collections/Christmas",
        "name": "Christmas",
        "title": "Рождество",
        "photo": "/hp/catalog/tree/a6789a6a7081.webp",
        "anyTags": [
         "Christmas",
         "XmasFireplace"
        ],
        "allTags": []
       },
       {
        "id": "Special/Categories/Collections/Halloween",
        "name": "Halloween",
        "title": "Хеллоуин",
        "photo": "/hp/catalog/tree/a9b7d7fc1f79.webp",
        "anyTags": [],
        "allTags": [
         "Halloween"
        ]
       },
       {
        "id": "Special/Categories/Collections/Beauty salon",
        "name": "Beauty salon",
        "title": "Салон красоты",
        "photo": "/hp/catalog/tree/27b739ddebd6.webp",
        "anyTags": [],
        "allTags": [
         "BeautySalon"
        ]
       },
       {
        "id": "Special/Categories/Collections/Barbie",
        "name": "Barbie",
        "title": "Барби",
        "photo": "/hp/catalog/tree/182aa589a26a.webp",
        "anyTags": [],
        "allTags": [
         "Barbie"
        ]
       },
       {
        "id": "Special/Categories/Collections/Tiny house",
        "name": "Tiny house",
        "title": "Мини-дом",
        "photo": "/hp/catalog/tree/8c0e4e7cf492.webp",
        "anyTags": [
         "TinyHouse",
         "FoldingBed",
         "StaircaseCabinet"
        ],
        "allTags": []
       },
       {
        "id": "Special/Categories/Collections/GoToSchool",
        "name": "GoToSchool",
        "title": "Снова в школу",
        "photo": "/hp/catalog/tree/b078776a30df.webp",
        "anyTags": [],
        "allTags": [
         "GoToSchool"
        ]
       },
       {
        "id": "Special/Categories/Collections/Cottagecore",
        "name": "Cottagecore",
        "title": "Коттеджкор",
        "photo": "/hp/catalog/tree/6134d151eb39.webp",
        "anyTags": [],
        "allTags": [
         "Cottagecore"
        ]
       },
       {
        "id": "Special/Categories/Collections/Smart Home",
        "name": "Smart Home",
        "title": "Умный дом",
        "photo": "/hp/catalog/tree/9f9be68768f8.webp",
        "anyTags": [],
        "allTags": [
         "SmartHome"
        ]
       },
       {
        "id": "Special/Categories/Collections/Hospital",
        "name": "Hospital",
        "title": "Больница",
        "photo": "/hp/catalog/tree/ec0014bed801.webp",
        "anyTags": [],
        "allTags": [
         "Hospital"
        ]
       },
       {
        "id": "Special/Categories/Collections/SummerFreshness",
        "name": "SummerFreshness",
        "title": "Летняя свежесть",
        "photo": "/hp/catalog/tree/8f84cd8867a6.webp",
        "anyTags": [],
        "allTags": [
         "SummerFreshness"
        ]
       },
       {
        "id": "Special/Categories/Collections/Underwater",
        "name": "Underwater",
        "title": "Подводный мир",
        "photo": "/hp/catalog/tree/16838632851e.webp",
        "anyTags": [],
        "allTags": [
         "Underwater"
        ]
       },
       {
        "id": "Special/Categories/Collections/Dark Academia",
        "name": "Dark Academia",
        "title": "Дарк академия",
        "photo": "/hp/catalog/tree/d979e9c45be2.webp",
        "anyTags": [],
        "allTags": [
         "DarkAcademia"
        ]
       },
       {
        "id": "Special/Categories/Collections/ValentinesDay",
        "name": "ValentinesDay",
        "title": "День святого Валентина",
        "photo": "/hp/catalog/tree/f910c7af5307.webp",
        "anyTags": [],
        "allTags": [
         "ValentinesDay"
        ]
       },
       {
        "id": "Special/Categories/Collections/Medieval castle",
        "name": "Medieval castle",
        "title": "Средневековый замок",
        "photo": "/hp/catalog/tree/1bc485b8a596.webp",
        "anyTags": [],
        "allTags": [
         "Medieval"
        ]
       },
       {
        "id": "Special/Categories/Collections/SpringBlossom",
        "name": "SpringBlossom",
        "title": "Весеннее цветение",
        "photo": "/hp/catalog/tree/6219721cce06.webp",
        "anyTags": [],
        "allTags": [
         "SpringBlossom"
        ]
       },
       {
        "id": "Special/Categories/Collections/Church",
        "name": "Church",
        "title": "Церковь",
        "photo": "/hp/catalog/tree/b84cac3c16ec.webp",
        "anyTags": [],
        "allTags": [
         "Church"
        ]
       },
       {
        "id": "Special/Categories/Collections/Ghost house",
        "name": "Ghost house",
        "title": "Дом с привидениями",
        "photo": "/hp/catalog/tree/26a7012add3b.webp",
        "anyTags": [],
        "allTags": [
         "GhostHouse"
        ]
       },
       {
        "id": "Special/Categories/Collections/EidMubarak",
        "name": "EidMubarak",
        "title": "Ид Мубарак",
        "photo": "/hp/catalog/tree/929697cff16f.webp",
        "anyTags": [],
        "allTags": [
         "EidMubarak"
        ]
       },
       {
        "id": "Special/Categories/Collections/Wild West",
        "name": "Wild West",
        "title": "Дикий Запад",
        "photo": "/hp/catalog/tree/b67eecb0b30a.webp",
        "anyTags": [],
        "allTags": [
         "WildWest"
        ]
       },
       {
        "id": "Special/Categories/Collections/Space Odyssey",
        "name": "Space Odyssey",
        "title": "Космическая одиссея",
        "photo": "/hp/catalog/tree/9ece49008ad3.webp",
        "anyTags": [],
        "allTags": [
         "SpaceOdyssey"
        ]
       },
       {
        "id": "Special/Categories/Collections/MardiGras",
        "name": "MardiGras",
        "title": "Марди Гра",
        "photo": "/hp/catalog/tree/0de0a2d3d8c0.webp",
        "anyTags": [],
        "allTags": [
         "MardiGras"
        ]
       },
       {
        "id": "Special/Categories/Collections/WinterWonderland",
        "name": "WinterWonderland",
        "title": "Зимняя сказка",
        "photo": "/hp/catalog/tree/ea85512d3091.webp",
        "anyTags": [],
        "allTags": [
         "WinterWonderland"
        ]
       },
       {
        "id": "Special/Categories/Collections/Pirates",
        "name": "Pirates",
        "title": "Пираты",
        "photo": "/hp/catalog/tree/a4ca7a1a45e2.webp",
        "anyTags": [],
        "allTags": [
         "Pirates"
        ]
       },
       {
        "id": "Special/Categories/Collections/StPatricksDay",
        "name": "StPatricksDay",
        "title": "День святого Патрика",
        "photo": "/hp/catalog/tree/7e1628f144e4.webp",
        "anyTags": [],
        "allTags": [
         "StPatricksDay"
        ]
       }
      ]
     },
     {
      "id": "Special/Categories/Brands",
      "name": "Brands",
      "title": "Бренды",
      "photo": "/hp/catalog/tree/474e5db74b19.webp",
      "children": [
       {
        "id": "Special/Categories/Brands/IKEA",
        "name": "IKEA",
        "title": "ИКЕА",
        "photo": "/hp/catalog/tree/7258ff1851a3.webp",
        "children": [
         {
          "id": "Special/Categories/Brands/IKEA/Knoxhult",
          "name": "Knoxhult",
          "title": "Knoxhult",
          "photo": "/hp/catalog/tree/d6c76fb1f4c1.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionKnoxhult"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Enhet",
          "name": "Enhet",
          "title": "Enhet",
          "photo": "/hp/catalog/tree/5d3c7c9975ba.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionEnhet"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Sektion",
          "name": "Sektion",
          "title": "Сектион",
          "photo": "/hp/catalog/tree/272ba9d28b74.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSektion"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/All IKEA",
          "name": "All IKEA",
          "title": "Вся ИКЕА",
          "photo": "/hp/catalog/tree/7258ff1851a3.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Hemnes",
          "name": "Hemnes",
          "title": "Хемнэс",
          "photo": "/hp/catalog/tree/20597aedb966.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionHemnes"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Pax",
          "name": "Pax",
          "title": "Пакс",
          "photo": "/hp/catalog/tree/1a75acd469ae.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionPax"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Billy",
          "name": "Billy",
          "title": "Билли",
          "photo": "/hp/catalog/tree/2aa80d2285c1.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionBilly"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Malm",
          "name": "Malm",
          "title": "Мальм",
          "photo": "/hp/catalog/tree/1f891c977ab5.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionMalm"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Kallax",
          "name": "Kallax",
          "title": "Каллакс",
          "photo": "/hp/catalog/tree/d5cd6b53f9bb.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionKallax"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Grönlid",
          "name": "Grönlid",
          "title": "Grönlid",
          "photo": "/hp/catalog/tree/265145515d6b.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionGrönlid"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Platsa",
          "name": "Platsa",
          "title": "Platsa",
          "photo": "/hp/catalog/tree/d38908dafef5.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionPlatsa"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Alex / Linnmon",
          "name": "Alex / Linnmon",
          "title": "Alex / Linnmon",
          "photo": "/hp/catalog/tree/3bd2a7a956d0.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionAlex"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Brimnes",
          "name": "Brimnes",
          "title": "Бримнэс",
          "photo": "/hp/catalog/tree/b252a97e477e.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionBrimnes"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Eket",
          "name": "Eket",
          "title": "Eket",
          "photo": "/hp/catalog/tree/9b1764d06ae0.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionEket"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Besta",
          "name": "Besta",
          "title": "Бесто",
          "photo": "/hp/catalog/tree/bbd01bab5a98.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionBesta"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Ektorp",
          "name": "Ektorp",
          "title": "Экторп",
          "photo": "/hp/catalog/tree/0f149d4103f3.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionEktorp"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Lidhult",
          "name": "Lidhult",
          "title": "Lidhult",
          "photo": "/hp/catalog/tree/afc0cd0ee90f.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionLidhult"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Mandal",
          "name": "Mandal",
          "title": "Мандал",
          "photo": "/hp/catalog/tree/557ea409b0cd.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionMandal"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Tyssedal",
          "name": "Tyssedal",
          "title": "Tyssedal",
          "photo": "/hp/catalog/tree/bd2f089d40ea.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionTyssedal"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Vimle",
          "name": "Vimle",
          "title": "Vimle",
          "photo": "/hp/catalog/tree/ecc80cedcbcb.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionVimle"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Liatorp",
          "name": "Liatorp",
          "title": "Лиаторп",
          "photo": "/hp/catalog/tree/7c4f8a7b44d8.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionLiatorp"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Kleppstad",
          "name": "Kleppstad",
          "title": "Kleppstad",
          "photo": "/hp/catalog/tree/182c41774981.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionKleppstad"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Bjorksta",
          "name": "Bjorksta",
          "title": "Bjorksta",
          "photo": "/hp/catalog/tree/f7d63211d6ea.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionBjorksta"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Lommarp",
          "name": "Lommarp",
          "title": "Lommarp",
          "photo": "/hp/catalog/tree/bdec7b6e9129.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionLommarp"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Lagan",
          "name": "Lagan",
          "title": "Lagan",
          "photo": "/hp/catalog/tree/61cb3ae2df2d.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionLagan"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Havsta",
          "name": "Havsta",
          "title": "Havsta",
          "photo": "/hp/catalog/tree/1458c0bbe92d.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionHavsta"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Karlstad",
          "name": "Karlstad",
          "title": "Карлстад",
          "photo": "/hp/catalog/tree/754e806f1d28.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionKarlstad"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Sundvik",
          "name": "Sundvik",
          "title": "Sundvik",
          "photo": "/hp/catalog/tree/c96beeca1295.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSundvik"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Backsälen",
          "name": "Backsälen",
          "title": "Backsälen",
          "photo": "/hp/catalog/tree/8fcd5cd254dd.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionBacksälen"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Bekant",
          "name": "Bekant",
          "title": "Bekant",
          "photo": "/hp/catalog/tree/ffdf581e29ff.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionBekant"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Gursken",
          "name": "Gursken",
          "title": "Gursken",
          "photo": "/hp/catalog/tree/9d66f99c31c8.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionGursken"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Elvarli",
          "name": "Elvarli",
          "title": "Elvarli",
          "photo": "/hp/catalog/tree/91ee46913c9f.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionElvarli"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Bjursta",
          "name": "Bjursta",
          "title": "Бьюрста",
          "photo": "/hp/catalog/tree/d834a39557fb.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionBjursta"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Kivik",
          "name": "Kivik",
          "title": "Кивик",
          "photo": "/hp/catalog/tree/588bcb0f3a17.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionKivik"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Rågrund",
          "name": "Rågrund",
          "title": "Rågrund",
          "photo": "/hp/catalog/tree/d46c51e0dc1c.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionRågrund"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Songesand",
          "name": "Songesand",
          "title": "Songesand",
          "photo": "/hp/catalog/tree/4c3a7fd514b7.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSongesand"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Finnala",
          "name": "Finnala",
          "title": "Finnala",
          "photo": "/hp/catalog/tree/cc15d575cbdd.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionVimle"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Friheten",
          "name": "Friheten",
          "title": "Friheten",
          "photo": "/hp/catalog/tree/3216be6d854f.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionFriheten"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Lack",
          "name": "Lack",
          "title": "Лакк",
          "photo": "/hp/catalog/tree/78a0892038fb.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionLack"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Lycksele",
          "name": "Lycksele",
          "title": "Lycksele",
          "photo": "/hp/catalog/tree/fb50295f3d1a.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionLycksele"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Ekedalen",
          "name": "Ekedalen",
          "title": "Ekedalen",
          "photo": "/hp/catalog/tree/f17eacb66697.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionEkedalen"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Nordli",
          "name": "Nordli",
          "title": "Нордли",
          "photo": "/hp/catalog/tree/e954f21e0f70.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionNordli"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Micke",
          "name": "Micke",
          "title": "Micke",
          "photo": "/hp/catalog/tree/fa061a710619.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionMicke"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Tullsta",
          "name": "Tullsta",
          "title": "Тульста",
          "photo": "/hp/catalog/tree/c1ef055c6eef.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionTullsta"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Satsumas",
          "name": "Satsumas",
          "title": "Satsumas",
          "photo": "/hp/catalog/tree/e7d078819766.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSatsumas"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Stockholm",
          "name": "Stockholm",
          "title": "Стокгольм",
          "photo": "/hp/catalog/tree/7a38e08a09a4.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionStockholm"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Äpplaryd",
          "name": "Äpplaryd",
          "title": "Äpplaryd",
          "photo": "/hp/catalog/tree/38d636aecb52.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionÄpplaryd"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Färlöv",
          "name": "Färlöv",
          "title": "Färlöv",
          "photo": "/hp/catalog/tree/04a650d80880.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionFärlöv"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Isala",
          "name": "Isala",
          "title": "Исала",
          "photo": "/hp/catalog/tree/450d27faac23.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionIsala"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Nikkeby",
          "name": "Nikkeby",
          "title": "Nikkeby",
          "photo": "/hp/catalog/tree/1f96c95f3845.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionNikkeby"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Släkt",
          "name": "Släkt",
          "title": "Släkt",
          "photo": "/hp/catalog/tree/4900299eb583.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSläkt"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Vihals",
          "name": "Vihals",
          "title": "Vihals",
          "photo": "/hp/catalog/tree/522554acb674.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionVihals"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Pjatteryd",
          "name": "Pjatteryd",
          "title": "Pjatteryd",
          "photo": "/hp/catalog/tree/1658822746a2.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionPjatteryd"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Arkelstorp",
          "name": "Arkelstorp",
          "title": "Arkelstorp",
          "photo": "/hp/catalog/tree/e31a970a6283.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionArkelstorp"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Smastad",
          "name": "Smastad",
          "title": "Smastad",
          "photo": "/hp/catalog/tree/48fed9c7c339.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSmastad"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Odda",
          "name": "Odda",
          "title": "Одда",
          "photo": "/hp/catalog/tree/1a3ba67435fd.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionOdda"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Hauga",
          "name": "Hauga",
          "title": "Hauga",
          "photo": "/hp/catalog/tree/65be56477441.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionHauga"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Härlanda",
          "name": "Härlanda",
          "title": "Härlanda",
          "photo": "/hp/catalog/tree/65d850c39dc4.webp",
          "anyTags": [
           "CollectionHärlanda",
           "CollectionGrönlid"
          ],
          "allTags": [
           "BrandIkea"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Regissör",
          "name": "Regissör",
          "title": "Regissör",
          "photo": "/hp/catalog/tree/f411b9d6c91e.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionRegissör"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Holmsund",
          "name": "Holmsund",
          "title": "Holmsund",
          "photo": "/hp/catalog/tree/dc7966fe5fd0.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionHolmsund"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Nordviken",
          "name": "Nordviken",
          "title": "Nordviken",
          "photo": "/hp/catalog/tree/49ae46b8ca77.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionNordviken"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Trofast",
          "name": "Trofast",
          "title": "Trofast",
          "photo": "/hp/catalog/tree/043afe57a43a.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionTrofast"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Fjällbo",
          "name": "Fjällbo",
          "title": "Fjällbo",
          "photo": "/hp/catalog/tree/c7b85e9be995.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionFjällbo"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Idanäs",
          "name": "Idanäs",
          "title": "Idanäs",
          "photo": "/hp/catalog/tree/aaea87d29192.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionIdanäs"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Långfjäll",
          "name": "Långfjäll",
          "title": "Långfjäll",
          "photo": "/hp/catalog/tree/aa117c950f27.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionLångfjäll"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Simrishamn",
          "name": "Simrishamn",
          "title": "Simrishamn",
          "photo": "/hp/catalog/tree/777a4bc33e99.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSimrishamn"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Tornviken",
          "name": "Tornviken",
          "title": "Tornviken",
          "photo": "/hp/catalog/tree/05d3a4461a46.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionTornviken"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Vadholma",
          "name": "Vadholma",
          "title": "Vadholma",
          "photo": "/hp/catalog/tree/dabbde33da46.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionVadholma"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Vallentuna",
          "name": "Vallentuna",
          "title": "Vallentuna",
          "photo": "/hp/catalog/tree/4381151046a4.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionVallentuna"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Trotten",
          "name": "Trotten",
          "title": "Trotten",
          "photo": "/hp/catalog/tree/96a573006c86.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionTrotten"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Valje",
          "name": "Valje",
          "title": "Вэлье",
          "photo": "/hp/catalog/tree/e802329f8dce.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionValje"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Nymåne",
          "name": "Nymåne",
          "title": "Nymåne",
          "photo": "/hp/catalog/tree/6f42cdc7864f.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionNymåne"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Varde",
          "name": "Varde",
          "title": "Вёрда",
          "photo": "/hp/catalog/tree/57dd0641a019.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionVarde"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Baggebo",
          "name": "Baggebo",
          "title": "Baggebo",
          "photo": "/hp/catalog/tree/37c21f0283ae.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionBaggebo"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Busunge",
          "name": "Busunge",
          "title": "Busunge",
          "photo": "/hp/catalog/tree/3fc44db87c05.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionBusunge"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Lixhult",
          "name": "Lixhult",
          "title": "Lixhult",
          "photo": "/hp/catalog/tree/9d196f716eff.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionLixhult"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Godmorgon",
          "name": "Godmorgon",
          "title": "Godmorgon",
          "photo": "/hp/catalog/tree/6585e9000bfd.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionGodmorgon"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Ivar",
          "name": "Ivar",
          "title": "Ivar",
          "photo": "/hp/catalog/tree/bdcd9e8e9bcb.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionIvar"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Stuva",
          "name": "Stuva",
          "title": "Stuva",
          "photo": "/hp/catalog/tree/faff1f069569.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionStuva"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Mammut",
          "name": "Mammut",
          "title": "Mammut",
          "photo": "/hp/catalog/tree/7f9ccad32fb6.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionMammut"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Pinnig",
          "name": "Pinnig",
          "title": "Pinnig",
          "photo": "/hp/catalog/tree/4c5d5f4196bd.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionPinnig"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Vinliden",
          "name": "Vinliden",
          "title": "Vinliden",
          "photo": "/hp/catalog/tree/139edaddcbd3.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionVinliden"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Morabo",
          "name": "Morabo",
          "title": "Morabo",
          "photo": "/hp/catalog/tree/eaf4d35f043b.webp",
          "anyTags": [
           "CollectionMorabo",
           "CollectionLandskrona"
          ],
          "allTags": [
           "BrandIkea"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Stocksund",
          "name": "Stocksund",
          "title": "Stocksund",
          "photo": "/hp/catalog/tree/b842031f42dc.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionStocksund"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Norden",
          "name": "Norden",
          "title": "Норден",
          "photo": "/hp/catalog/tree/3cc8163cefd4.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionNorden"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Nävlinge",
          "name": "Nävlinge",
          "title": "Nävlinge",
          "photo": "/hp/catalog/tree/3da204069202.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionNävlinge"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Pärup",
          "name": "Pärup",
          "title": "Pärup",
          "photo": "/hp/catalog/tree/81ddda2773ea.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionPärup"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Sniglar",
          "name": "Sniglar",
          "title": "Sniglar",
          "photo": "/hp/catalog/tree/a914ae075c57.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSniglar"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Stenstorp",
          "name": "Stenstorp",
          "title": "Stenstorp",
          "photo": "/hp/catalog/tree/1db444b24b11.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionStenstorp"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Söderhamn",
          "name": "Söderhamn",
          "title": "Söderhamn",
          "photo": "/hp/catalog/tree/cac71a2a1cbf.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSöderhamn"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Torparö",
          "name": "Torparö",
          "title": "Torparö",
          "photo": "/hp/catalog/tree/db487e541868.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionTorparö"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Klippan",
          "name": "Klippan",
          "title": "Клиппан",
          "photo": "/hp/catalog/tree/7570d9bea974.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionKlippan"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Råvaror",
          "name": "Råvaror",
          "title": "Råvaror",
          "photo": "/hp/catalog/tree/e0cea3febe27.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionRåvaror"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Mackapär",
          "name": "Mackapär",
          "title": "Mackapär",
          "photo": "/hp/catalog/tree/a9d601183353.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionMackapär"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Strandmon",
          "name": "Strandmon",
          "title": "Strandmon",
          "photo": "/hp/catalog/tree/ee07c433d964.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionStrandmon"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Ranarp",
          "name": "Ranarp",
          "title": "Ranarp",
          "photo": "/hp/catalog/tree/ea0c2e3db9b1.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionRanarp"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Skurup",
          "name": "Skurup",
          "title": "Skurup",
          "photo": "/hp/catalog/tree/aa9c99de6476.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSkurup"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Sollerön",
          "name": "Sollerön",
          "title": "Sollerön",
          "photo": "/hp/catalog/tree/155765db19fa.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSollerön"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Kvart",
          "name": "Kvart",
          "title": "Кварт",
          "photo": "/hp/catalog/tree/f1d21ce60cf4.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionKvart"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Rönnskär",
          "name": "Rönnskär",
          "title": "Rönnskär",
          "photo": "/hp/catalog/tree/4a73dcfbdae6.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionRönnskär"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Sandsberg",
          "name": "Sandsberg",
          "title": "Sandsberg",
          "photo": "/hp/catalog/tree/8d2f04abddcc.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSandsberg"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Ingatorp",
          "name": "Ingatorp",
          "title": "Ingatorp",
          "photo": "/hp/catalog/tree/baf3279ac614.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionIngatorp"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Nordkisa",
          "name": "Nordkisa",
          "title": "Nordkisa",
          "photo": "/hp/catalog/tree/1c2d08f74686.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionNordkisa"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Nyhamn",
          "name": "Nyhamn",
          "title": "Nyhamn",
          "photo": "/hp/catalog/tree/588dc56f89c7.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionNyhamn"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Bondholmen",
          "name": "Bondholmen",
          "title": "Bondholmen",
          "photo": "/hp/catalog/tree/ee92a1c84667.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionBondholmen"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Vittsjö",
          "name": "Vittsjö",
          "title": "Vittsjö",
          "photo": "/hp/catalog/tree/903f623130b7.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionVittsjö"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Hektar",
          "name": "Hektar",
          "title": "Hektar",
          "photo": "/hp/catalog/tree/a1b03045b244.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionHektar"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Ingolf",
          "name": "Ingolf",
          "title": "Ингольф",
          "photo": "/hp/catalog/tree/b8742de3da3b.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionIngolf"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Askholmen",
          "name": "Askholmen",
          "title": "Askholmen",
          "photo": "/hp/catalog/tree/8e0c4273ab7e.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionAskholmen"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Galant",
          "name": "Galant",
          "title": "Galant",
          "photo": "/hp/catalog/tree/a30991e257bd.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionGalant"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Havsten",
          "name": "Havsten",
          "title": "Havsten",
          "photo": "/hp/catalog/tree/56389e3d7fb4.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionHavsten"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Koarp",
          "name": "Koarp",
          "title": "Koarp",
          "photo": "/hp/catalog/tree/a0d719ef7312.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionKoarp"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Lisabo",
          "name": "Lisabo",
          "title": "Lisabo",
          "photo": "/hp/catalog/tree/08c790fa2f27.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionLisabo"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Lantliv",
          "name": "Lantliv",
          "title": "Lantliv",
          "photo": "/hp/catalog/tree/85f2df212075.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionLantliv"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Flottebo",
          "name": "Flottebo",
          "title": "Flottebo",
          "photo": "/hp/catalog/tree/0170e5984549.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionFlottebo"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Rönninge",
          "name": "Rönninge",
          "title": "Rönninge",
          "photo": "/hp/catalog/tree/df2d7bb6076f.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionRönninge"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Äpplarö",
          "name": "Äpplarö",
          "title": "Äpplarö",
          "photo": "/hp/catalog/tree/48d6e0b62006.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionÄpplarö"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Uppspel",
          "name": "Uppspel",
          "title": "Uppspel",
          "photo": "/hp/catalog/tree/f663eb14416d.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionUppspel"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Själland",
          "name": "Själland",
          "title": "Själland",
          "photo": "/hp/catalog/tree/09d5c0cbc2d2.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionSjälland"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Tjusig",
          "name": "Tjusig",
          "title": "Tjusig",
          "photo": "/hp/catalog/tree/0c6f6551fb6c.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionTjusig"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Läckö",
          "name": "Läckö",
          "title": "Läckö",
          "photo": "/hp/catalog/tree/41f593b23946.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionLäckö"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Bergmund",
          "name": "Bergmund",
          "title": "Bergmund",
          "photo": "/hp/catalog/tree/972e029199ef.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionBergmund"
          ],
          "sort": "PriceHigh"
         },
         {
          "id": "Special/Categories/Brands/IKEA/Jutholmen",
          "name": "Jutholmen",
          "title": "Jutholmen",
          "photo": "/hp/catalog/tree/07a1f7f3f796.webp",
          "anyTags": [],
          "allTags": [
           "BrandIkea",
           "CollectionJutholmen"
          ],
          "sort": "PriceHigh"
         }
        ]
       }
      ]
     },
     {
      "id": "Special/Categories/Sandbox",
      "name": "Sandbox",
      "title": "Архив",
      "photo": "/hp/catalog/tree/5a0fc4d4727b.webp",
      "anyTags": [
       "Sandbox",
       "MaterialSandbox"
      ],
      "allTags": []
     }
    ]
   },
   {
    "id": "Special/Annotations",
    "name": "Annotations",
    "title": "Аннотации",
    "photo": "/hp/catalog/tree/a36ae33013e3.webp",
    "anyTags": [],
    "allTags": [
     "Annotation"
    ]
   }
  ]
 }
]
